/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { createFileRoute } from '@tanstack/react-router'

import { Route as rootRouteImport } from './routes/__root'
import { Route as AuthenticatedRouteImport } from './routes/_authenticated'
import { Route as UnauthenticatedRouteImport } from './routes/_unauthenticated'
import { Route as ImpersonateRouteImport } from './routes/impersonate'
import { Route as UnsubscribeRouteImport } from './routes/unsubscribe'
import { Route as AuthenticatedIndexRouteImport } from './routes/_authenticated/index'
import { Route as AuthenticatedLayoutRouteImport } from './routes/_authenticated/_layout'
import { Route as AuthenticatedConsentRouteImport } from './routes/_authenticated/consent'
import { Route as AuthenticatedMcpAuthRouteImport } from './routes/_authenticated/mcp-auth'
import { Route as AuthenticatedMintlify_loginRouteImport } from './routes/_authenticated/mintlify_login'
import { Route as AuthenticatedOnboardingRouteImport } from './routes/_authenticated/onboarding'
import { Route as AuthenticatedReadme_loginRouteImport } from './routes/_authenticated/readme_login'
import { Route as UnauthenticatedLoginRouteImport } from './routes/_unauthenticated/login'
import { Route as ContactSalesEnterpriseRouteImport } from './routes/contact-sales.enterprise'
import { Route as NewsletterUnsubscribeRouteImport } from './routes/newsletter.unsubscribe'
import { Route as UnsubscribeIndexRouteImport } from './routes/unsubscribe.index'
import { Route as UnsubscribeFeedbackRouteImport } from './routes/unsubscribe.feedback'
import { Route as AuthenticatedLayoutSplatRouteImport } from './routes/_authenticated/_layout/$'
import { Route as AuthenticatedWorkspacesStartRouteImport } from './routes/_authenticated/workspaces/start'
import { Route as UnauthenticatedInvitation_confirmationIdRouteImport } from './routes/_unauthenticated/invitation_confirmation.$id'
import { Route as UnauthenticatedResetIndexRouteImport } from './routes/_unauthenticated/reset/index'
import { Route as UnauthenticatedResetIdRouteImport } from './routes/_unauthenticated/reset/$id'
import { Route as UnauthenticatedReset_confirmIndexRouteImport } from './routes/_unauthenticated/reset_confirm/index'
import { Route as UnauthenticatedSignupIndexRouteImport } from './routes/_unauthenticated/signup/index'
import { Route as UnauthenticatedSsoCallbackRouteImport } from './routes/_unauthenticated/sso.callback'
import { Route as SignupConfirmIndexRouteImport } from './routes/signup/confirm/index'
import { Route as SignupConfirmSignupIntentRouteImport } from './routes/signup/confirm/$signupIntent'
import { Route as AuthenticatedLayoutProfileNotificationsRouteImport } from './routes/_authenticated/_layout/profile/notifications'
import { Route as AuthenticatedLayoutProfileSettingsRouteImport } from './routes/_authenticated/_layout/profile/settings'
import { Route as AuthenticatedLayoutSettingsUsersRouteImport } from './routes/_authenticated/_layout/settings/users'
import { Route as AuthenticatedLayoutSettingsWorkspacesRouteImport } from './routes/_authenticated/_layout/settings/workspaces'
import { Route as AuthenticatedLayoutTemplatesSplatRouteImport } from './routes/_authenticated/_layout/templates/$'
import { Route as AuthenticatedLayoutWorkspacesSubscriptionIdRouteImport } from './routes/_authenticated/_layout/workspaces/$subscriptionId'
import { Route as AuthenticatedLayoutdeprecatedSubscriptionsSplatRouteImport } from './routes/_authenticated/_layout/(deprecated)/subscriptions.$'
import { Route as AuthenticatedLayoutSettingsBillingIndexRouteImport } from './routes/_authenticated/_layout/settings/billing/index'
import { Route as AuthenticatedLayoutSettingsBillingMigrateRouteImport } from './routes/_authenticated/_layout/settings/billing/migrate'
import { Route as AuthenticatedLayoutWorkspacesSubscriptionIdIndexRouteImport } from './routes/_authenticated/_layout/workspaces/$subscriptionId/index'
import { Route as AuthenticatedLayoutWorkspacesSubscriptionIdAlertsRouteImport } from './routes/_authenticated/_layout/workspaces/$subscriptionId/alerts'
import { Route as AuthenticatedLayoutWorkspacesSubscriptionIdAuditLogRouteImport } from './routes/_authenticated/_layout/workspaces/$subscriptionId/audit-log'
import { Route as AuthenticatedLayoutWorkspacesSubscriptionIdBillingRouteImport } from './routes/_authenticated/_layout/workspaces/$subscriptionId/billing'
import { Route as AuthenticatedLayoutWorkspacesSubscriptionIdBotDetectionRouteImport } from './routes/_authenticated/_layout/workspaces/$subscriptionId/bot-detection'
import { Route as AuthenticatedLayoutWorkspacesSubscriptionIdBotdRouteImport } from './routes/_authenticated/_layout/workspaces/$subscriptionId/botd'
import { Route as AuthenticatedLayoutWorkspacesSubscriptionIdEnvironmentsRouteImport } from './routes/_authenticated/_layout/workspaces/$subscriptionId/environments'
import { Route as AuthenticatedLayoutWorkspacesSubscriptionIdFraudAnalysisRouteImport } from './routes/_authenticated/_layout/workspaces/$subscriptionId/fraud-analysis'
import { Route as AuthenticatedLayoutWorkspacesSubscriptionIdGeneralRouteImport } from './routes/_authenticated/_layout/workspaces/$subscriptionId/general'
import { Route as AuthenticatedLayoutWorkspacesSubscriptionIdGetStartedRouteImport } from './routes/_authenticated/_layout/workspaces/$subscriptionId/get-started'
import { Route as AuthenticatedLayoutWorkspacesSubscriptionIdIntegrationsRouteImport } from './routes/_authenticated/_layout/workspaces/$subscriptionId/integrations'
import { Route as AuthenticatedLayoutWorkspacesSubscriptionIdMcpRouteImport } from './routes/_authenticated/_layout/workspaces/$subscriptionId/mcp'
import { Route as AuthenticatedLayoutWorkspacesSubscriptionIdOverviewRouteImport } from './routes/_authenticated/_layout/workspaces/$subscriptionId/overview'
import { Route as AuthenticatedLayoutWorkspacesSubscriptionIdPlansRouteImport } from './routes/_authenticated/_layout/workspaces/$subscriptionId/plans'
import { Route as AuthenticatedLayoutWorkspacesSubscriptionIdSmartSignalsRouteImport } from './routes/_authenticated/_layout/workspaces/$subscriptionId/smart-signals'
import { Route as AuthenticatedLayoutWorkspacesSubscriptionIdSubmitBotRouteImport } from './routes/_authenticated/_layout/workspaces/$subscriptionId/submit-bot'
import { Route as AuthenticatedLayoutWorkspacesSubscriptionIdSuspectScoreRouteImport } from './routes/_authenticated/_layout/workspaces/$subscriptionId/suspect-score'
import { Route as AuthenticatedLayoutWorkspacesSubscriptionIdTrafficRulesRouteImport } from './routes/_authenticated/_layout/workspaces/$subscriptionId/traffic-rules'
import { Route as AuthenticatedWorkspacesSubscriptionIdRulesetsRulesetIdRouteImport } from './routes/_authenticated/workspaces/$subscriptionId/rulesets/$rulesetId'
import { Route as AuthenticatedWorkspacesSubscriptionIdTemplatesSplatRouteImport } from './routes/_authenticated/workspaces/$subscriptionId/templates/$'
import { Route as AuthenticatedLayoutdeprecatedWorkspacesSubscriptionIdVisitsRouteImport } from './routes/_authenticated/_layout/(deprecated)/workspaces.$subscriptionId.visits'
import { Route as AuthenticatedLayoutWorkspacesSubscriptionIdApiKeysIndexRouteImport } from './routes/_authenticated/_layout/workspaces/$subscriptionId/api-keys/index'
import { Route as AuthenticatedLayoutWorkspacesSubscriptionIdBotDetectionIndexRouteImport } from './routes/_authenticated/_layout/workspaces/$subscriptionId/bot-detection/index'
import { Route as AuthenticatedLayoutWorkspacesSubscriptionIdEventsIndexRouteImport } from './routes/_authenticated/_layout/workspaces/$subscriptionId/events/index'
import { Route as AuthenticatedLayoutWorkspacesSubscriptionIdFraudAnalysisIndexRouteImport } from './routes/_authenticated/_layout/workspaces/$subscriptionId/fraud-analysis/index'
import { Route as AuthenticatedLayoutWorkspacesSubscriptionIdFraudAnalysisDatasetRouteImport } from './routes/_authenticated/_layout/workspaces/$subscriptionId/fraud-analysis/dataset'
import { Route as AuthenticatedLayoutWorkspacesSubscriptionIdFraudAnalysisUnlockRouteImport } from './routes/_authenticated/_layout/workspaces/$subscriptionId/fraud-analysis/unlock'
import { Route as AuthenticatedLayoutWorkspacesSubscriptionIdFraudAnalysisUpgradeRouteImport } from './routes/_authenticated/_layout/workspaces/$subscriptionId/fraud-analysis/upgrade'
import { Route as AuthenticatedLayoutWorkspacesSubscriptionIdFraudAnalysisUploadRouteImport } from './routes/_authenticated/_layout/workspaces/$subscriptionId/fraud-analysis/upload'
import { Route as AuthenticatedLayoutWorkspacesSubscriptionIdGetStartedIndexRouteImport } from './routes/_authenticated/_layout/workspaces/$subscriptionId/get-started/index'
import { Route as AuthenticatedLayoutWorkspacesSubscriptionIdGetStartedStepSlugRouteImport } from './routes/_authenticated/_layout/workspaces/$subscriptionId/get-started/$stepSlug'
import { Route as AuthenticatedLayoutWorkspacesSubscriptionIdHealthIndexRouteImport } from './routes/_authenticated/_layout/workspaces/$subscriptionId/health/index'
import { Route as AuthenticatedLayoutWorkspacesSubscriptionIdIntegrationsIndexRouteImport } from './routes/_authenticated/_layout/workspaces/$subscriptionId/integrations/index'
import { Route as AuthenticatedLayoutWorkspacesSubscriptionIdIntegrationsActiveRouteImport } from './routes/_authenticated/_layout/workspaces/$subscriptionId/integrations/active'
import { Route as AuthenticatedLayoutWorkspacesSubscriptionIdIntegrationsDirectoryRouteImport } from './routes/_authenticated/_layout/workspaces/$subscriptionId/integrations/directory'
import { Route as AuthenticatedLayoutWorkspacesSubscriptionIdPlanIndexRouteImport } from './routes/_authenticated/_layout/workspaces/$subscriptionId/plan/index'
import { Route as AuthenticatedLayoutWorkspacesSubscriptionIdPlanCheckoutReturnRouteImport } from './routes/_authenticated/_layout/workspaces/$subscriptionId/plan/checkout-return'
import { Route as AuthenticatedLayoutWorkspacesSubscriptionIdPlanUnpaidInvoicesRouteImport } from './routes/_authenticated/_layout/workspaces/$subscriptionId/plan/unpaid-invoices'
import { Route as AuthenticatedLayoutWorkspacesSubscriptionIdRulesetsIndexRouteImport } from './routes/_authenticated/_layout/workspaces/$subscriptionId/rulesets/index'
import { Route as AuthenticatedLayoutWorkspacesSubscriptionIdSubdomainsIndexRouteImport } from './routes/_authenticated/_layout/workspaces/$subscriptionId/subdomains/index'
import { Route as AuthenticatedLayoutWorkspacesSubscriptionIdSubdomainsCertificateIdRouteImport } from './routes/_authenticated/_layout/workspaces/$subscriptionId/subdomains/$certificateId'
import { Route as AuthenticatedLayoutWorkspacesSubscriptionIdSuspectScoreIndexRouteImport } from './routes/_authenticated/_layout/workspaces/$subscriptionId/suspect-score/index'
import { Route as AuthenticatedLayoutWorkspacesSubscriptionIdSuspectScoreAnalysisRouteImport } from './routes/_authenticated/_layout/workspaces/$subscriptionId/suspect-score/analysis'
import { Route as AuthenticatedLayoutWorkspacesSubscriptionIdVisitorsIndexRouteImport } from './routes/_authenticated/_layout/workspaces/$subscriptionId/visitors/index'
import { Route as AuthenticatedLayoutWorkspacesSubscriptionIdVisitorsVisitorIdRouteImport } from './routes/_authenticated/_layout/workspaces/$subscriptionId/visitors/$visitorId'
import { Route as AuthenticatedLayoutWorkspacesSubscriptionIdVisitorsAvatarsRouteImport } from './routes/_authenticated/_layout/workspaces/$subscriptionId/visitors/avatars'
import { Route as AuthenticatedLayoutWorkspacesSubscriptionIdWebhooksIndexRouteImport } from './routes/_authenticated/_layout/workspaces/$subscriptionId/webhooks/index'
import { Route as AuthenticatedWorkspacesSubscriptionIdPlanCancelIndexRouteImport } from './routes/_authenticated/workspaces/$subscriptionId/plan/cancel/index'
import { Route as AuthenticatedWorkspacesSubscriptionIdPlanCancelConfirmRouteImport } from './routes/_authenticated/workspaces/$subscriptionId/plan/cancel/confirm'
import { Route as AuthenticatedWorkspacesSubscriptionIdPlanDowngradeIndexRouteImport } from './routes/_authenticated/workspaces/$subscriptionId/plan/downgrade/index'
import { Route as AuthenticatedWorkspacesSubscriptionIdPlanDowngradeConfirmRouteImport } from './routes/_authenticated/workspaces/$subscriptionId/plan/downgrade/confirm'
import { Route as AuthenticatedWorkspacesSubscriptionIdRulesetsTemplatesTemplateSlugRouteImport } from './routes/_authenticated/workspaces/$subscriptionId/rulesets/templates/$templateSlug'
import { Route as AuthenticatedLayoutdeprecatedWorkspacesSubscriptionIdVisitsRequestIdRouteImport } from './routes/_authenticated/_layout/(deprecated)/workspaces.$subscriptionId.visits.$requestId'
import { Route as AuthenticatedLayoutWorkspacesSubscriptionIdApiKeysTokenIdIndexRouteImport } from './routes/_authenticated/_layout/workspaces/$subscriptionId/api-keys/$tokenId/index'
import { Route as AuthenticatedLayoutWorkspacesSubscriptionIdBotDetectionEventsIndexRouteImport } from './routes/_authenticated/_layout/workspaces/$subscriptionId/bot-detection/events/index'
import { Route as AuthenticatedLayoutWorkspacesSubscriptionIdBotDetectionEventsEventIdRouteImport } from './routes/_authenticated/_layout/workspaces/$subscriptionId/bot-detection/events/$eventId'
import { Route as AuthenticatedLayoutWorkspacesSubscriptionIdEventsRequestIdIndexRouteImport } from './routes/_authenticated/_layout/workspaces/$subscriptionId/events/$requestId/index'
import { Route as AuthenticatedLayoutWorkspacesSubscriptionIdEventsRequestIdVisitorHistoryRouteImport } from './routes/_authenticated/_layout/workspaces/$subscriptionId/events/$requestId/visitor-history'
import { Route as AuthenticatedLayoutWorkspacesSubscriptionIdFraudAnalysisDatasetIndexRouteImport } from './routes/_authenticated/_layout/workspaces/$subscriptionId/fraud-analysis/dataset/index'
import { Route as AuthenticatedLayoutWorkspacesSubscriptionIdFraudAnalysisDatasetEventsRouteImport } from './routes/_authenticated/_layout/workspaces/$subscriptionId/fraud-analysis/dataset/events'
import { Route as AuthenticatedLayoutWorkspacesSubscriptionIdFraudAnalysisModelsIndexRouteImport } from './routes/_authenticated/_layout/workspaces/$subscriptionId/fraud-analysis/models/index'
import { Route as AuthenticatedLayoutWorkspacesSubscriptionIdIntegrationsIntegrationTagIndexRouteImport } from './routes/_authenticated/_layout/workspaces/$subscriptionId/integrations/$integrationTag/index'
import { Route as AuthenticatedLayoutWorkspacesSubscriptionIdIntegrationsIntegrationTagEnvironmentIdRouteImport } from './routes/_authenticated/_layout/workspaces/$subscriptionId/integrations/$integrationTag/$environmentId'
import { Route as AuthenticatedLayoutWorkspacesSubscriptionIdIntegrationsIntegrationTagHealthRouteImport } from './routes/_authenticated/_layout/workspaces/$subscriptionId/integrations/$integrationTag/health'
import { Route as AuthenticatedLayoutWorkspacesSubscriptionIdIntegrationsCloudflareFlowIndexRouteImport } from './routes/_authenticated/_layout/workspaces/$subscriptionId/integrations/cloudflare-flow/index'
import { Route as AuthenticatedLayoutWorkspacesSubscriptionIdInvoicesInvoiceIdIndexRouteImport } from './routes/_authenticated/_layout/workspaces/$subscriptionId/invoices/$invoiceId/index'
import { Route as AuthenticatedLayoutWorkspacesSubscriptionIdInvoicesInvoiceIdForgivenessRequestRouteImport } from './routes/_authenticated/_layout/workspaces/$subscriptionId/invoices/$invoiceId/forgiveness-request'
import { Route as AuthenticatedLayoutWorkspacesSubscriptionIdVisitorsVisitorIdIndexRouteImport } from './routes/_authenticated/_layout/workspaces/$subscriptionId/visitors/$visitorId/index'
import { Route as AuthenticatedLayoutWorkspacesSubscriptionIdVisitorsVisitorIdEventsRouteImport } from './routes/_authenticated/_layout/workspaces/$subscriptionId/visitors/$visitorId/events'
import { Route as AuthenticatedLayoutWorkspacesSubscriptionIdVisitorsVisitorIdIpAddressesRouteImport } from './routes/_authenticated/_layout/workspaces/$subscriptionId/visitors/$visitorId/ip-addresses'
import { Route as AuthenticatedLayoutWorkspacesSubscriptionIdVisitorsVisitorIdLocationHistoryRouteImport } from './routes/_authenticated/_layout/workspaces/$subscriptionId/visitors/$visitorId/location-history'
import { Route as AuthenticatedLayoutWorkspacesSubscriptionIdVisitorsVisitorIdRelatedVisitorsRouteImport } from './routes/_authenticated/_layout/workspaces/$subscriptionId/visitors/$visitorId/related-visitors'
import { Route as AuthenticatedLayoutWorkspacesSubscriptionIdVisitorsVisitorIdSmartSignalsRouteImport } from './routes/_authenticated/_layout/workspaces/$subscriptionId/visitors/$visitorId/smart-signals'
import { Route as AuthenticatedLayoutWorkspacesSubscriptionIdWebhooksWebhookIdEventsRouteImport } from './routes/_authenticated/_layout/workspaces/$subscriptionId/webhooks/$webhookId.events'
import { Route as AuthenticatedLayoutWorkspacesSubscriptionIdWebhooksWebhookIdVerifyRouteImport } from './routes/_authenticated/_layout/workspaces/$subscriptionId/webhooks/$webhookId.verify'
import { Route as AuthenticatedLayoutWorkspacesSubscriptionIdFraudAnalysisModelsLabelSlugIndexRouteImport } from './routes/_authenticated/_layout/workspaces/$subscriptionId/fraud-analysis/models/$labelSlug/index'
import { Route as AuthenticatedLayoutWorkspacesSubscriptionIdFraudAnalysisModelsLabelSlugClientTypeRouteImport } from './routes/_authenticated/_layout/workspaces/$subscriptionId/fraud-analysis/models/$labelSlug/$clientType'
import { Route as AuthenticatedLayoutWorkspacesSubscriptionIdIntegrationsCloudflareFlowWorkersIndexRouteImport } from './routes/_authenticated/_layout/workspaces/$subscriptionId/integrations/cloudflare-flow/workers/index'
import { Route as AuthenticatedLayoutWorkspacesSubscriptionIdIntegrationsCloudflareFlowWorkersDeploymentIdRouteImport } from './routes/_authenticated/_layout/workspaces/$subscriptionId/integrations/cloudflare-flow/workers/$deploymentId'
import { Route as AuthenticatedLayoutWorkspacesSubscriptionIdFraudAnalysisModelsLabelSlugClientTypeIndexRouteImport } from './routes/_authenticated/_layout/workspaces/$subscriptionId/fraud-analysis/models/$labelSlug/$clientType/index'
import { Route as AuthenticatedLayoutWorkspacesSubscriptionIdFraudAnalysisModelsLabelSlugClientTypeModelVersionIdRouteImport } from './routes/_authenticated/_layout/workspaces/$subscriptionId/fraud-analysis/models/$labelSlug/$clientType/$modelVersionId'
import { Route as AuthenticatedLayoutWorkspacesSubscriptionIdFraudAnalysisModelsLabelSlugClientTypeOverviewRouteImport } from './routes/_authenticated/_layout/workspaces/$subscriptionId/fraud-analysis/models/$labelSlug/$clientType/overview'
import { Route as AuthenticatedLayoutWorkspacesSubscriptionIdFraudAnalysisModelsLabelSlugClientTypeVersionsRouteImport } from './routes/_authenticated/_layout/workspaces/$subscriptionId/fraud-analysis/models/$labelSlug/$clientType/versions'

const AuthenticatedWorkspacesSubscriptionIdRulesetsRulesetIdIndexLazyRouteImport =
  createFileRoute(
    '/_authenticated/workspaces/$subscriptionId/rulesets/$rulesetId/',
  )()

const AuthenticatedRoute = AuthenticatedRouteImport.update({
  id: '/_authenticated',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() =>
  import('./routes/_authenticated.lazy').then((d) => d.Route),
)
const UnauthenticatedRoute = UnauthenticatedRouteImport.update({
  id: '/_unauthenticated',
  getParentRoute: () => rootRouteImport,
} as any)
const ImpersonateRoute = ImpersonateRouteImport.update({
  id: '/impersonate',
  path: '/impersonate',
  getParentRoute: () => rootRouteImport,
} as any)
const UnsubscribeRoute = UnsubscribeRouteImport.update({
  id: '/unsubscribe',
  path: '/unsubscribe',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthenticatedIndexRoute = AuthenticatedIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedLayoutRoute = AuthenticatedLayoutRouteImport.update({
  id: '/_layout',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedConsentRoute = AuthenticatedConsentRouteImport.update({
  id: '/consent',
  path: '/consent',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedMcpAuthRoute = AuthenticatedMcpAuthRouteImport.update({
  id: '/mcp-auth',
  path: '/mcp-auth',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedMintlify_loginRoute =
  AuthenticatedMintlify_loginRouteImport.update({
    id: '/mintlify_login',
    path: '/mintlify_login',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedOnboardingRoute = AuthenticatedOnboardingRouteImport.update({
  id: '/onboarding',
  path: '/onboarding',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedReadme_loginRoute =
  AuthenticatedReadme_loginRouteImport.update({
    id: '/readme_login',
    path: '/readme_login',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const UnauthenticatedLoginRoute = UnauthenticatedLoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => UnauthenticatedRoute,
} as any)
const ContactSalesEnterpriseRoute = ContactSalesEnterpriseRouteImport.update({
  id: '/contact-sales/enterprise',
  path: '/contact-sales/enterprise',
  getParentRoute: () => rootRouteImport,
} as any)
const NewsletterUnsubscribeRoute = NewsletterUnsubscribeRouteImport.update({
  id: '/newsletter/unsubscribe',
  path: '/newsletter/unsubscribe',
  getParentRoute: () => rootRouteImport,
} as any)
const UnsubscribeIndexRoute = UnsubscribeIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => UnsubscribeRoute,
} as any)
const UnsubscribeFeedbackRoute = UnsubscribeFeedbackRouteImport.update({
  id: '/feedback',
  path: '/feedback',
  getParentRoute: () => UnsubscribeRoute,
} as any)
const AuthenticatedLayoutSplatRoute =
  AuthenticatedLayoutSplatRouteImport.update({
    id: '/$',
    path: '/$',
    getParentRoute: () => AuthenticatedLayoutRoute,
  } as any)
const AuthenticatedWorkspacesStartRoute =
  AuthenticatedWorkspacesStartRouteImport.update({
    id: '/workspaces/start',
    path: '/workspaces/start',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const UnauthenticatedInvitation_confirmationIdRoute =
  UnauthenticatedInvitation_confirmationIdRouteImport.update({
    id: '/invitation_confirmation/$id',
    path: '/invitation_confirmation/$id',
    getParentRoute: () => UnauthenticatedRoute,
  } as any)
const UnauthenticatedResetIndexRoute =
  UnauthenticatedResetIndexRouteImport.update({
    id: '/reset/',
    path: '/reset/',
    getParentRoute: () => UnauthenticatedRoute,
  } as any)
const UnauthenticatedResetIdRoute = UnauthenticatedResetIdRouteImport.update({
  id: '/reset/$id',
  path: '/reset/$id',
  getParentRoute: () => UnauthenticatedRoute,
} as any)
const UnauthenticatedReset_confirmIndexRoute =
  UnauthenticatedReset_confirmIndexRouteImport.update({
    id: '/reset_confirm/',
    path: '/reset_confirm/',
    getParentRoute: () => UnauthenticatedRoute,
  } as any)
const UnauthenticatedSignupIndexRoute =
  UnauthenticatedSignupIndexRouteImport.update({
    id: '/signup/',
    path: '/signup/',
    getParentRoute: () => UnauthenticatedRoute,
  } as any)
const UnauthenticatedSsoCallbackRoute =
  UnauthenticatedSsoCallbackRouteImport.update({
    id: '/sso/callback',
    path: '/sso/callback',
    getParentRoute: () => UnauthenticatedRoute,
  } as any)
const SignupConfirmIndexRoute = SignupConfirmIndexRouteImport.update({
  id: '/signup/confirm/',
  path: '/signup/confirm/',
  getParentRoute: () => rootRouteImport,
} as any)
const SignupConfirmSignupIntentRoute =
  SignupConfirmSignupIntentRouteImport.update({
    id: '/signup/confirm/$signupIntent',
    path: '/signup/confirm/$signupIntent',
    getParentRoute: () => rootRouteImport,
  } as any)
const AuthenticatedLayoutProfileNotificationsRoute =
  AuthenticatedLayoutProfileNotificationsRouteImport.update({
    id: '/profile/notifications',
    path: '/profile/notifications',
    getParentRoute: () => AuthenticatedLayoutRoute,
  } as any)
const AuthenticatedLayoutProfileSettingsRoute =
  AuthenticatedLayoutProfileSettingsRouteImport.update({
    id: '/profile/settings',
    path: '/profile/settings',
    getParentRoute: () => AuthenticatedLayoutRoute,
  } as any)
const AuthenticatedLayoutSettingsUsersRoute =
  AuthenticatedLayoutSettingsUsersRouteImport.update({
    id: '/settings/users',
    path: '/settings/users',
    getParentRoute: () => AuthenticatedLayoutRoute,
  } as any)
const AuthenticatedLayoutSettingsWorkspacesRoute =
  AuthenticatedLayoutSettingsWorkspacesRouteImport.update({
    id: '/settings/workspaces',
    path: '/settings/workspaces',
    getParentRoute: () => AuthenticatedLayoutRoute,
  } as any)
const AuthenticatedLayoutTemplatesSplatRoute =
  AuthenticatedLayoutTemplatesSplatRouteImport.update({
    id: '/templates/$',
    path: '/templates/$',
    getParentRoute: () => AuthenticatedLayoutRoute,
  } as any)
const AuthenticatedLayoutWorkspacesSubscriptionIdRoute =
  AuthenticatedLayoutWorkspacesSubscriptionIdRouteImport.update({
    id: '/workspaces/$subscriptionId',
    path: '/workspaces/$subscriptionId',
    getParentRoute: () => AuthenticatedLayoutRoute,
  } as any)
const AuthenticatedLayoutdeprecatedSubscriptionsSplatRoute =
  AuthenticatedLayoutdeprecatedSubscriptionsSplatRouteImport.update({
    id: '/(deprecated)/subscriptions/$',
    path: '/subscriptions/$',
    getParentRoute: () => AuthenticatedLayoutRoute,
  } as any)
const AuthenticatedLayoutSettingsBillingIndexRoute =
  AuthenticatedLayoutSettingsBillingIndexRouteImport.update({
    id: '/settings/billing/',
    path: '/settings/billing/',
    getParentRoute: () => AuthenticatedLayoutRoute,
  } as any)
const AuthenticatedLayoutSettingsBillingMigrateRoute =
  AuthenticatedLayoutSettingsBillingMigrateRouteImport.update({
    id: '/settings/billing/migrate',
    path: '/settings/billing/migrate',
    getParentRoute: () => AuthenticatedLayoutRoute,
  } as any)
const AuthenticatedLayoutWorkspacesSubscriptionIdIndexRoute =
  AuthenticatedLayoutWorkspacesSubscriptionIdIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedLayoutWorkspacesSubscriptionIdRoute,
  } as any)
const AuthenticatedLayoutWorkspacesSubscriptionIdAlertsRoute =
  AuthenticatedLayoutWorkspacesSubscriptionIdAlertsRouteImport.update({
    id: '/alerts',
    path: '/alerts',
    getParentRoute: () => AuthenticatedLayoutWorkspacesSubscriptionIdRoute,
  } as any)
const AuthenticatedLayoutWorkspacesSubscriptionIdAuditLogRoute =
  AuthenticatedLayoutWorkspacesSubscriptionIdAuditLogRouteImport.update({
    id: '/audit-log',
    path: '/audit-log',
    getParentRoute: () => AuthenticatedLayoutWorkspacesSubscriptionIdRoute,
  } as any)
const AuthenticatedLayoutWorkspacesSubscriptionIdBillingRoute =
  AuthenticatedLayoutWorkspacesSubscriptionIdBillingRouteImport.update({
    id: '/billing',
    path: '/billing',
    getParentRoute: () => AuthenticatedLayoutWorkspacesSubscriptionIdRoute,
  } as any)
const AuthenticatedLayoutWorkspacesSubscriptionIdBotDetectionRoute =
  AuthenticatedLayoutWorkspacesSubscriptionIdBotDetectionRouteImport.update({
    id: '/bot-detection',
    path: '/bot-detection',
    getParentRoute: () => AuthenticatedLayoutWorkspacesSubscriptionIdRoute,
  } as any)
const AuthenticatedLayoutWorkspacesSubscriptionIdBotdRoute =
  AuthenticatedLayoutWorkspacesSubscriptionIdBotdRouteImport.update({
    id: '/botd',
    path: '/botd',
    getParentRoute: () => AuthenticatedLayoutWorkspacesSubscriptionIdRoute,
  } as any)
const AuthenticatedLayoutWorkspacesSubscriptionIdEnvironmentsRoute =
  AuthenticatedLayoutWorkspacesSubscriptionIdEnvironmentsRouteImport.update({
    id: '/environments',
    path: '/environments',
    getParentRoute: () => AuthenticatedLayoutWorkspacesSubscriptionIdRoute,
  } as any)
const AuthenticatedLayoutWorkspacesSubscriptionIdFraudAnalysisRoute =
  AuthenticatedLayoutWorkspacesSubscriptionIdFraudAnalysisRouteImport.update({
    id: '/fraud-analysis',
    path: '/fraud-analysis',
    getParentRoute: () => AuthenticatedLayoutWorkspacesSubscriptionIdRoute,
  } as any)
const AuthenticatedLayoutWorkspacesSubscriptionIdGeneralRoute =
  AuthenticatedLayoutWorkspacesSubscriptionIdGeneralRouteImport.update({
    id: '/general',
    path: '/general',
    getParentRoute: () => AuthenticatedLayoutWorkspacesSubscriptionIdRoute,
  } as any)
const AuthenticatedLayoutWorkspacesSubscriptionIdGetStartedRoute =
  AuthenticatedLayoutWorkspacesSubscriptionIdGetStartedRouteImport.update({
    id: '/get-started',
    path: '/get-started',
    getParentRoute: () => AuthenticatedLayoutWorkspacesSubscriptionIdRoute,
  } as any)
const AuthenticatedLayoutWorkspacesSubscriptionIdIntegrationsRoute =
  AuthenticatedLayoutWorkspacesSubscriptionIdIntegrationsRouteImport.update({
    id: '/integrations',
    path: '/integrations',
    getParentRoute: () => AuthenticatedLayoutWorkspacesSubscriptionIdRoute,
  } as any)
const AuthenticatedLayoutWorkspacesSubscriptionIdMcpRoute =
  AuthenticatedLayoutWorkspacesSubscriptionIdMcpRouteImport.update({
    id: '/mcp',
    path: '/mcp',
    getParentRoute: () => AuthenticatedLayoutWorkspacesSubscriptionIdRoute,
  } as any)
const AuthenticatedLayoutWorkspacesSubscriptionIdOverviewRoute =
  AuthenticatedLayoutWorkspacesSubscriptionIdOverviewRouteImport.update({
    id: '/overview',
    path: '/overview',
    getParentRoute: () => AuthenticatedLayoutWorkspacesSubscriptionIdRoute,
  } as any)
const AuthenticatedLayoutWorkspacesSubscriptionIdPlansRoute =
  AuthenticatedLayoutWorkspacesSubscriptionIdPlansRouteImport.update({
    id: '/plans',
    path: '/plans',
    getParentRoute: () => AuthenticatedLayoutWorkspacesSubscriptionIdRoute,
  } as any)
const AuthenticatedLayoutWorkspacesSubscriptionIdSmartSignalsRoute =
  AuthenticatedLayoutWorkspacesSubscriptionIdSmartSignalsRouteImport.update({
    id: '/smart-signals',
    path: '/smart-signals',
    getParentRoute: () => AuthenticatedLayoutWorkspacesSubscriptionIdRoute,
  } as any)
const AuthenticatedLayoutWorkspacesSubscriptionIdSubmitBotRoute =
  AuthenticatedLayoutWorkspacesSubscriptionIdSubmitBotRouteImport.update({
    id: '/submit-bot',
    path: '/submit-bot',
    getParentRoute: () => AuthenticatedLayoutWorkspacesSubscriptionIdRoute,
  } as any)
const AuthenticatedLayoutWorkspacesSubscriptionIdSuspectScoreRoute =
  AuthenticatedLayoutWorkspacesSubscriptionIdSuspectScoreRouteImport.update({
    id: '/suspect-score',
    path: '/suspect-score',
    getParentRoute: () => AuthenticatedLayoutWorkspacesSubscriptionIdRoute,
  } as any)
const AuthenticatedLayoutWorkspacesSubscriptionIdTrafficRulesRoute =
  AuthenticatedLayoutWorkspacesSubscriptionIdTrafficRulesRouteImport.update({
    id: '/traffic-rules',
    path: '/traffic-rules',
    getParentRoute: () => AuthenticatedLayoutWorkspacesSubscriptionIdRoute,
  } as any)
const AuthenticatedWorkspacesSubscriptionIdRulesetsRulesetIdRoute =
  AuthenticatedWorkspacesSubscriptionIdRulesetsRulesetIdRouteImport.update({
    id: '/workspaces/$subscriptionId/rulesets/$rulesetId',
    path: '/workspaces/$subscriptionId/rulesets/$rulesetId',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedWorkspacesSubscriptionIdTemplatesSplatRoute =
  AuthenticatedWorkspacesSubscriptionIdTemplatesSplatRouteImport.update({
    id: '/workspaces/$subscriptionId/templates/$',
    path: '/workspaces/$subscriptionId/templates/$',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedLayoutdeprecatedWorkspacesSubscriptionIdVisitsRoute =
  AuthenticatedLayoutdeprecatedWorkspacesSubscriptionIdVisitsRouteImport.update(
    {
      id: '/(deprecated)/workspaces/$subscriptionId/visits',
      path: '/workspaces/$subscriptionId/visits',
      getParentRoute: () => AuthenticatedLayoutRoute,
    } as any,
  )
const AuthenticatedLayoutWorkspacesSubscriptionIdApiKeysIndexRoute =
  AuthenticatedLayoutWorkspacesSubscriptionIdApiKeysIndexRouteImport.update({
    id: '/api-keys/',
    path: '/api-keys/',
    getParentRoute: () => AuthenticatedLayoutWorkspacesSubscriptionIdRoute,
  } as any)
const AuthenticatedLayoutWorkspacesSubscriptionIdBotDetectionIndexRoute =
  AuthenticatedLayoutWorkspacesSubscriptionIdBotDetectionIndexRouteImport.update(
    {
      id: '/',
      path: '/',
      getParentRoute: () =>
        AuthenticatedLayoutWorkspacesSubscriptionIdBotDetectionRoute,
    } as any,
  )
const AuthenticatedLayoutWorkspacesSubscriptionIdEventsIndexRoute =
  AuthenticatedLayoutWorkspacesSubscriptionIdEventsIndexRouteImport.update({
    id: '/events/',
    path: '/events/',
    getParentRoute: () => AuthenticatedLayoutWorkspacesSubscriptionIdRoute,
  } as any)
const AuthenticatedLayoutWorkspacesSubscriptionIdFraudAnalysisIndexRoute =
  AuthenticatedLayoutWorkspacesSubscriptionIdFraudAnalysisIndexRouteImport.update(
    {
      id: '/',
      path: '/',
      getParentRoute: () =>
        AuthenticatedLayoutWorkspacesSubscriptionIdFraudAnalysisRoute,
    } as any,
  )
const AuthenticatedLayoutWorkspacesSubscriptionIdFraudAnalysisDatasetRoute =
  AuthenticatedLayoutWorkspacesSubscriptionIdFraudAnalysisDatasetRouteImport.update(
    {
      id: '/dataset',
      path: '/dataset',
      getParentRoute: () =>
        AuthenticatedLayoutWorkspacesSubscriptionIdFraudAnalysisRoute,
    } as any,
  )
const AuthenticatedLayoutWorkspacesSubscriptionIdFraudAnalysisUnlockRoute =
  AuthenticatedLayoutWorkspacesSubscriptionIdFraudAnalysisUnlockRouteImport.update(
    {
      id: '/unlock',
      path: '/unlock',
      getParentRoute: () =>
        AuthenticatedLayoutWorkspacesSubscriptionIdFraudAnalysisRoute,
    } as any,
  )
const AuthenticatedLayoutWorkspacesSubscriptionIdFraudAnalysisUpgradeRoute =
  AuthenticatedLayoutWorkspacesSubscriptionIdFraudAnalysisUpgradeRouteImport.update(
    {
      id: '/upgrade',
      path: '/upgrade',
      getParentRoute: () =>
        AuthenticatedLayoutWorkspacesSubscriptionIdFraudAnalysisRoute,
    } as any,
  )
const AuthenticatedLayoutWorkspacesSubscriptionIdFraudAnalysisUploadRoute =
  AuthenticatedLayoutWorkspacesSubscriptionIdFraudAnalysisUploadRouteImport.update(
    {
      id: '/upload',
      path: '/upload',
      getParentRoute: () =>
        AuthenticatedLayoutWorkspacesSubscriptionIdFraudAnalysisRoute,
    } as any,
  )
const AuthenticatedLayoutWorkspacesSubscriptionIdGetStartedIndexRoute =
  AuthenticatedLayoutWorkspacesSubscriptionIdGetStartedIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () =>
      AuthenticatedLayoutWorkspacesSubscriptionIdGetStartedRoute,
  } as any)
const AuthenticatedLayoutWorkspacesSubscriptionIdGetStartedStepSlugRoute =
  AuthenticatedLayoutWorkspacesSubscriptionIdGetStartedStepSlugRouteImport.update(
    {
      id: '/$stepSlug',
      path: '/$stepSlug',
      getParentRoute: () =>
        AuthenticatedLayoutWorkspacesSubscriptionIdGetStartedRoute,
    } as any,
  )
const AuthenticatedLayoutWorkspacesSubscriptionIdHealthIndexRoute =
  AuthenticatedLayoutWorkspacesSubscriptionIdHealthIndexRouteImport.update({
    id: '/health/',
    path: '/health/',
    getParentRoute: () => AuthenticatedLayoutWorkspacesSubscriptionIdRoute,
  } as any)
const AuthenticatedLayoutWorkspacesSubscriptionIdIntegrationsIndexRoute =
  AuthenticatedLayoutWorkspacesSubscriptionIdIntegrationsIndexRouteImport.update(
    {
      id: '/',
      path: '/',
      getParentRoute: () =>
        AuthenticatedLayoutWorkspacesSubscriptionIdIntegrationsRoute,
    } as any,
  )
const AuthenticatedLayoutWorkspacesSubscriptionIdIntegrationsActiveRoute =
  AuthenticatedLayoutWorkspacesSubscriptionIdIntegrationsActiveRouteImport.update(
    {
      id: '/active',
      path: '/active',
      getParentRoute: () =>
        AuthenticatedLayoutWorkspacesSubscriptionIdIntegrationsRoute,
    } as any,
  )
const AuthenticatedLayoutWorkspacesSubscriptionIdIntegrationsDirectoryRoute =
  AuthenticatedLayoutWorkspacesSubscriptionIdIntegrationsDirectoryRouteImport.update(
    {
      id: '/directory',
      path: '/directory',
      getParentRoute: () =>
        AuthenticatedLayoutWorkspacesSubscriptionIdIntegrationsRoute,
    } as any,
  )
const AuthenticatedLayoutWorkspacesSubscriptionIdPlanIndexRoute =
  AuthenticatedLayoutWorkspacesSubscriptionIdPlanIndexRouteImport.update({
    id: '/plan/',
    path: '/plan/',
    getParentRoute: () => AuthenticatedLayoutWorkspacesSubscriptionIdRoute,
  } as any)
const AuthenticatedLayoutWorkspacesSubscriptionIdPlanCheckoutReturnRoute =
  AuthenticatedLayoutWorkspacesSubscriptionIdPlanCheckoutReturnRouteImport.update(
    {
      id: '/plan/checkout-return',
      path: '/plan/checkout-return',
      getParentRoute: () => AuthenticatedLayoutWorkspacesSubscriptionIdRoute,
    } as any,
  )
const AuthenticatedLayoutWorkspacesSubscriptionIdPlanUnpaidInvoicesRoute =
  AuthenticatedLayoutWorkspacesSubscriptionIdPlanUnpaidInvoicesRouteImport.update(
    {
      id: '/plan/unpaid-invoices',
      path: '/plan/unpaid-invoices',
      getParentRoute: () => AuthenticatedLayoutWorkspacesSubscriptionIdRoute,
    } as any,
  )
const AuthenticatedLayoutWorkspacesSubscriptionIdRulesetsIndexRoute =
  AuthenticatedLayoutWorkspacesSubscriptionIdRulesetsIndexRouteImport.update({
    id: '/rulesets/',
    path: '/rulesets/',
    getParentRoute: () => AuthenticatedLayoutWorkspacesSubscriptionIdRoute,
  } as any)
const AuthenticatedLayoutWorkspacesSubscriptionIdSubdomainsIndexRoute =
  AuthenticatedLayoutWorkspacesSubscriptionIdSubdomainsIndexRouteImport.update({
    id: '/subdomains/',
    path: '/subdomains/',
    getParentRoute: () => AuthenticatedLayoutWorkspacesSubscriptionIdRoute,
  } as any)
const AuthenticatedLayoutWorkspacesSubscriptionIdSubdomainsCertificateIdRoute =
  AuthenticatedLayoutWorkspacesSubscriptionIdSubdomainsCertificateIdRouteImport.update(
    {
      id: '/subdomains/$certificateId',
      path: '/subdomains/$certificateId',
      getParentRoute: () => AuthenticatedLayoutWorkspacesSubscriptionIdRoute,
    } as any,
  )
const AuthenticatedLayoutWorkspacesSubscriptionIdSuspectScoreIndexRoute =
  AuthenticatedLayoutWorkspacesSubscriptionIdSuspectScoreIndexRouteImport.update(
    {
      id: '/',
      path: '/',
      getParentRoute: () =>
        AuthenticatedLayoutWorkspacesSubscriptionIdSuspectScoreRoute,
    } as any,
  )
const AuthenticatedLayoutWorkspacesSubscriptionIdSuspectScoreAnalysisRoute =
  AuthenticatedLayoutWorkspacesSubscriptionIdSuspectScoreAnalysisRouteImport.update(
    {
      id: '/analysis',
      path: '/analysis',
      getParentRoute: () =>
        AuthenticatedLayoutWorkspacesSubscriptionIdSuspectScoreRoute,
    } as any,
  )
const AuthenticatedLayoutWorkspacesSubscriptionIdVisitorsIndexRoute =
  AuthenticatedLayoutWorkspacesSubscriptionIdVisitorsIndexRouteImport.update({
    id: '/visitors/',
    path: '/visitors/',
    getParentRoute: () => AuthenticatedLayoutWorkspacesSubscriptionIdRoute,
  } as any)
const AuthenticatedLayoutWorkspacesSubscriptionIdVisitorsVisitorIdRoute =
  AuthenticatedLayoutWorkspacesSubscriptionIdVisitorsVisitorIdRouteImport.update(
    {
      id: '/visitors/$visitorId',
      path: '/visitors/$visitorId',
      getParentRoute: () => AuthenticatedLayoutWorkspacesSubscriptionIdRoute,
    } as any,
  )
const AuthenticatedLayoutWorkspacesSubscriptionIdVisitorsAvatarsRoute =
  AuthenticatedLayoutWorkspacesSubscriptionIdVisitorsAvatarsRouteImport.update({
    id: '/visitors/avatars',
    path: '/visitors/avatars',
    getParentRoute: () => AuthenticatedLayoutWorkspacesSubscriptionIdRoute,
  } as any)
const AuthenticatedLayoutWorkspacesSubscriptionIdWebhooksIndexRoute =
  AuthenticatedLayoutWorkspacesSubscriptionIdWebhooksIndexRouteImport.update({
    id: '/webhooks/',
    path: '/webhooks/',
    getParentRoute: () => AuthenticatedLayoutWorkspacesSubscriptionIdRoute,
  } as any)
const AuthenticatedWorkspacesSubscriptionIdPlanCancelIndexRoute =
  AuthenticatedWorkspacesSubscriptionIdPlanCancelIndexRouteImport.update({
    id: '/workspaces/$subscriptionId/plan/cancel/',
    path: '/workspaces/$subscriptionId/plan/cancel/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedWorkspacesSubscriptionIdPlanCancelConfirmRoute =
  AuthenticatedWorkspacesSubscriptionIdPlanCancelConfirmRouteImport.update({
    id: '/workspaces/$subscriptionId/plan/cancel/confirm',
    path: '/workspaces/$subscriptionId/plan/cancel/confirm',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedWorkspacesSubscriptionIdPlanDowngradeIndexRoute =
  AuthenticatedWorkspacesSubscriptionIdPlanDowngradeIndexRouteImport.update({
    id: '/workspaces/$subscriptionId/plan/downgrade/',
    path: '/workspaces/$subscriptionId/plan/downgrade/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedWorkspacesSubscriptionIdPlanDowngradeConfirmRoute =
  AuthenticatedWorkspacesSubscriptionIdPlanDowngradeConfirmRouteImport.update({
    id: '/workspaces/$subscriptionId/plan/downgrade/confirm',
    path: '/workspaces/$subscriptionId/plan/downgrade/confirm',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedWorkspacesSubscriptionIdRulesetsRulesetIdIndexLazyRoute =
  AuthenticatedWorkspacesSubscriptionIdRulesetsRulesetIdIndexLazyRouteImport.update(
    {
      id: '/',
      path: '/',
      getParentRoute: () =>
        AuthenticatedWorkspacesSubscriptionIdRulesetsRulesetIdRoute,
    } as any,
  ).lazy(() =>
    import(
      './routes/_authenticated/workspaces/$subscriptionId/rulesets/$rulesetId/index.lazy'
    ).then((d) => d.Route),
  )
const AuthenticatedWorkspacesSubscriptionIdRulesetsTemplatesTemplateSlugRoute =
  AuthenticatedWorkspacesSubscriptionIdRulesetsTemplatesTemplateSlugRouteImport.update(
    {
      id: '/workspaces/$subscriptionId/rulesets/templates/$templateSlug',
      path: '/workspaces/$subscriptionId/rulesets/templates/$templateSlug',
      getParentRoute: () => AuthenticatedRoute,
    } as any,
  )
const AuthenticatedLayoutdeprecatedWorkspacesSubscriptionIdVisitsRequestIdRoute =
  AuthenticatedLayoutdeprecatedWorkspacesSubscriptionIdVisitsRequestIdRouteImport.update(
    {
      id: '/$requestId',
      path: '/$requestId',
      getParentRoute: () =>
        AuthenticatedLayoutdeprecatedWorkspacesSubscriptionIdVisitsRoute,
    } as any,
  )
const AuthenticatedLayoutWorkspacesSubscriptionIdApiKeysTokenIdIndexRoute =
  AuthenticatedLayoutWorkspacesSubscriptionIdApiKeysTokenIdIndexRouteImport.update(
    {
      id: '/api-keys/$tokenId/',
      path: '/api-keys/$tokenId/',
      getParentRoute: () => AuthenticatedLayoutWorkspacesSubscriptionIdRoute,
    } as any,
  )
const AuthenticatedLayoutWorkspacesSubscriptionIdBotDetectionEventsIndexRoute =
  AuthenticatedLayoutWorkspacesSubscriptionIdBotDetectionEventsIndexRouteImport.update(
    {
      id: '/events/',
      path: '/events/',
      getParentRoute: () =>
        AuthenticatedLayoutWorkspacesSubscriptionIdBotDetectionRoute,
    } as any,
  )
const AuthenticatedLayoutWorkspacesSubscriptionIdBotDetectionEventsEventIdRoute =
  AuthenticatedLayoutWorkspacesSubscriptionIdBotDetectionEventsEventIdRouteImport.update(
    {
      id: '/events/$eventId',
      path: '/events/$eventId',
      getParentRoute: () =>
        AuthenticatedLayoutWorkspacesSubscriptionIdBotDetectionRoute,
    } as any,
  )
const AuthenticatedLayoutWorkspacesSubscriptionIdEventsRequestIdIndexRoute =
  AuthenticatedLayoutWorkspacesSubscriptionIdEventsRequestIdIndexRouteImport.update(
    {
      id: '/events/$requestId/',
      path: '/events/$requestId/',
      getParentRoute: () => AuthenticatedLayoutWorkspacesSubscriptionIdRoute,
    } as any,
  )
const AuthenticatedLayoutWorkspacesSubscriptionIdEventsRequestIdVisitorHistoryRoute =
  AuthenticatedLayoutWorkspacesSubscriptionIdEventsRequestIdVisitorHistoryRouteImport.update(
    {
      id: '/events/$requestId/visitor-history',
      path: '/events/$requestId/visitor-history',
      getParentRoute: () => AuthenticatedLayoutWorkspacesSubscriptionIdRoute,
    } as any,
  )
const AuthenticatedLayoutWorkspacesSubscriptionIdFraudAnalysisDatasetIndexRoute =
  AuthenticatedLayoutWorkspacesSubscriptionIdFraudAnalysisDatasetIndexRouteImport.update(
    {
      id: '/',
      path: '/',
      getParentRoute: () =>
        AuthenticatedLayoutWorkspacesSubscriptionIdFraudAnalysisDatasetRoute,
    } as any,
  )
const AuthenticatedLayoutWorkspacesSubscriptionIdFraudAnalysisDatasetEventsRoute =
  AuthenticatedLayoutWorkspacesSubscriptionIdFraudAnalysisDatasetEventsRouteImport.update(
    {
      id: '/events',
      path: '/events',
      getParentRoute: () =>
        AuthenticatedLayoutWorkspacesSubscriptionIdFraudAnalysisDatasetRoute,
    } as any,
  )
const AuthenticatedLayoutWorkspacesSubscriptionIdFraudAnalysisModelsIndexRoute =
  AuthenticatedLayoutWorkspacesSubscriptionIdFraudAnalysisModelsIndexRouteImport.update(
    {
      id: '/models/',
      path: '/models/',
      getParentRoute: () =>
        AuthenticatedLayoutWorkspacesSubscriptionIdFraudAnalysisRoute,
    } as any,
  )
const AuthenticatedLayoutWorkspacesSubscriptionIdIntegrationsIntegrationTagIndexRoute =
  AuthenticatedLayoutWorkspacesSubscriptionIdIntegrationsIntegrationTagIndexRouteImport.update(
    {
      id: '/$integrationTag/',
      path: '/$integrationTag/',
      getParentRoute: () =>
        AuthenticatedLayoutWorkspacesSubscriptionIdIntegrationsRoute,
    } as any,
  )
const AuthenticatedLayoutWorkspacesSubscriptionIdIntegrationsIntegrationTagEnvironmentIdRoute =
  AuthenticatedLayoutWorkspacesSubscriptionIdIntegrationsIntegrationTagEnvironmentIdRouteImport.update(
    {
      id: '/$integrationTag/$environmentId',
      path: '/$integrationTag/$environmentId',
      getParentRoute: () =>
        AuthenticatedLayoutWorkspacesSubscriptionIdIntegrationsRoute,
    } as any,
  )
const AuthenticatedLayoutWorkspacesSubscriptionIdIntegrationsIntegrationTagHealthRoute =
  AuthenticatedLayoutWorkspacesSubscriptionIdIntegrationsIntegrationTagHealthRouteImport.update(
    {
      id: '/$integrationTag/health',
      path: '/$integrationTag/health',
      getParentRoute: () =>
        AuthenticatedLayoutWorkspacesSubscriptionIdIntegrationsRoute,
    } as any,
  )
const AuthenticatedLayoutWorkspacesSubscriptionIdIntegrationsCloudflareFlowIndexRoute =
  AuthenticatedLayoutWorkspacesSubscriptionIdIntegrationsCloudflareFlowIndexRouteImport.update(
    {
      id: '/cloudflare-flow/',
      path: '/cloudflare-flow/',
      getParentRoute: () =>
        AuthenticatedLayoutWorkspacesSubscriptionIdIntegrationsRoute,
    } as any,
  )
const AuthenticatedLayoutWorkspacesSubscriptionIdInvoicesInvoiceIdIndexRoute =
  AuthenticatedLayoutWorkspacesSubscriptionIdInvoicesInvoiceIdIndexRouteImport.update(
    {
      id: '/invoices/$invoiceId/',
      path: '/invoices/$invoiceId/',
      getParentRoute: () => AuthenticatedLayoutWorkspacesSubscriptionIdRoute,
    } as any,
  )
const AuthenticatedLayoutWorkspacesSubscriptionIdInvoicesInvoiceIdForgivenessRequestRoute =
  AuthenticatedLayoutWorkspacesSubscriptionIdInvoicesInvoiceIdForgivenessRequestRouteImport.update(
    {
      id: '/invoices/$invoiceId/forgiveness-request',
      path: '/invoices/$invoiceId/forgiveness-request',
      getParentRoute: () => AuthenticatedLayoutWorkspacesSubscriptionIdRoute,
    } as any,
  )
const AuthenticatedLayoutWorkspacesSubscriptionIdVisitorsVisitorIdIndexRoute =
  AuthenticatedLayoutWorkspacesSubscriptionIdVisitorsVisitorIdIndexRouteImport.update(
    {
      id: '/',
      path: '/',
      getParentRoute: () =>
        AuthenticatedLayoutWorkspacesSubscriptionIdVisitorsVisitorIdRoute,
    } as any,
  )
const AuthenticatedLayoutWorkspacesSubscriptionIdVisitorsVisitorIdEventsRoute =
  AuthenticatedLayoutWorkspacesSubscriptionIdVisitorsVisitorIdEventsRouteImport.update(
    {
      id: '/events',
      path: '/events',
      getParentRoute: () =>
        AuthenticatedLayoutWorkspacesSubscriptionIdVisitorsVisitorIdRoute,
    } as any,
  )
const AuthenticatedLayoutWorkspacesSubscriptionIdVisitorsVisitorIdIpAddressesRoute =
  AuthenticatedLayoutWorkspacesSubscriptionIdVisitorsVisitorIdIpAddressesRouteImport.update(
    {
      id: '/ip-addresses',
      path: '/ip-addresses',
      getParentRoute: () =>
        AuthenticatedLayoutWorkspacesSubscriptionIdVisitorsVisitorIdRoute,
    } as any,
  )
const AuthenticatedLayoutWorkspacesSubscriptionIdVisitorsVisitorIdLocationHistoryRoute =
  AuthenticatedLayoutWorkspacesSubscriptionIdVisitorsVisitorIdLocationHistoryRouteImport.update(
    {
      id: '/location-history',
      path: '/location-history',
      getParentRoute: () =>
        AuthenticatedLayoutWorkspacesSubscriptionIdVisitorsVisitorIdRoute,
    } as any,
  )
const AuthenticatedLayoutWorkspacesSubscriptionIdVisitorsVisitorIdRelatedVisitorsRoute =
  AuthenticatedLayoutWorkspacesSubscriptionIdVisitorsVisitorIdRelatedVisitorsRouteImport.update(
    {
      id: '/related-visitors',
      path: '/related-visitors',
      getParentRoute: () =>
        AuthenticatedLayoutWorkspacesSubscriptionIdVisitorsVisitorIdRoute,
    } as any,
  )
const AuthenticatedLayoutWorkspacesSubscriptionIdVisitorsVisitorIdSmartSignalsRoute =
  AuthenticatedLayoutWorkspacesSubscriptionIdVisitorsVisitorIdSmartSignalsRouteImport.update(
    {
      id: '/smart-signals',
      path: '/smart-signals',
      getParentRoute: () =>
        AuthenticatedLayoutWorkspacesSubscriptionIdVisitorsVisitorIdRoute,
    } as any,
  )
const AuthenticatedLayoutWorkspacesSubscriptionIdWebhooksWebhookIdEventsRoute =
  AuthenticatedLayoutWorkspacesSubscriptionIdWebhooksWebhookIdEventsRouteImport.update(
    {
      id: '/webhooks/$webhookId/events',
      path: '/webhooks/$webhookId/events',
      getParentRoute: () => AuthenticatedLayoutWorkspacesSubscriptionIdRoute,
    } as any,
  )
const AuthenticatedLayoutWorkspacesSubscriptionIdWebhooksWebhookIdVerifyRoute =
  AuthenticatedLayoutWorkspacesSubscriptionIdWebhooksWebhookIdVerifyRouteImport.update(
    {
      id: '/webhooks/$webhookId/verify',
      path: '/webhooks/$webhookId/verify',
      getParentRoute: () => AuthenticatedLayoutWorkspacesSubscriptionIdRoute,
    } as any,
  )
const AuthenticatedLayoutWorkspacesSubscriptionIdFraudAnalysisModelsLabelSlugIndexRoute =
  AuthenticatedLayoutWorkspacesSubscriptionIdFraudAnalysisModelsLabelSlugIndexRouteImport.update(
    {
      id: '/models/$labelSlug/',
      path: '/models/$labelSlug/',
      getParentRoute: () =>
        AuthenticatedLayoutWorkspacesSubscriptionIdFraudAnalysisRoute,
    } as any,
  )
const AuthenticatedLayoutWorkspacesSubscriptionIdFraudAnalysisModelsLabelSlugClientTypeRoute =
  AuthenticatedLayoutWorkspacesSubscriptionIdFraudAnalysisModelsLabelSlugClientTypeRouteImport.update(
    {
      id: '/models/$labelSlug/$clientType',
      path: '/models/$labelSlug/$clientType',
      getParentRoute: () =>
        AuthenticatedLayoutWorkspacesSubscriptionIdFraudAnalysisRoute,
    } as any,
  )
const AuthenticatedLayoutWorkspacesSubscriptionIdIntegrationsCloudflareFlowWorkersIndexRoute =
  AuthenticatedLayoutWorkspacesSubscriptionIdIntegrationsCloudflareFlowWorkersIndexRouteImport.update(
    {
      id: '/cloudflare-flow/workers/',
      path: '/cloudflare-flow/workers/',
      getParentRoute: () =>
        AuthenticatedLayoutWorkspacesSubscriptionIdIntegrationsRoute,
    } as any,
  )
const AuthenticatedLayoutWorkspacesSubscriptionIdIntegrationsCloudflareFlowWorkersDeploymentIdRoute =
  AuthenticatedLayoutWorkspacesSubscriptionIdIntegrationsCloudflareFlowWorkersDeploymentIdRouteImport.update(
    {
      id: '/cloudflare-flow/workers/$deploymentId',
      path: '/cloudflare-flow/workers/$deploymentId',
      getParentRoute: () =>
        AuthenticatedLayoutWorkspacesSubscriptionIdIntegrationsRoute,
    } as any,
  )
const AuthenticatedLayoutWorkspacesSubscriptionIdFraudAnalysisModelsLabelSlugClientTypeIndexRoute =
  AuthenticatedLayoutWorkspacesSubscriptionIdFraudAnalysisModelsLabelSlugClientTypeIndexRouteImport.update(
    {
      id: '/',
      path: '/',
      getParentRoute: () =>
        AuthenticatedLayoutWorkspacesSubscriptionIdFraudAnalysisModelsLabelSlugClientTypeRoute,
    } as any,
  )
const AuthenticatedLayoutWorkspacesSubscriptionIdFraudAnalysisModelsLabelSlugClientTypeModelVersionIdRoute =
  AuthenticatedLayoutWorkspacesSubscriptionIdFraudAnalysisModelsLabelSlugClientTypeModelVersionIdRouteImport.update(
    {
      id: '/$modelVersionId',
      path: '/$modelVersionId',
      getParentRoute: () =>
        AuthenticatedLayoutWorkspacesSubscriptionIdFraudAnalysisModelsLabelSlugClientTypeRoute,
    } as any,
  )
const AuthenticatedLayoutWorkspacesSubscriptionIdFraudAnalysisModelsLabelSlugClientTypeOverviewRoute =
  AuthenticatedLayoutWorkspacesSubscriptionIdFraudAnalysisModelsLabelSlugClientTypeOverviewRouteImport.update(
    {
      id: '/overview',
      path: '/overview',
      getParentRoute: () =>
        AuthenticatedLayoutWorkspacesSubscriptionIdFraudAnalysisModelsLabelSlugClientTypeRoute,
    } as any,
  )
const AuthenticatedLayoutWorkspacesSubscriptionIdFraudAnalysisModelsLabelSlugClientTypeVersionsRoute =
  AuthenticatedLayoutWorkspacesSubscriptionIdFraudAnalysisModelsLabelSlugClientTypeVersionsRouteImport.update(
    {
      id: '/versions',
      path: '/versions',
      getParentRoute: () =>
        AuthenticatedLayoutWorkspacesSubscriptionIdFraudAnalysisModelsLabelSlugClientTypeRoute,
    } as any,
  )

export interface FileRoutesByFullPath {
  '/': typeof AuthenticatedIndexRoute
  '/impersonate': typeof ImpersonateRoute
  '/unsubscribe': typeof UnsubscribeRouteWithChildren
  '/consent': typeof AuthenticatedConsentRoute
  '/mcp-auth': typeof AuthenticatedMcpAuthRoute
  '/mintlify_login': typeof AuthenticatedMintlify_loginRoute
  '/onboarding': typeof AuthenticatedOnboardingRoute
  '/readme_login': typeof AuthenticatedReadme_loginRoute
  '/login': typeof UnauthenticatedLoginRoute
  '/contact-sales/enterprise': typeof ContactSalesEnterpriseRoute
  '/newsletter/unsubscribe': typeof NewsletterUnsubscribeRoute
  '/unsubscribe/feedback': typeof UnsubscribeFeedbackRoute
  '/unsubscribe/': typeof UnsubscribeIndexRoute
  '/$': typeof AuthenticatedLayoutSplatRoute
  '/workspaces/start': typeof AuthenticatedWorkspacesStartRoute
  '/invitation_confirmation/$id': typeof UnauthenticatedInvitation_confirmationIdRoute
  '/reset/$id': typeof UnauthenticatedResetIdRoute
  '/sso/callback': typeof UnauthenticatedSsoCallbackRoute
  '/signup/confirm/$signupIntent': typeof SignupConfirmSignupIntentRoute
  '/reset/': typeof UnauthenticatedResetIndexRoute
  '/reset_confirm/': typeof UnauthenticatedReset_confirmIndexRoute
  '/signup/': typeof UnauthenticatedSignupIndexRoute
  '/signup/confirm/': typeof SignupConfirmIndexRoute
  '/profile/notifications': typeof AuthenticatedLayoutProfileNotificationsRoute
  '/profile/settings': typeof AuthenticatedLayoutProfileSettingsRoute
  '/settings/users': typeof AuthenticatedLayoutSettingsUsersRoute
  '/settings/workspaces': typeof AuthenticatedLayoutSettingsWorkspacesRoute
  '/templates/$': typeof AuthenticatedLayoutTemplatesSplatRoute
  '/workspaces/$subscriptionId': typeof AuthenticatedLayoutWorkspacesSubscriptionIdRouteWithChildren
  '/subscriptions/$': typeof AuthenticatedLayoutdeprecatedSubscriptionsSplatRoute
  '/settings/billing/migrate': typeof AuthenticatedLayoutSettingsBillingMigrateRoute
  '/workspaces/$subscriptionId/alerts': typeof AuthenticatedLayoutWorkspacesSubscriptionIdAlertsRoute
  '/workspaces/$subscriptionId/audit-log': typeof AuthenticatedLayoutWorkspacesSubscriptionIdAuditLogRoute
  '/workspaces/$subscriptionId/billing': typeof AuthenticatedLayoutWorkspacesSubscriptionIdBillingRoute
  '/workspaces/$subscriptionId/bot-detection': typeof AuthenticatedLayoutWorkspacesSubscriptionIdBotDetectionRouteWithChildren
  '/workspaces/$subscriptionId/botd': typeof AuthenticatedLayoutWorkspacesSubscriptionIdBotdRoute
  '/workspaces/$subscriptionId/environments': typeof AuthenticatedLayoutWorkspacesSubscriptionIdEnvironmentsRoute
  '/workspaces/$subscriptionId/fraud-analysis': typeof AuthenticatedLayoutWorkspacesSubscriptionIdFraudAnalysisRouteWithChildren
  '/workspaces/$subscriptionId/general': typeof AuthenticatedLayoutWorkspacesSubscriptionIdGeneralRoute
  '/workspaces/$subscriptionId/get-started': typeof AuthenticatedLayoutWorkspacesSubscriptionIdGetStartedRouteWithChildren
  '/workspaces/$subscriptionId/integrations': typeof AuthenticatedLayoutWorkspacesSubscriptionIdIntegrationsRouteWithChildren
  '/workspaces/$subscriptionId/mcp': typeof AuthenticatedLayoutWorkspacesSubscriptionIdMcpRoute
  '/workspaces/$subscriptionId/overview': typeof AuthenticatedLayoutWorkspacesSubscriptionIdOverviewRoute
  '/workspaces/$subscriptionId/plans': typeof AuthenticatedLayoutWorkspacesSubscriptionIdPlansRoute
  '/workspaces/$subscriptionId/smart-signals': typeof AuthenticatedLayoutWorkspacesSubscriptionIdSmartSignalsRoute
  '/workspaces/$subscriptionId/submit-bot': typeof AuthenticatedLayoutWorkspacesSubscriptionIdSubmitBotRoute
  '/workspaces/$subscriptionId/suspect-score': typeof AuthenticatedLayoutWorkspacesSubscriptionIdSuspectScoreRouteWithChildren
  '/workspaces/$subscriptionId/traffic-rules': typeof AuthenticatedLayoutWorkspacesSubscriptionIdTrafficRulesRoute
  '/workspaces/$subscriptionId/rulesets/$rulesetId': typeof AuthenticatedWorkspacesSubscriptionIdRulesetsRulesetIdRouteWithChildren
  '/workspaces/$subscriptionId/templates/$': typeof AuthenticatedWorkspacesSubscriptionIdTemplatesSplatRoute
  '/settings/billing/': typeof AuthenticatedLayoutSettingsBillingIndexRoute
  '/workspaces/$subscriptionId/': typeof AuthenticatedLayoutWorkspacesSubscriptionIdIndexRoute
  '/workspaces/$subscriptionId/visits': typeof AuthenticatedLayoutdeprecatedWorkspacesSubscriptionIdVisitsRouteWithChildren
  '/workspaces/$subscriptionId/fraud-analysis/dataset': typeof AuthenticatedLayoutWorkspacesSubscriptionIdFraudAnalysisDatasetRouteWithChildren
  '/workspaces/$subscriptionId/fraud-analysis/unlock': typeof AuthenticatedLayoutWorkspacesSubscriptionIdFraudAnalysisUnlockRoute
  '/workspaces/$subscriptionId/fraud-analysis/upgrade': typeof AuthenticatedLayoutWorkspacesSubscriptionIdFraudAnalysisUpgradeRoute
  '/workspaces/$subscriptionId/fraud-analysis/upload': typeof AuthenticatedLayoutWorkspacesSubscriptionIdFraudAnalysisUploadRoute
  '/workspaces/$subscriptionId/get-started/$stepSlug': typeof AuthenticatedLayoutWorkspacesSubscriptionIdGetStartedStepSlugRoute
  '/workspaces/$subscriptionId/integrations/active': typeof AuthenticatedLayoutWorkspacesSubscriptionIdIntegrationsActiveRoute
  '/workspaces/$subscriptionId/integrations/directory': typeof AuthenticatedLayoutWorkspacesSubscriptionIdIntegrationsDirectoryRoute
  '/workspaces/$subscriptionId/plan/checkout-return': typeof AuthenticatedLayoutWorkspacesSubscriptionIdPlanCheckoutReturnRoute
  '/workspaces/$subscriptionId/plan/unpaid-invoices': typeof AuthenticatedLayoutWorkspacesSubscriptionIdPlanUnpaidInvoicesRoute
  '/workspaces/$subscriptionId/subdomains/$certificateId': typeof AuthenticatedLayoutWorkspacesSubscriptionIdSubdomainsCertificateIdRoute
  '/workspaces/$subscriptionId/suspect-score/analysis': typeof AuthenticatedLayoutWorkspacesSubscriptionIdSuspectScoreAnalysisRoute
  '/workspaces/$subscriptionId/visitors/$visitorId': typeof AuthenticatedLayoutWorkspacesSubscriptionIdVisitorsVisitorIdRouteWithChildren
  '/workspaces/$subscriptionId/visitors/avatars': typeof AuthenticatedLayoutWorkspacesSubscriptionIdVisitorsAvatarsRoute
  '/workspaces/$subscriptionId/plan/cancel/confirm': typeof AuthenticatedWorkspacesSubscriptionIdPlanCancelConfirmRoute
  '/workspaces/$subscriptionId/plan/downgrade/confirm': typeof AuthenticatedWorkspacesSubscriptionIdPlanDowngradeConfirmRoute
  '/workspaces/$subscriptionId/rulesets/templates/$templateSlug': typeof AuthenticatedWorkspacesSubscriptionIdRulesetsTemplatesTemplateSlugRoute
  '/workspaces/$subscriptionId/api-keys/': typeof AuthenticatedLayoutWorkspacesSubscriptionIdApiKeysIndexRoute
  '/workspaces/$subscriptionId/bot-detection/': typeof AuthenticatedLayoutWorkspacesSubscriptionIdBotDetectionIndexRoute
  '/workspaces/$subscriptionId/events/': typeof AuthenticatedLayoutWorkspacesSubscriptionIdEventsIndexRoute
  '/workspaces/$subscriptionId/fraud-analysis/': typeof AuthenticatedLayoutWorkspacesSubscriptionIdFraudAnalysisIndexRoute
  '/workspaces/$subscriptionId/get-started/': typeof AuthenticatedLayoutWorkspacesSubscriptionIdGetStartedIndexRoute
  '/workspaces/$subscriptionId/health/': typeof AuthenticatedLayoutWorkspacesSubscriptionIdHealthIndexRoute
  '/workspaces/$subscriptionId/integrations/': typeof AuthenticatedLayoutWorkspacesSubscriptionIdIntegrationsIndexRoute
  '/workspaces/$subscriptionId/plan/': typeof AuthenticatedLayoutWorkspacesSubscriptionIdPlanIndexRoute
  '/workspaces/$subscriptionId/rulesets/': typeof AuthenticatedLayoutWorkspacesSubscriptionIdRulesetsIndexRoute
  '/workspaces/$subscriptionId/subdomains/': typeof AuthenticatedLayoutWorkspacesSubscriptionIdSubdomainsIndexRoute
  '/workspaces/$subscriptionId/suspect-score/': typeof AuthenticatedLayoutWorkspacesSubscriptionIdSuspectScoreIndexRoute
  '/workspaces/$subscriptionId/visitors/': typeof AuthenticatedLayoutWorkspacesSubscriptionIdVisitorsIndexRoute
  '/workspaces/$subscriptionId/webhooks/': typeof AuthenticatedLayoutWorkspacesSubscriptionIdWebhooksIndexRoute
  '/workspaces/$subscriptionId/plan/cancel/': typeof AuthenticatedWorkspacesSubscriptionIdPlanCancelIndexRoute
  '/workspaces/$subscriptionId/plan/downgrade/': typeof AuthenticatedWorkspacesSubscriptionIdPlanDowngradeIndexRoute
  '/workspaces/$subscriptionId/rulesets/$rulesetId/': typeof AuthenticatedWorkspacesSubscriptionIdRulesetsRulesetIdIndexLazyRoute
  '/workspaces/$subscriptionId/visits/$requestId': typeof AuthenticatedLayoutdeprecatedWorkspacesSubscriptionIdVisitsRequestIdRoute
  '/workspaces/$subscriptionId/bot-detection/events/$eventId': typeof AuthenticatedLayoutWorkspacesSubscriptionIdBotDetectionEventsEventIdRoute
  '/workspaces/$subscriptionId/events/$requestId/visitor-history': typeof AuthenticatedLayoutWorkspacesSubscriptionIdEventsRequestIdVisitorHistoryRoute
  '/workspaces/$subscriptionId/fraud-analysis/dataset/events': typeof AuthenticatedLayoutWorkspacesSubscriptionIdFraudAnalysisDatasetEventsRoute
  '/workspaces/$subscriptionId/integrations/$integrationTag/$environmentId': typeof AuthenticatedLayoutWorkspacesSubscriptionIdIntegrationsIntegrationTagEnvironmentIdRoute
  '/workspaces/$subscriptionId/integrations/$integrationTag/health': typeof AuthenticatedLayoutWorkspacesSubscriptionIdIntegrationsIntegrationTagHealthRoute
  '/workspaces/$subscriptionId/invoices/$invoiceId/forgiveness-request': typeof AuthenticatedLayoutWorkspacesSubscriptionIdInvoicesInvoiceIdForgivenessRequestRoute
  '/workspaces/$subscriptionId/visitors/$visitorId/events': typeof AuthenticatedLayoutWorkspacesSubscriptionIdVisitorsVisitorIdEventsRoute
  '/workspaces/$subscriptionId/visitors/$visitorId/ip-addresses': typeof AuthenticatedLayoutWorkspacesSubscriptionIdVisitorsVisitorIdIpAddressesRoute
  '/workspaces/$subscriptionId/visitors/$visitorId/location-history': typeof AuthenticatedLayoutWorkspacesSubscriptionIdVisitorsVisitorIdLocationHistoryRoute
  '/workspaces/$subscriptionId/visitors/$visitorId/related-visitors': typeof AuthenticatedLayoutWorkspacesSubscriptionIdVisitorsVisitorIdRelatedVisitorsRoute
  '/workspaces/$subscriptionId/visitors/$visitorId/smart-signals': typeof AuthenticatedLayoutWorkspacesSubscriptionIdVisitorsVisitorIdSmartSignalsRoute
  '/workspaces/$subscriptionId/webhooks/$webhookId/events': typeof AuthenticatedLayoutWorkspacesSubscriptionIdWebhooksWebhookIdEventsRoute
  '/workspaces/$subscriptionId/webhooks/$webhookId/verify': typeof AuthenticatedLayoutWorkspacesSubscriptionIdWebhooksWebhookIdVerifyRoute
  '/workspaces/$subscriptionId/api-keys/$tokenId/': typeof AuthenticatedLayoutWorkspacesSubscriptionIdApiKeysTokenIdIndexRoute
  '/workspaces/$subscriptionId/bot-detection/events/': typeof AuthenticatedLayoutWorkspacesSubscriptionIdBotDetectionEventsIndexRoute
  '/workspaces/$subscriptionId/events/$requestId/': typeof AuthenticatedLayoutWorkspacesSubscriptionIdEventsRequestIdIndexRoute
  '/workspaces/$subscriptionId/fraud-analysis/dataset/': typeof AuthenticatedLayoutWorkspacesSubscriptionIdFraudAnalysisDatasetIndexRoute
  '/workspaces/$subscriptionId/fraud-analysis/models/': typeof AuthenticatedLayoutWorkspacesSubscriptionIdFraudAnalysisModelsIndexRoute
  '/workspaces/$subscriptionId/integrations/$integrationTag/': typeof AuthenticatedLayoutWorkspacesSubscriptionIdIntegrationsIntegrationTagIndexRoute
  '/workspaces/$subscriptionId/integrations/cloudflare-flow/': typeof AuthenticatedLayoutWorkspacesSubscriptionIdIntegrationsCloudflareFlowIndexRoute
  '/workspaces/$subscriptionId/invoices/$invoiceId/': typeof AuthenticatedLayoutWorkspacesSubscriptionIdInvoicesInvoiceIdIndexRoute
  '/workspaces/$subscriptionId/visitors/$visitorId/': typeof AuthenticatedLayoutWorkspacesSubscriptionIdVisitorsVisitorIdIndexRoute
  '/workspaces/$subscriptionId/fraud-analysis/models/$labelSlug/$clientType': typeof AuthenticatedLayoutWorkspacesSubscriptionIdFraudAnalysisModelsLabelSlugClientTypeRouteWithChildren
  '/workspaces/$subscriptionId/integrations/cloudflare-flow/workers/$deploymentId': typeof AuthenticatedLayoutWorkspacesSubscriptionIdIntegrationsCloudflareFlowWorkersDeploymentIdRoute
  '/workspaces/$subscriptionId/fraud-analysis/models/$labelSlug/': typeof AuthenticatedLayoutWorkspacesSubscriptionIdFraudAnalysisModelsLabelSlugIndexRoute
  '/workspaces/$subscriptionId/integrations/cloudflare-flow/workers/': typeof AuthenticatedLayoutWorkspacesSubscriptionIdIntegrationsCloudflareFlowWorkersIndexRoute
  '/workspaces/$subscriptionId/fraud-analysis/models/$labelSlug/$clientType/$modelVersionId': typeof AuthenticatedLayoutWorkspacesSubscriptionIdFraudAnalysisModelsLabelSlugClientTypeModelVersionIdRoute
  '/workspaces/$subscriptionId/fraud-analysis/models/$labelSlug/$clientType/overview': typeof AuthenticatedLayoutWorkspacesSubscriptionIdFraudAnalysisModelsLabelSlugClientTypeOverviewRoute
  '/workspaces/$subscriptionId/fraud-analysis/models/$labelSlug/$clientType/versions': typeof AuthenticatedLayoutWorkspacesSubscriptionIdFraudAnalysisModelsLabelSlugClientTypeVersionsRoute
  '/workspaces/$subscriptionId/fraud-analysis/models/$labelSlug/$clientType/': typeof AuthenticatedLayoutWorkspacesSubscriptionIdFraudAnalysisModelsLabelSlugClientTypeIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof AuthenticatedIndexRoute
  '/impersonate': typeof ImpersonateRoute
  '/consent': typeof AuthenticatedConsentRoute
  '/mcp-auth': typeof AuthenticatedMcpAuthRoute
  '/mintlify_login': typeof AuthenticatedMintlify_loginRoute
  '/onboarding': typeof AuthenticatedOnboardingRoute
  '/readme_login': typeof AuthenticatedReadme_loginRoute
  '/login': typeof UnauthenticatedLoginRoute
  '/contact-sales/enterprise': typeof ContactSalesEnterpriseRoute
  '/newsletter/unsubscribe': typeof NewsletterUnsubscribeRoute
  '/unsubscribe/feedback': typeof UnsubscribeFeedbackRoute
  '/unsubscribe': typeof UnsubscribeIndexRoute
  '/$': typeof AuthenticatedLayoutSplatRoute
  '/workspaces/start': typeof AuthenticatedWorkspacesStartRoute
  '/invitation_confirmation/$id': typeof UnauthenticatedInvitation_confirmationIdRoute
  '/reset/$id': typeof UnauthenticatedResetIdRoute
  '/sso/callback': typeof UnauthenticatedSsoCallbackRoute
  '/signup/confirm/$signupIntent': typeof SignupConfirmSignupIntentRoute
  '/reset': typeof UnauthenticatedResetIndexRoute
  '/reset_confirm': typeof UnauthenticatedReset_confirmIndexRoute
  '/signup': typeof UnauthenticatedSignupIndexRoute
  '/signup/confirm': typeof SignupConfirmIndexRoute
  '/profile/notifications': typeof AuthenticatedLayoutProfileNotificationsRoute
  '/profile/settings': typeof AuthenticatedLayoutProfileSettingsRoute
  '/settings/users': typeof AuthenticatedLayoutSettingsUsersRoute
  '/settings/workspaces': typeof AuthenticatedLayoutSettingsWorkspacesRoute
  '/templates/$': typeof AuthenticatedLayoutTemplatesSplatRoute
  '/subscriptions/$': typeof AuthenticatedLayoutdeprecatedSubscriptionsSplatRoute
  '/settings/billing/migrate': typeof AuthenticatedLayoutSettingsBillingMigrateRoute
  '/workspaces/$subscriptionId/alerts': typeof AuthenticatedLayoutWorkspacesSubscriptionIdAlertsRoute
  '/workspaces/$subscriptionId/audit-log': typeof AuthenticatedLayoutWorkspacesSubscriptionIdAuditLogRoute
  '/workspaces/$subscriptionId/billing': typeof AuthenticatedLayoutWorkspacesSubscriptionIdBillingRoute
  '/workspaces/$subscriptionId/botd': typeof AuthenticatedLayoutWorkspacesSubscriptionIdBotdRoute
  '/workspaces/$subscriptionId/environments': typeof AuthenticatedLayoutWorkspacesSubscriptionIdEnvironmentsRoute
  '/workspaces/$subscriptionId/general': typeof AuthenticatedLayoutWorkspacesSubscriptionIdGeneralRoute
  '/workspaces/$subscriptionId/mcp': typeof AuthenticatedLayoutWorkspacesSubscriptionIdMcpRoute
  '/workspaces/$subscriptionId/overview': typeof AuthenticatedLayoutWorkspacesSubscriptionIdOverviewRoute
  '/workspaces/$subscriptionId/plans': typeof AuthenticatedLayoutWorkspacesSubscriptionIdPlansRoute
  '/workspaces/$subscriptionId/smart-signals': typeof AuthenticatedLayoutWorkspacesSubscriptionIdSmartSignalsRoute
  '/workspaces/$subscriptionId/submit-bot': typeof AuthenticatedLayoutWorkspacesSubscriptionIdSubmitBotRoute
  '/workspaces/$subscriptionId/traffic-rules': typeof AuthenticatedLayoutWorkspacesSubscriptionIdTrafficRulesRoute
  '/workspaces/$subscriptionId/templates/$': typeof AuthenticatedWorkspacesSubscriptionIdTemplatesSplatRoute
  '/settings/billing': typeof AuthenticatedLayoutSettingsBillingIndexRoute
  '/workspaces/$subscriptionId': typeof AuthenticatedLayoutWorkspacesSubscriptionIdIndexRoute
  '/workspaces/$subscriptionId/visits': typeof AuthenticatedLayoutdeprecatedWorkspacesSubscriptionIdVisitsRouteWithChildren
  '/workspaces/$subscriptionId/fraud-analysis/unlock': typeof AuthenticatedLayoutWorkspacesSubscriptionIdFraudAnalysisUnlockRoute
  '/workspaces/$subscriptionId/fraud-analysis/upgrade': typeof AuthenticatedLayoutWorkspacesSubscriptionIdFraudAnalysisUpgradeRoute
  '/workspaces/$subscriptionId/fraud-analysis/upload': typeof AuthenticatedLayoutWorkspacesSubscriptionIdFraudAnalysisUploadRoute
  '/workspaces/$subscriptionId/get-started/$stepSlug': typeof AuthenticatedLayoutWorkspacesSubscriptionIdGetStartedStepSlugRoute
  '/workspaces/$subscriptionId/integrations/active': typeof AuthenticatedLayoutWorkspacesSubscriptionIdIntegrationsActiveRoute
  '/workspaces/$subscriptionId/integrations/directory': typeof AuthenticatedLayoutWorkspacesSubscriptionIdIntegrationsDirectoryRoute
  '/workspaces/$subscriptionId/plan/checkout-return': typeof AuthenticatedLayoutWorkspacesSubscriptionIdPlanCheckoutReturnRoute
  '/workspaces/$subscriptionId/plan/unpaid-invoices': typeof AuthenticatedLayoutWorkspacesSubscriptionIdPlanUnpaidInvoicesRoute
  '/workspaces/$subscriptionId/subdomains/$certificateId': typeof AuthenticatedLayoutWorkspacesSubscriptionIdSubdomainsCertificateIdRoute
  '/workspaces/$subscriptionId/suspect-score/analysis': typeof AuthenticatedLayoutWorkspacesSubscriptionIdSuspectScoreAnalysisRoute
  '/workspaces/$subscriptionId/visitors/avatars': typeof AuthenticatedLayoutWorkspacesSubscriptionIdVisitorsAvatarsRoute
  '/workspaces/$subscriptionId/plan/cancel/confirm': typeof AuthenticatedWorkspacesSubscriptionIdPlanCancelConfirmRoute
  '/workspaces/$subscriptionId/plan/downgrade/confirm': typeof AuthenticatedWorkspacesSubscriptionIdPlanDowngradeConfirmRoute
  '/workspaces/$subscriptionId/rulesets/templates/$templateSlug': typeof AuthenticatedWorkspacesSubscriptionIdRulesetsTemplatesTemplateSlugRoute
  '/workspaces/$subscriptionId/api-keys': typeof AuthenticatedLayoutWorkspacesSubscriptionIdApiKeysIndexRoute
  '/workspaces/$subscriptionId/bot-detection': typeof AuthenticatedLayoutWorkspacesSubscriptionIdBotDetectionIndexRoute
  '/workspaces/$subscriptionId/events': typeof AuthenticatedLayoutWorkspacesSubscriptionIdEventsIndexRoute
  '/workspaces/$subscriptionId/fraud-analysis': typeof AuthenticatedLayoutWorkspacesSubscriptionIdFraudAnalysisIndexRoute
  '/workspaces/$subscriptionId/get-started': typeof AuthenticatedLayoutWorkspacesSubscriptionIdGetStartedIndexRoute
  '/workspaces/$subscriptionId/health': typeof AuthenticatedLayoutWorkspacesSubscriptionIdHealthIndexRoute
  '/workspaces/$subscriptionId/integrations': typeof AuthenticatedLayoutWorkspacesSubscriptionIdIntegrationsIndexRoute
  '/workspaces/$subscriptionId/plan': typeof AuthenticatedLayoutWorkspacesSubscriptionIdPlanIndexRoute
  '/workspaces/$subscriptionId/rulesets': typeof AuthenticatedLayoutWorkspacesSubscriptionIdRulesetsIndexRoute
  '/workspaces/$subscriptionId/subdomains': typeof AuthenticatedLayoutWorkspacesSubscriptionIdSubdomainsIndexRoute
  '/workspaces/$subscriptionId/suspect-score': typeof AuthenticatedLayoutWorkspacesSubscriptionIdSuspectScoreIndexRoute
  '/workspaces/$subscriptionId/visitors': typeof AuthenticatedLayoutWorkspacesSubscriptionIdVisitorsIndexRoute
  '/workspaces/$subscriptionId/webhooks': typeof AuthenticatedLayoutWorkspacesSubscriptionIdWebhooksIndexRoute
  '/workspaces/$subscriptionId/plan/cancel': typeof AuthenticatedWorkspacesSubscriptionIdPlanCancelIndexRoute
  '/workspaces/$subscriptionId/plan/downgrade': typeof AuthenticatedWorkspacesSubscriptionIdPlanDowngradeIndexRoute
  '/workspaces/$subscriptionId/rulesets/$rulesetId': typeof AuthenticatedWorkspacesSubscriptionIdRulesetsRulesetIdIndexLazyRoute
  '/workspaces/$subscriptionId/visits/$requestId': typeof AuthenticatedLayoutdeprecatedWorkspacesSubscriptionIdVisitsRequestIdRoute
  '/workspaces/$subscriptionId/bot-detection/events/$eventId': typeof AuthenticatedLayoutWorkspacesSubscriptionIdBotDetectionEventsEventIdRoute
  '/workspaces/$subscriptionId/events/$requestId/visitor-history': typeof AuthenticatedLayoutWorkspacesSubscriptionIdEventsRequestIdVisitorHistoryRoute
  '/workspaces/$subscriptionId/fraud-analysis/dataset/events': typeof AuthenticatedLayoutWorkspacesSubscriptionIdFraudAnalysisDatasetEventsRoute
  '/workspaces/$subscriptionId/integrations/$integrationTag/$environmentId': typeof AuthenticatedLayoutWorkspacesSubscriptionIdIntegrationsIntegrationTagEnvironmentIdRoute
  '/workspaces/$subscriptionId/integrations/$integrationTag/health': typeof AuthenticatedLayoutWorkspacesSubscriptionIdIntegrationsIntegrationTagHealthRoute
  '/workspaces/$subscriptionId/invoices/$invoiceId/forgiveness-request': typeof AuthenticatedLayoutWorkspacesSubscriptionIdInvoicesInvoiceIdForgivenessRequestRoute
  '/workspaces/$subscriptionId/visitors/$visitorId/events': typeof AuthenticatedLayoutWorkspacesSubscriptionIdVisitorsVisitorIdEventsRoute
  '/workspaces/$subscriptionId/visitors/$visitorId/ip-addresses': typeof AuthenticatedLayoutWorkspacesSubscriptionIdVisitorsVisitorIdIpAddressesRoute
  '/workspaces/$subscriptionId/visitors/$visitorId/location-history': typeof AuthenticatedLayoutWorkspacesSubscriptionIdVisitorsVisitorIdLocationHistoryRoute
  '/workspaces/$subscriptionId/visitors/$visitorId/related-visitors': typeof AuthenticatedLayoutWorkspacesSubscriptionIdVisitorsVisitorIdRelatedVisitorsRoute
  '/workspaces/$subscriptionId/visitors/$visitorId/smart-signals': typeof AuthenticatedLayoutWorkspacesSubscriptionIdVisitorsVisitorIdSmartSignalsRoute
  '/workspaces/$subscriptionId/webhooks/$webhookId/events': typeof AuthenticatedLayoutWorkspacesSubscriptionIdWebhooksWebhookIdEventsRoute
  '/workspaces/$subscriptionId/webhooks/$webhookId/verify': typeof AuthenticatedLayoutWorkspacesSubscriptionIdWebhooksWebhookIdVerifyRoute
  '/workspaces/$subscriptionId/api-keys/$tokenId': typeof AuthenticatedLayoutWorkspacesSubscriptionIdApiKeysTokenIdIndexRoute
  '/workspaces/$subscriptionId/bot-detection/events': typeof AuthenticatedLayoutWorkspacesSubscriptionIdBotDetectionEventsIndexRoute
  '/workspaces/$subscriptionId/events/$requestId': typeof AuthenticatedLayoutWorkspacesSubscriptionIdEventsRequestIdIndexRoute
  '/workspaces/$subscriptionId/fraud-analysis/dataset': typeof AuthenticatedLayoutWorkspacesSubscriptionIdFraudAnalysisDatasetIndexRoute
  '/workspaces/$subscriptionId/fraud-analysis/models': typeof AuthenticatedLayoutWorkspacesSubscriptionIdFraudAnalysisModelsIndexRoute
  '/workspaces/$subscriptionId/integrations/$integrationTag': typeof AuthenticatedLayoutWorkspacesSubscriptionIdIntegrationsIntegrationTagIndexRoute
  '/workspaces/$subscriptionId/integrations/cloudflare-flow': typeof AuthenticatedLayoutWorkspacesSubscriptionIdIntegrationsCloudflareFlowIndexRoute
  '/workspaces/$subscriptionId/invoices/$invoiceId': typeof AuthenticatedLayoutWorkspacesSubscriptionIdInvoicesInvoiceIdIndexRoute
  '/workspaces/$subscriptionId/visitors/$visitorId': typeof AuthenticatedLayoutWorkspacesSubscriptionIdVisitorsVisitorIdIndexRoute
  '/workspaces/$subscriptionId/integrations/cloudflare-flow/workers/$deploymentId': typeof AuthenticatedLayoutWorkspacesSubscriptionIdIntegrationsCloudflareFlowWorkersDeploymentIdRoute
  '/workspaces/$subscriptionId/fraud-analysis/models/$labelSlug': typeof AuthenticatedLayoutWorkspacesSubscriptionIdFraudAnalysisModelsLabelSlugIndexRoute
  '/workspaces/$subscriptionId/integrations/cloudflare-flow/workers': typeof AuthenticatedLayoutWorkspacesSubscriptionIdIntegrationsCloudflareFlowWorkersIndexRoute
  '/workspaces/$subscriptionId/fraud-analysis/models/$labelSlug/$clientType/$modelVersionId': typeof AuthenticatedLayoutWorkspacesSubscriptionIdFraudAnalysisModelsLabelSlugClientTypeModelVersionIdRoute
  '/workspaces/$subscriptionId/fraud-analysis/models/$labelSlug/$clientType/overview': typeof AuthenticatedLayoutWorkspacesSubscriptionIdFraudAnalysisModelsLabelSlugClientTypeOverviewRoute
  '/workspaces/$subscriptionId/fraud-analysis/models/$labelSlug/$clientType/versions': typeof AuthenticatedLayoutWorkspacesSubscriptionIdFraudAnalysisModelsLabelSlugClientTypeVersionsRoute
  '/workspaces/$subscriptionId/fraud-analysis/models/$labelSlug/$clientType': typeof AuthenticatedLayoutWorkspacesSubscriptionIdFraudAnalysisModelsLabelSlugClientTypeIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/_authenticated': typeof AuthenticatedRouteWithChildren
  '/_unauthenticated': typeof UnauthenticatedRouteWithChildren
  '/impersonate': typeof ImpersonateRoute
  '/unsubscribe': typeof UnsubscribeRouteWithChildren
  '/_authenticated/_layout': typeof AuthenticatedLayoutRouteWithChildren
  '/_authenticated/consent': typeof AuthenticatedConsentRoute
  '/_authenticated/mcp-auth': typeof AuthenticatedMcpAuthRoute
  '/_authenticated/mintlify_login': typeof AuthenticatedMintlify_loginRoute
  '/_authenticated/onboarding': typeof AuthenticatedOnboardingRoute
  '/_authenticated/readme_login': typeof AuthenticatedReadme_loginRoute
  '/_unauthenticated/login': typeof UnauthenticatedLoginRoute
  '/contact-sales/enterprise': typeof ContactSalesEnterpriseRoute
  '/newsletter/unsubscribe': typeof NewsletterUnsubscribeRoute
  '/unsubscribe/feedback': typeof UnsubscribeFeedbackRoute
  '/_authenticated/': typeof AuthenticatedIndexRoute
  '/unsubscribe/': typeof UnsubscribeIndexRoute
  '/_authenticated/_layout/$': typeof AuthenticatedLayoutSplatRoute
  '/_authenticated/workspaces/start': typeof AuthenticatedWorkspacesStartRoute
  '/_unauthenticated/invitation_confirmation/$id': typeof UnauthenticatedInvitation_confirmationIdRoute
  '/_unauthenticated/reset/$id': typeof UnauthenticatedResetIdRoute
  '/_unauthenticated/sso/callback': typeof UnauthenticatedSsoCallbackRoute
  '/signup/confirm/$signupIntent': typeof SignupConfirmSignupIntentRoute
  '/_unauthenticated/reset/': typeof UnauthenticatedResetIndexRoute
  '/_unauthenticated/reset_confirm/': typeof UnauthenticatedReset_confirmIndexRoute
  '/_unauthenticated/signup/': typeof UnauthenticatedSignupIndexRoute
  '/signup/confirm/': typeof SignupConfirmIndexRoute
  '/_authenticated/_layout/profile/notifications': typeof AuthenticatedLayoutProfileNotificationsRoute
  '/_authenticated/_layout/profile/settings': typeof AuthenticatedLayoutProfileSettingsRoute
  '/_authenticated/_layout/settings/users': typeof AuthenticatedLayoutSettingsUsersRoute
  '/_authenticated/_layout/settings/workspaces': typeof AuthenticatedLayoutSettingsWorkspacesRoute
  '/_authenticated/_layout/templates/$': typeof AuthenticatedLayoutTemplatesSplatRoute
  '/_authenticated/_layout/workspaces/$subscriptionId': typeof AuthenticatedLayoutWorkspacesSubscriptionIdRouteWithChildren
  '/_authenticated/_layout/(deprecated)/subscriptions/$': typeof AuthenticatedLayoutdeprecatedSubscriptionsSplatRoute
  '/_authenticated/_layout/settings/billing/migrate': typeof AuthenticatedLayoutSettingsBillingMigrateRoute
  '/_authenticated/_layout/workspaces/$subscriptionId/alerts': typeof AuthenticatedLayoutWorkspacesSubscriptionIdAlertsRoute
  '/_authenticated/_layout/workspaces/$subscriptionId/audit-log': typeof AuthenticatedLayoutWorkspacesSubscriptionIdAuditLogRoute
  '/_authenticated/_layout/workspaces/$subscriptionId/billing': typeof AuthenticatedLayoutWorkspacesSubscriptionIdBillingRoute
  '/_authenticated/_layout/workspaces/$subscriptionId/bot-detection': typeof AuthenticatedLayoutWorkspacesSubscriptionIdBotDetectionRouteWithChildren
  '/_authenticated/_layout/workspaces/$subscriptionId/botd': typeof AuthenticatedLayoutWorkspacesSubscriptionIdBotdRoute
  '/_authenticated/_layout/workspaces/$subscriptionId/environments': typeof AuthenticatedLayoutWorkspacesSubscriptionIdEnvironmentsRoute
  '/_authenticated/_layout/workspaces/$subscriptionId/fraud-analysis': typeof AuthenticatedLayoutWorkspacesSubscriptionIdFraudAnalysisRouteWithChildren
  '/_authenticated/_layout/workspaces/$subscriptionId/general': typeof AuthenticatedLayoutWorkspacesSubscriptionIdGeneralRoute
  '/_authenticated/_layout/workspaces/$subscriptionId/get-started': typeof AuthenticatedLayoutWorkspacesSubscriptionIdGetStartedRouteWithChildren
  '/_authenticated/_layout/workspaces/$subscriptionId/integrations': typeof AuthenticatedLayoutWorkspacesSubscriptionIdIntegrationsRouteWithChildren
  '/_authenticated/_layout/workspaces/$subscriptionId/mcp': typeof AuthenticatedLayoutWorkspacesSubscriptionIdMcpRoute
  '/_authenticated/_layout/workspaces/$subscriptionId/overview': typeof AuthenticatedLayoutWorkspacesSubscriptionIdOverviewRoute
  '/_authenticated/_layout/workspaces/$subscriptionId/plans': typeof AuthenticatedLayoutWorkspacesSubscriptionIdPlansRoute
  '/_authenticated/_layout/workspaces/$subscriptionId/smart-signals': typeof AuthenticatedLayoutWorkspacesSubscriptionIdSmartSignalsRoute
  '/_authenticated/_layout/workspaces/$subscriptionId/submit-bot': typeof AuthenticatedLayoutWorkspacesSubscriptionIdSubmitBotRoute
  '/_authenticated/_layout/workspaces/$subscriptionId/suspect-score': typeof AuthenticatedLayoutWorkspacesSubscriptionIdSuspectScoreRouteWithChildren
  '/_authenticated/_layout/workspaces/$subscriptionId/traffic-rules': typeof AuthenticatedLayoutWorkspacesSubscriptionIdTrafficRulesRoute
  '/_authenticated/workspaces/$subscriptionId/rulesets/$rulesetId': typeof AuthenticatedWorkspacesSubscriptionIdRulesetsRulesetIdRouteWithChildren
  '/_authenticated/workspaces/$subscriptionId/templates/$': typeof AuthenticatedWorkspacesSubscriptionIdTemplatesSplatRoute
  '/_authenticated/_layout/settings/billing/': typeof AuthenticatedLayoutSettingsBillingIndexRoute
  '/_authenticated/_layout/workspaces/$subscriptionId/': typeof AuthenticatedLayoutWorkspacesSubscriptionIdIndexRoute
  '/_authenticated/_layout/(deprecated)/workspaces/$subscriptionId/visits': typeof AuthenticatedLayoutdeprecatedWorkspacesSubscriptionIdVisitsRouteWithChildren
  '/_authenticated/_layout/workspaces/$subscriptionId/fraud-analysis/dataset': typeof AuthenticatedLayoutWorkspacesSubscriptionIdFraudAnalysisDatasetRouteWithChildren
  '/_authenticated/_layout/workspaces/$subscriptionId/fraud-analysis/unlock': typeof AuthenticatedLayoutWorkspacesSubscriptionIdFraudAnalysisUnlockRoute
  '/_authenticated/_layout/workspaces/$subscriptionId/fraud-analysis/upgrade': typeof AuthenticatedLayoutWorkspacesSubscriptionIdFraudAnalysisUpgradeRoute
  '/_authenticated/_layout/workspaces/$subscriptionId/fraud-analysis/upload': typeof AuthenticatedLayoutWorkspacesSubscriptionIdFraudAnalysisUploadRoute
  '/_authenticated/_layout/workspaces/$subscriptionId/get-started/$stepSlug': typeof AuthenticatedLayoutWorkspacesSubscriptionIdGetStartedStepSlugRoute
  '/_authenticated/_layout/workspaces/$subscriptionId/integrations/active': typeof AuthenticatedLayoutWorkspacesSubscriptionIdIntegrationsActiveRoute
  '/_authenticated/_layout/workspaces/$subscriptionId/integrations/directory': typeof AuthenticatedLayoutWorkspacesSubscriptionIdIntegrationsDirectoryRoute
  '/_authenticated/_layout/workspaces/$subscriptionId/plan/checkout-return': typeof AuthenticatedLayoutWorkspacesSubscriptionIdPlanCheckoutReturnRoute
  '/_authenticated/_layout/workspaces/$subscriptionId/plan/unpaid-invoices': typeof AuthenticatedLayoutWorkspacesSubscriptionIdPlanUnpaidInvoicesRoute
  '/_authenticated/_layout/workspaces/$subscriptionId/subdomains/$certificateId': typeof AuthenticatedLayoutWorkspacesSubscriptionIdSubdomainsCertificateIdRoute
  '/_authenticated/_layout/workspaces/$subscriptionId/suspect-score/analysis': typeof AuthenticatedLayoutWorkspacesSubscriptionIdSuspectScoreAnalysisRoute
  '/_authenticated/_layout/workspaces/$subscriptionId/visitors/$visitorId': typeof AuthenticatedLayoutWorkspacesSubscriptionIdVisitorsVisitorIdRouteWithChildren
  '/_authenticated/_layout/workspaces/$subscriptionId/visitors/avatars': typeof AuthenticatedLayoutWorkspacesSubscriptionIdVisitorsAvatarsRoute
  '/_authenticated/workspaces/$subscriptionId/plan/cancel/confirm': typeof AuthenticatedWorkspacesSubscriptionIdPlanCancelConfirmRoute
  '/_authenticated/workspaces/$subscriptionId/plan/downgrade/confirm': typeof AuthenticatedWorkspacesSubscriptionIdPlanDowngradeConfirmRoute
  '/_authenticated/workspaces/$subscriptionId/rulesets/templates/$templateSlug': typeof AuthenticatedWorkspacesSubscriptionIdRulesetsTemplatesTemplateSlugRoute
  '/_authenticated/_layout/workspaces/$subscriptionId/api-keys/': typeof AuthenticatedLayoutWorkspacesSubscriptionIdApiKeysIndexRoute
  '/_authenticated/_layout/workspaces/$subscriptionId/bot-detection/': typeof AuthenticatedLayoutWorkspacesSubscriptionIdBotDetectionIndexRoute
  '/_authenticated/_layout/workspaces/$subscriptionId/events/': typeof AuthenticatedLayoutWorkspacesSubscriptionIdEventsIndexRoute
  '/_authenticated/_layout/workspaces/$subscriptionId/fraud-analysis/': typeof AuthenticatedLayoutWorkspacesSubscriptionIdFraudAnalysisIndexRoute
  '/_authenticated/_layout/workspaces/$subscriptionId/get-started/': typeof AuthenticatedLayoutWorkspacesSubscriptionIdGetStartedIndexRoute
  '/_authenticated/_layout/workspaces/$subscriptionId/health/': typeof AuthenticatedLayoutWorkspacesSubscriptionIdHealthIndexRoute
  '/_authenticated/_layout/workspaces/$subscriptionId/integrations/': typeof AuthenticatedLayoutWorkspacesSubscriptionIdIntegrationsIndexRoute
  '/_authenticated/_layout/workspaces/$subscriptionId/plan/': typeof AuthenticatedLayoutWorkspacesSubscriptionIdPlanIndexRoute
  '/_authenticated/_layout/workspaces/$subscriptionId/rulesets/': typeof AuthenticatedLayoutWorkspacesSubscriptionIdRulesetsIndexRoute
  '/_authenticated/_layout/workspaces/$subscriptionId/subdomains/': typeof AuthenticatedLayoutWorkspacesSubscriptionIdSubdomainsIndexRoute
  '/_authenticated/_layout/workspaces/$subscriptionId/suspect-score/': typeof AuthenticatedLayoutWorkspacesSubscriptionIdSuspectScoreIndexRoute
  '/_authenticated/_layout/workspaces/$subscriptionId/visitors/': typeof AuthenticatedLayoutWorkspacesSubscriptionIdVisitorsIndexRoute
  '/_authenticated/_layout/workspaces/$subscriptionId/webhooks/': typeof AuthenticatedLayoutWorkspacesSubscriptionIdWebhooksIndexRoute
  '/_authenticated/workspaces/$subscriptionId/plan/cancel/': typeof AuthenticatedWorkspacesSubscriptionIdPlanCancelIndexRoute
  '/_authenticated/workspaces/$subscriptionId/plan/downgrade/': typeof AuthenticatedWorkspacesSubscriptionIdPlanDowngradeIndexRoute
  '/_authenticated/workspaces/$subscriptionId/rulesets/$rulesetId/': typeof AuthenticatedWorkspacesSubscriptionIdRulesetsRulesetIdIndexLazyRoute
  '/_authenticated/_layout/(deprecated)/workspaces/$subscriptionId/visits/$requestId': typeof AuthenticatedLayoutdeprecatedWorkspacesSubscriptionIdVisitsRequestIdRoute
  '/_authenticated/_layout/workspaces/$subscriptionId/bot-detection/events/$eventId': typeof AuthenticatedLayoutWorkspacesSubscriptionIdBotDetectionEventsEventIdRoute
  '/_authenticated/_layout/workspaces/$subscriptionId/events/$requestId/visitor-history': typeof AuthenticatedLayoutWorkspacesSubscriptionIdEventsRequestIdVisitorHistoryRoute
  '/_authenticated/_layout/workspaces/$subscriptionId/fraud-analysis/dataset/events': typeof AuthenticatedLayoutWorkspacesSubscriptionIdFraudAnalysisDatasetEventsRoute
  '/_authenticated/_layout/workspaces/$subscriptionId/integrations/$integrationTag/$environmentId': typeof AuthenticatedLayoutWorkspacesSubscriptionIdIntegrationsIntegrationTagEnvironmentIdRoute
  '/_authenticated/_layout/workspaces/$subscriptionId/integrations/$integrationTag/health': typeof AuthenticatedLayoutWorkspacesSubscriptionIdIntegrationsIntegrationTagHealthRoute
  '/_authenticated/_layout/workspaces/$subscriptionId/invoices/$invoiceId/forgiveness-request': typeof AuthenticatedLayoutWorkspacesSubscriptionIdInvoicesInvoiceIdForgivenessRequestRoute
  '/_authenticated/_layout/workspaces/$subscriptionId/visitors/$visitorId/events': typeof AuthenticatedLayoutWorkspacesSubscriptionIdVisitorsVisitorIdEventsRoute
  '/_authenticated/_layout/workspaces/$subscriptionId/visitors/$visitorId/ip-addresses': typeof AuthenticatedLayoutWorkspacesSubscriptionIdVisitorsVisitorIdIpAddressesRoute
  '/_authenticated/_layout/workspaces/$subscriptionId/visitors/$visitorId/location-history': typeof AuthenticatedLayoutWorkspacesSubscriptionIdVisitorsVisitorIdLocationHistoryRoute
  '/_authenticated/_layout/workspaces/$subscriptionId/visitors/$visitorId/related-visitors': typeof AuthenticatedLayoutWorkspacesSubscriptionIdVisitorsVisitorIdRelatedVisitorsRoute
  '/_authenticated/_layout/workspaces/$subscriptionId/visitors/$visitorId/smart-signals': typeof AuthenticatedLayoutWorkspacesSubscriptionIdVisitorsVisitorIdSmartSignalsRoute
  '/_authenticated/_layout/workspaces/$subscriptionId/webhooks/$webhookId/events': typeof AuthenticatedLayoutWorkspacesSubscriptionIdWebhooksWebhookIdEventsRoute
  '/_authenticated/_layout/workspaces/$subscriptionId/webhooks/$webhookId/verify': typeof AuthenticatedLayoutWorkspacesSubscriptionIdWebhooksWebhookIdVerifyRoute
  '/_authenticated/_layout/workspaces/$subscriptionId/api-keys/$tokenId/': typeof AuthenticatedLayoutWorkspacesSubscriptionIdApiKeysTokenIdIndexRoute
  '/_authenticated/_layout/workspaces/$subscriptionId/bot-detection/events/': typeof AuthenticatedLayoutWorkspacesSubscriptionIdBotDetectionEventsIndexRoute
  '/_authenticated/_layout/workspaces/$subscriptionId/events/$requestId/': typeof AuthenticatedLayoutWorkspacesSubscriptionIdEventsRequestIdIndexRoute
  '/_authenticated/_layout/workspaces/$subscriptionId/fraud-analysis/dataset/': typeof AuthenticatedLayoutWorkspacesSubscriptionIdFraudAnalysisDatasetIndexRoute
  '/_authenticated/_layout/workspaces/$subscriptionId/fraud-analysis/models/': typeof AuthenticatedLayoutWorkspacesSubscriptionIdFraudAnalysisModelsIndexRoute
  '/_authenticated/_layout/workspaces/$subscriptionId/integrations/$integrationTag/': typeof AuthenticatedLayoutWorkspacesSubscriptionIdIntegrationsIntegrationTagIndexRoute
  '/_authenticated/_layout/workspaces/$subscriptionId/integrations/cloudflare-flow/': typeof AuthenticatedLayoutWorkspacesSubscriptionIdIntegrationsCloudflareFlowIndexRoute
  '/_authenticated/_layout/workspaces/$subscriptionId/invoices/$invoiceId/': typeof AuthenticatedLayoutWorkspacesSubscriptionIdInvoicesInvoiceIdIndexRoute
  '/_authenticated/_layout/workspaces/$subscriptionId/visitors/$visitorId/': typeof AuthenticatedLayoutWorkspacesSubscriptionIdVisitorsVisitorIdIndexRoute
  '/_authenticated/_layout/workspaces/$subscriptionId/fraud-analysis/models/$labelSlug/$clientType': typeof AuthenticatedLayoutWorkspacesSubscriptionIdFraudAnalysisModelsLabelSlugClientTypeRouteWithChildren
  '/_authenticated/_layout/workspaces/$subscriptionId/integrations/cloudflare-flow/workers/$deploymentId': typeof AuthenticatedLayoutWorkspacesSubscriptionIdIntegrationsCloudflareFlowWorkersDeploymentIdRoute
  '/_authenticated/_layout/workspaces/$subscriptionId/fraud-analysis/models/$labelSlug/': typeof AuthenticatedLayoutWorkspacesSubscriptionIdFraudAnalysisModelsLabelSlugIndexRoute
  '/_authenticated/_layout/workspaces/$subscriptionId/integrations/cloudflare-flow/workers/': typeof AuthenticatedLayoutWorkspacesSubscriptionIdIntegrationsCloudflareFlowWorkersIndexRoute
  '/_authenticated/_layout/workspaces/$subscriptionId/fraud-analysis/models/$labelSlug/$clientType/$modelVersionId': typeof AuthenticatedLayoutWorkspacesSubscriptionIdFraudAnalysisModelsLabelSlugClientTypeModelVersionIdRoute
  '/_authenticated/_layout/workspaces/$subscriptionId/fraud-analysis/models/$labelSlug/$clientType/overview': typeof AuthenticatedLayoutWorkspacesSubscriptionIdFraudAnalysisModelsLabelSlugClientTypeOverviewRoute
  '/_authenticated/_layout/workspaces/$subscriptionId/fraud-analysis/models/$labelSlug/$clientType/versions': typeof AuthenticatedLayoutWorkspacesSubscriptionIdFraudAnalysisModelsLabelSlugClientTypeVersionsRoute
  '/_authenticated/_layout/workspaces/$subscriptionId/fraud-analysis/models/$labelSlug/$clientType/': typeof AuthenticatedLayoutWorkspacesSubscriptionIdFraudAnalysisModelsLabelSlugClientTypeIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/impersonate'
    | '/unsubscribe'
    | '/consent'
    | '/mcp-auth'
    | '/mintlify_login'
    | '/onboarding'
    | '/readme_login'
    | '/login'
    | '/contact-sales/enterprise'
    | '/newsletter/unsubscribe'
    | '/unsubscribe/feedback'
    | '/unsubscribe/'
    | '/$'
    | '/workspaces/start'
    | '/invitation_confirmation/$id'
    | '/reset/$id'
    | '/sso/callback'
    | '/signup/confirm/$signupIntent'
    | '/reset/'
    | '/reset_confirm/'
    | '/signup/'
    | '/signup/confirm/'
    | '/profile/notifications'
    | '/profile/settings'
    | '/settings/users'
    | '/settings/workspaces'
    | '/templates/$'
    | '/workspaces/$subscriptionId'
    | '/subscriptions/$'
    | '/settings/billing/migrate'
    | '/workspaces/$subscriptionId/alerts'
    | '/workspaces/$subscriptionId/audit-log'
    | '/workspaces/$subscriptionId/billing'
    | '/workspaces/$subscriptionId/bot-detection'
    | '/workspaces/$subscriptionId/botd'
    | '/workspaces/$subscriptionId/environments'
    | '/workspaces/$subscriptionId/fraud-analysis'
    | '/workspaces/$subscriptionId/general'
    | '/workspaces/$subscriptionId/get-started'
    | '/workspaces/$subscriptionId/integrations'
    | '/workspaces/$subscriptionId/mcp'
    | '/workspaces/$subscriptionId/overview'
    | '/workspaces/$subscriptionId/plans'
    | '/workspaces/$subscriptionId/smart-signals'
    | '/workspaces/$subscriptionId/submit-bot'
    | '/workspaces/$subscriptionId/suspect-score'
    | '/workspaces/$subscriptionId/traffic-rules'
    | '/workspaces/$subscriptionId/rulesets/$rulesetId'
    | '/workspaces/$subscriptionId/templates/$'
    | '/settings/billing/'
    | '/workspaces/$subscriptionId/'
    | '/workspaces/$subscriptionId/visits'
    | '/workspaces/$subscriptionId/fraud-analysis/dataset'
    | '/workspaces/$subscriptionId/fraud-analysis/unlock'
    | '/workspaces/$subscriptionId/fraud-analysis/upgrade'
    | '/workspaces/$subscriptionId/fraud-analysis/upload'
    | '/workspaces/$subscriptionId/get-started/$stepSlug'
    | '/workspaces/$subscriptionId/integrations/active'
    | '/workspaces/$subscriptionId/integrations/directory'
    | '/workspaces/$subscriptionId/plan/checkout-return'
    | '/workspaces/$subscriptionId/plan/unpaid-invoices'
    | '/workspaces/$subscriptionId/subdomains/$certificateId'
    | '/workspaces/$subscriptionId/suspect-score/analysis'
    | '/workspaces/$subscriptionId/visitors/$visitorId'
    | '/workspaces/$subscriptionId/visitors/avatars'
    | '/workspaces/$subscriptionId/plan/cancel/confirm'
    | '/workspaces/$subscriptionId/plan/downgrade/confirm'
    | '/workspaces/$subscriptionId/rulesets/templates/$templateSlug'
    | '/workspaces/$subscriptionId/api-keys/'
    | '/workspaces/$subscriptionId/bot-detection/'
    | '/workspaces/$subscriptionId/events/'
    | '/workspaces/$subscriptionId/fraud-analysis/'
    | '/workspaces/$subscriptionId/get-started/'
    | '/workspaces/$subscriptionId/health/'
    | '/workspaces/$subscriptionId/integrations/'
    | '/workspaces/$subscriptionId/plan/'
    | '/workspaces/$subscriptionId/rulesets/'
    | '/workspaces/$subscriptionId/subdomains/'
    | '/workspaces/$subscriptionId/suspect-score/'
    | '/workspaces/$subscriptionId/visitors/'
    | '/workspaces/$subscriptionId/webhooks/'
    | '/workspaces/$subscriptionId/plan/cancel/'
    | '/workspaces/$subscriptionId/plan/downgrade/'
    | '/workspaces/$subscriptionId/rulesets/$rulesetId/'
    | '/workspaces/$subscriptionId/visits/$requestId'
    | '/workspaces/$subscriptionId/bot-detection/events/$eventId'
    | '/workspaces/$subscriptionId/events/$requestId/visitor-history'
    | '/workspaces/$subscriptionId/fraud-analysis/dataset/events'
    | '/workspaces/$subscriptionId/integrations/$integrationTag/$environmentId'
    | '/workspaces/$subscriptionId/integrations/$integrationTag/health'
    | '/workspaces/$subscriptionId/invoices/$invoiceId/forgiveness-request'
    | '/workspaces/$subscriptionId/visitors/$visitorId/events'
    | '/workspaces/$subscriptionId/visitors/$visitorId/ip-addresses'
    | '/workspaces/$subscriptionId/visitors/$visitorId/location-history'
    | '/workspaces/$subscriptionId/visitors/$visitorId/related-visitors'
    | '/workspaces/$subscriptionId/visitors/$visitorId/smart-signals'
    | '/workspaces/$subscriptionId/webhooks/$webhookId/events'
    | '/workspaces/$subscriptionId/webhooks/$webhookId/verify'
    | '/workspaces/$subscriptionId/api-keys/$tokenId/'
    | '/workspaces/$subscriptionId/bot-detection/events/'
    | '/workspaces/$subscriptionId/events/$requestId/'
    | '/workspaces/$subscriptionId/fraud-analysis/dataset/'
    | '/workspaces/$subscriptionId/fraud-analysis/models/'
    | '/workspaces/$subscriptionId/integrations/$integrationTag/'
    | '/workspaces/$subscriptionId/integrations/cloudflare-flow/'
    | '/workspaces/$subscriptionId/invoices/$invoiceId/'
    | '/workspaces/$subscriptionId/visitors/$visitorId/'
    | '/workspaces/$subscriptionId/fraud-analysis/models/$labelSlug/$clientType'
    | '/workspaces/$subscriptionId/integrations/cloudflare-flow/workers/$deploymentId'
    | '/workspaces/$subscriptionId/fraud-analysis/models/$labelSlug/'
    | '/workspaces/$subscriptionId/integrations/cloudflare-flow/workers/'
    | '/workspaces/$subscriptionId/fraud-analysis/models/$labelSlug/$clientType/$modelVersionId'
    | '/workspaces/$subscriptionId/fraud-analysis/models/$labelSlug/$clientType/overview'
    | '/workspaces/$subscriptionId/fraud-analysis/models/$labelSlug/$clientType/versions'
    | '/workspaces/$subscriptionId/fraud-analysis/models/$labelSlug/$clientType/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/impersonate'
    | '/consent'
    | '/mcp-auth'
    | '/mintlify_login'
    | '/onboarding'
    | '/readme_login'
    | '/login'
    | '/contact-sales/enterprise'
    | '/newsletter/unsubscribe'
    | '/unsubscribe/feedback'
    | '/unsubscribe'
    | '/$'
    | '/workspaces/start'
    | '/invitation_confirmation/$id'
    | '/reset/$id'
    | '/sso/callback'
    | '/signup/confirm/$signupIntent'
    | '/reset'
    | '/reset_confirm'
    | '/signup'
    | '/signup/confirm'
    | '/profile/notifications'
    | '/profile/settings'
    | '/settings/users'
    | '/settings/workspaces'
    | '/templates/$'
    | '/subscriptions/$'
    | '/settings/billing/migrate'
    | '/workspaces/$subscriptionId/alerts'
    | '/workspaces/$subscriptionId/audit-log'
    | '/workspaces/$subscriptionId/billing'
    | '/workspaces/$subscriptionId/botd'
    | '/workspaces/$subscriptionId/environments'
    | '/workspaces/$subscriptionId/general'
    | '/workspaces/$subscriptionId/mcp'
    | '/workspaces/$subscriptionId/overview'
    | '/workspaces/$subscriptionId/plans'
    | '/workspaces/$subscriptionId/smart-signals'
    | '/workspaces/$subscriptionId/submit-bot'
    | '/workspaces/$subscriptionId/traffic-rules'
    | '/workspaces/$subscriptionId/templates/$'
    | '/settings/billing'
    | '/workspaces/$subscriptionId'
    | '/workspaces/$subscriptionId/visits'
    | '/workspaces/$subscriptionId/fraud-analysis/unlock'
    | '/workspaces/$subscriptionId/fraud-analysis/upgrade'
    | '/workspaces/$subscriptionId/fraud-analysis/upload'
    | '/workspaces/$subscriptionId/get-started/$stepSlug'
    | '/workspaces/$subscriptionId/integrations/active'
    | '/workspaces/$subscriptionId/integrations/directory'
    | '/workspaces/$subscriptionId/plan/checkout-return'
    | '/workspaces/$subscriptionId/plan/unpaid-invoices'
    | '/workspaces/$subscriptionId/subdomains/$certificateId'
    | '/workspaces/$subscriptionId/suspect-score/analysis'
    | '/workspaces/$subscriptionId/visitors/avatars'
    | '/workspaces/$subscriptionId/plan/cancel/confirm'
    | '/workspaces/$subscriptionId/plan/downgrade/confirm'
    | '/workspaces/$subscriptionId/rulesets/templates/$templateSlug'
    | '/workspaces/$subscriptionId/api-keys'
    | '/workspaces/$subscriptionId/bot-detection'
    | '/workspaces/$subscriptionId/events'
    | '/workspaces/$subscriptionId/fraud-analysis'
    | '/workspaces/$subscriptionId/get-started'
    | '/workspaces/$subscriptionId/health'
    | '/workspaces/$subscriptionId/integrations'
    | '/workspaces/$subscriptionId/plan'
    | '/workspaces/$subscriptionId/rulesets'
    | '/workspaces/$subscriptionId/subdomains'
    | '/workspaces/$subscriptionId/suspect-score'
    | '/workspaces/$subscriptionId/visitors'
    | '/workspaces/$subscriptionId/webhooks'
    | '/workspaces/$subscriptionId/plan/cancel'
    | '/workspaces/$subscriptionId/plan/downgrade'
    | '/workspaces/$subscriptionId/rulesets/$rulesetId'
    | '/workspaces/$subscriptionId/visits/$requestId'
    | '/workspaces/$subscriptionId/bot-detection/events/$eventId'
    | '/workspaces/$subscriptionId/events/$requestId/visitor-history'
    | '/workspaces/$subscriptionId/fraud-analysis/dataset/events'
    | '/workspaces/$subscriptionId/integrations/$integrationTag/$environmentId'
    | '/workspaces/$subscriptionId/integrations/$integrationTag/health'
    | '/workspaces/$subscriptionId/invoices/$invoiceId/forgiveness-request'
    | '/workspaces/$subscriptionId/visitors/$visitorId/events'
    | '/workspaces/$subscriptionId/visitors/$visitorId/ip-addresses'
    | '/workspaces/$subscriptionId/visitors/$visitorId/location-history'
    | '/workspaces/$subscriptionId/visitors/$visitorId/related-visitors'
    | '/workspaces/$subscriptionId/visitors/$visitorId/smart-signals'
    | '/workspaces/$subscriptionId/webhooks/$webhookId/events'
    | '/workspaces/$subscriptionId/webhooks/$webhookId/verify'
    | '/workspaces/$subscriptionId/api-keys/$tokenId'
    | '/workspaces/$subscriptionId/bot-detection/events'
    | '/workspaces/$subscriptionId/events/$requestId'
    | '/workspaces/$subscriptionId/fraud-analysis/dataset'
    | '/workspaces/$subscriptionId/fraud-analysis/models'
    | '/workspaces/$subscriptionId/integrations/$integrationTag'
    | '/workspaces/$subscriptionId/integrations/cloudflare-flow'
    | '/workspaces/$subscriptionId/invoices/$invoiceId'
    | '/workspaces/$subscriptionId/visitors/$visitorId'
    | '/workspaces/$subscriptionId/integrations/cloudflare-flow/workers/$deploymentId'
    | '/workspaces/$subscriptionId/fraud-analysis/models/$labelSlug'
    | '/workspaces/$subscriptionId/integrations/cloudflare-flow/workers'
    | '/workspaces/$subscriptionId/fraud-analysis/models/$labelSlug/$clientType/$modelVersionId'
    | '/workspaces/$subscriptionId/fraud-analysis/models/$labelSlug/$clientType/overview'
    | '/workspaces/$subscriptionId/fraud-analysis/models/$labelSlug/$clientType/versions'
    | '/workspaces/$subscriptionId/fraud-analysis/models/$labelSlug/$clientType'
  id:
    | '__root__'
    | '/_authenticated'
    | '/_unauthenticated'
    | '/impersonate'
    | '/unsubscribe'
    | '/_authenticated/_layout'
    | '/_authenticated/consent'
    | '/_authenticated/mcp-auth'
    | '/_authenticated/mintlify_login'
    | '/_authenticated/onboarding'
    | '/_authenticated/readme_login'
    | '/_unauthenticated/login'
    | '/contact-sales/enterprise'
    | '/newsletter/unsubscribe'
    | '/unsubscribe/feedback'
    | '/_authenticated/'
    | '/unsubscribe/'
    | '/_authenticated/_layout/$'
    | '/_authenticated/workspaces/start'
    | '/_unauthenticated/invitation_confirmation/$id'
    | '/_unauthenticated/reset/$id'
    | '/_unauthenticated/sso/callback'
    | '/signup/confirm/$signupIntent'
    | '/_unauthenticated/reset/'
    | '/_unauthenticated/reset_confirm/'
    | '/_unauthenticated/signup/'
    | '/signup/confirm/'
    | '/_authenticated/_layout/profile/notifications'
    | '/_authenticated/_layout/profile/settings'
    | '/_authenticated/_layout/settings/users'
    | '/_authenticated/_layout/settings/workspaces'
    | '/_authenticated/_layout/templates/$'
    | '/_authenticated/_layout/workspaces/$subscriptionId'
    | '/_authenticated/_layout/(deprecated)/subscriptions/$'
    | '/_authenticated/_layout/settings/billing/migrate'
    | '/_authenticated/_layout/workspaces/$subscriptionId/alerts'
    | '/_authenticated/_layout/workspaces/$subscriptionId/audit-log'
    | '/_authenticated/_layout/workspaces/$subscriptionId/billing'
    | '/_authenticated/_layout/workspaces/$subscriptionId/bot-detection'
    | '/_authenticated/_layout/workspaces/$subscriptionId/botd'
    | '/_authenticated/_layout/workspaces/$subscriptionId/environments'
    | '/_authenticated/_layout/workspaces/$subscriptionId/fraud-analysis'
    | '/_authenticated/_layout/workspaces/$subscriptionId/general'
    | '/_authenticated/_layout/workspaces/$subscriptionId/get-started'
    | '/_authenticated/_layout/workspaces/$subscriptionId/integrations'
    | '/_authenticated/_layout/workspaces/$subscriptionId/mcp'
    | '/_authenticated/_layout/workspaces/$subscriptionId/overview'
    | '/_authenticated/_layout/workspaces/$subscriptionId/plans'
    | '/_authenticated/_layout/workspaces/$subscriptionId/smart-signals'
    | '/_authenticated/_layout/workspaces/$subscriptionId/submit-bot'
    | '/_authenticated/_layout/workspaces/$subscriptionId/suspect-score'
    | '/_authenticated/_layout/workspaces/$subscriptionId/traffic-rules'
    | '/_authenticated/workspaces/$subscriptionId/rulesets/$rulesetId'
    | '/_authenticated/workspaces/$subscriptionId/templates/$'
    | '/_authenticated/_layout/settings/billing/'
    | '/_authenticated/_layout/workspaces/$subscriptionId/'
    | '/_authenticated/_layout/(deprecated)/workspaces/$subscriptionId/visits'
    | '/_authenticated/_layout/workspaces/$subscriptionId/fraud-analysis/dataset'
    | '/_authenticated/_layout/workspaces/$subscriptionId/fraud-analysis/unlock'
    | '/_authenticated/_layout/workspaces/$subscriptionId/fraud-analysis/upgrade'
    | '/_authenticated/_layout/workspaces/$subscriptionId/fraud-analysis/upload'
    | '/_authenticated/_layout/workspaces/$subscriptionId/get-started/$stepSlug'
    | '/_authenticated/_layout/workspaces/$subscriptionId/integrations/active'
    | '/_authenticated/_layout/workspaces/$subscriptionId/integrations/directory'
    | '/_authenticated/_layout/workspaces/$subscriptionId/plan/checkout-return'
    | '/_authenticated/_layout/workspaces/$subscriptionId/plan/unpaid-invoices'
    | '/_authenticated/_layout/workspaces/$subscriptionId/subdomains/$certificateId'
    | '/_authenticated/_layout/workspaces/$subscriptionId/suspect-score/analysis'
    | '/_authenticated/_layout/workspaces/$subscriptionId/visitors/$visitorId'
    | '/_authenticated/_layout/workspaces/$subscriptionId/visitors/avatars'
    | '/_authenticated/workspaces/$subscriptionId/plan/cancel/confirm'
    | '/_authenticated/workspaces/$subscriptionId/plan/downgrade/confirm'
    | '/_authenticated/workspaces/$subscriptionId/rulesets/templates/$templateSlug'
    | '/_authenticated/_layout/workspaces/$subscriptionId/api-keys/'
    | '/_authenticated/_layout/workspaces/$subscriptionId/bot-detection/'
    | '/_authenticated/_layout/workspaces/$subscriptionId/events/'
    | '/_authenticated/_layout/workspaces/$subscriptionId/fraud-analysis/'
    | '/_authenticated/_layout/workspaces/$subscriptionId/get-started/'
    | '/_authenticated/_layout/workspaces/$subscriptionId/health/'
    | '/_authenticated/_layout/workspaces/$subscriptionId/integrations/'
    | '/_authenticated/_layout/workspaces/$subscriptionId/plan/'
    | '/_authenticated/_layout/workspaces/$subscriptionId/rulesets/'
    | '/_authenticated/_layout/workspaces/$subscriptionId/subdomains/'
    | '/_authenticated/_layout/workspaces/$subscriptionId/suspect-score/'
    | '/_authenticated/_layout/workspaces/$subscriptionId/visitors/'
    | '/_authenticated/_layout/workspaces/$subscriptionId/webhooks/'
    | '/_authenticated/workspaces/$subscriptionId/plan/cancel/'
    | '/_authenticated/workspaces/$subscriptionId/plan/downgrade/'
    | '/_authenticated/workspaces/$subscriptionId/rulesets/$rulesetId/'
    | '/_authenticated/_layout/(deprecated)/workspaces/$subscriptionId/visits/$requestId'
    | '/_authenticated/_layout/workspaces/$subscriptionId/bot-detection/events/$eventId'
    | '/_authenticated/_layout/workspaces/$subscriptionId/events/$requestId/visitor-history'
    | '/_authenticated/_layout/workspaces/$subscriptionId/fraud-analysis/dataset/events'
    | '/_authenticated/_layout/workspaces/$subscriptionId/integrations/$integrationTag/$environmentId'
    | '/_authenticated/_layout/workspaces/$subscriptionId/integrations/$integrationTag/health'
    | '/_authenticated/_layout/workspaces/$subscriptionId/invoices/$invoiceId/forgiveness-request'
    | '/_authenticated/_layout/workspaces/$subscriptionId/visitors/$visitorId/events'
    | '/_authenticated/_layout/workspaces/$subscriptionId/visitors/$visitorId/ip-addresses'
    | '/_authenticated/_layout/workspaces/$subscriptionId/visitors/$visitorId/location-history'
    | '/_authenticated/_layout/workspaces/$subscriptionId/visitors/$visitorId/related-visitors'
    | '/_authenticated/_layout/workspaces/$subscriptionId/visitors/$visitorId/smart-signals'
    | '/_authenticated/_layout/workspaces/$subscriptionId/webhooks/$webhookId/events'
    | '/_authenticated/_layout/workspaces/$subscriptionId/webhooks/$webhookId/verify'
    | '/_authenticated/_layout/workspaces/$subscriptionId/api-keys/$tokenId/'
    | '/_authenticated/_layout/workspaces/$subscriptionId/bot-detection/events/'
    | '/_authenticated/_layout/workspaces/$subscriptionId/events/$requestId/'
    | '/_authenticated/_layout/workspaces/$subscriptionId/fraud-analysis/dataset/'
    | '/_authenticated/_layout/workspaces/$subscriptionId/fraud-analysis/models/'
    | '/_authenticated/_layout/workspaces/$subscriptionId/integrations/$integrationTag/'
    | '/_authenticated/_layout/workspaces/$subscriptionId/integrations/cloudflare-flow/'
    | '/_authenticated/_layout/workspaces/$subscriptionId/invoices/$invoiceId/'
    | '/_authenticated/_layout/workspaces/$subscriptionId/visitors/$visitorId/'
    | '/_authenticated/_layout/workspaces/$subscriptionId/fraud-analysis/models/$labelSlug/$clientType'
    | '/_authenticated/_layout/workspaces/$subscriptionId/integrations/cloudflare-flow/workers/$deploymentId'
    | '/_authenticated/_layout/workspaces/$subscriptionId/fraud-analysis/models/$labelSlug/'
    | '/_authenticated/_layout/workspaces/$subscriptionId/integrations/cloudflare-flow/workers/'
    | '/_authenticated/_layout/workspaces/$subscriptionId/fraud-analysis/models/$labelSlug/$clientType/$modelVersionId'
    | '/_authenticated/_layout/workspaces/$subscriptionId/fraud-analysis/models/$labelSlug/$clientType/overview'
    | '/_authenticated/_layout/workspaces/$subscriptionId/fraud-analysis/models/$labelSlug/$clientType/versions'
    | '/_authenticated/_layout/workspaces/$subscriptionId/fraud-analysis/models/$labelSlug/$clientType/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  AuthenticatedRoute: typeof AuthenticatedRouteWithChildren
  UnauthenticatedRoute: typeof UnauthenticatedRouteWithChildren
  ImpersonateRoute: typeof ImpersonateRoute
  UnsubscribeRoute: typeof UnsubscribeRouteWithChildren
  ContactSalesEnterpriseRoute: typeof ContactSalesEnterpriseRoute
  NewsletterUnsubscribeRoute: typeof NewsletterUnsubscribeRoute
  SignupConfirmSignupIntentRoute: typeof SignupConfirmSignupIntentRoute
  SignupConfirmIndexRoute: typeof SignupConfirmIndexRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/_authenticated': {
      id: '/_authenticated'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AuthenticatedRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_unauthenticated': {
      id: '/_unauthenticated'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof UnauthenticatedRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/impersonate': {
      id: '/impersonate'
      path: '/impersonate'
      fullPath: '/impersonate'
      preLoaderRoute: typeof ImpersonateRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/unsubscribe': {
      id: '/unsubscribe'
      path: '/unsubscribe'
      fullPath: '/unsubscribe'
      preLoaderRoute: typeof UnsubscribeRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authenticated/': {
      id: '/_authenticated/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof AuthenticatedIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/_layout': {
      id: '/_authenticated/_layout'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AuthenticatedLayoutRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/consent': {
      id: '/_authenticated/consent'
      path: '/consent'
      fullPath: '/consent'
      preLoaderRoute: typeof AuthenticatedConsentRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/mcp-auth': {
      id: '/_authenticated/mcp-auth'
      path: '/mcp-auth'
      fullPath: '/mcp-auth'
      preLoaderRoute: typeof AuthenticatedMcpAuthRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/mintlify_login': {
      id: '/_authenticated/mintlify_login'
      path: '/mintlify_login'
      fullPath: '/mintlify_login'
      preLoaderRoute: typeof AuthenticatedMintlify_loginRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/onboarding': {
      id: '/_authenticated/onboarding'
      path: '/onboarding'
      fullPath: '/onboarding'
      preLoaderRoute: typeof AuthenticatedOnboardingRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/readme_login': {
      id: '/_authenticated/readme_login'
      path: '/readme_login'
      fullPath: '/readme_login'
      preLoaderRoute: typeof AuthenticatedReadme_loginRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_unauthenticated/login': {
      id: '/_unauthenticated/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof UnauthenticatedLoginRouteImport
      parentRoute: typeof UnauthenticatedRoute
    }
    '/contact-sales/enterprise': {
      id: '/contact-sales/enterprise'
      path: '/contact-sales/enterprise'
      fullPath: '/contact-sales/enterprise'
      preLoaderRoute: typeof ContactSalesEnterpriseRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/newsletter/unsubscribe': {
      id: '/newsletter/unsubscribe'
      path: '/newsletter/unsubscribe'
      fullPath: '/newsletter/unsubscribe'
      preLoaderRoute: typeof NewsletterUnsubscribeRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/unsubscribe/': {
      id: '/unsubscribe/'
      path: '/'
      fullPath: '/unsubscribe/'
      preLoaderRoute: typeof UnsubscribeIndexRouteImport
      parentRoute: typeof UnsubscribeRoute
    }
    '/unsubscribe/feedback': {
      id: '/unsubscribe/feedback'
      path: '/feedback'
      fullPath: '/unsubscribe/feedback'
      preLoaderRoute: typeof UnsubscribeFeedbackRouteImport
      parentRoute: typeof UnsubscribeRoute
    }
    '/_authenticated/_layout/$': {
      id: '/_authenticated/_layout/$'
      path: '/$'
      fullPath: '/$'
      preLoaderRoute: typeof AuthenticatedLayoutSplatRouteImport
      parentRoute: typeof AuthenticatedLayoutRoute
    }
    '/_authenticated/workspaces/start': {
      id: '/_authenticated/workspaces/start'
      path: '/workspaces/start'
      fullPath: '/workspaces/start'
      preLoaderRoute: typeof AuthenticatedWorkspacesStartRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_unauthenticated/invitation_confirmation/$id': {
      id: '/_unauthenticated/invitation_confirmation/$id'
      path: '/invitation_confirmation/$id'
      fullPath: '/invitation_confirmation/$id'
      preLoaderRoute: typeof UnauthenticatedInvitation_confirmationIdRouteImport
      parentRoute: typeof UnauthenticatedRoute
    }
    '/_unauthenticated/reset/': {
      id: '/_unauthenticated/reset/'
      path: '/reset'
      fullPath: '/reset/'
      preLoaderRoute: typeof UnauthenticatedResetIndexRouteImport
      parentRoute: typeof UnauthenticatedRoute
    }
    '/_unauthenticated/reset/$id': {
      id: '/_unauthenticated/reset/$id'
      path: '/reset/$id'
      fullPath: '/reset/$id'
      preLoaderRoute: typeof UnauthenticatedResetIdRouteImport
      parentRoute: typeof UnauthenticatedRoute
    }
    '/_unauthenticated/reset_confirm/': {
      id: '/_unauthenticated/reset_confirm/'
      path: '/reset_confirm'
      fullPath: '/reset_confirm/'
      preLoaderRoute: typeof UnauthenticatedReset_confirmIndexRouteImport
      parentRoute: typeof UnauthenticatedRoute
    }
    '/_unauthenticated/signup/': {
      id: '/_unauthenticated/signup/'
      path: '/signup'
      fullPath: '/signup/'
      preLoaderRoute: typeof UnauthenticatedSignupIndexRouteImport
      parentRoute: typeof UnauthenticatedRoute
    }
    '/_unauthenticated/sso/callback': {
      id: '/_unauthenticated/sso/callback'
      path: '/sso/callback'
      fullPath: '/sso/callback'
      preLoaderRoute: typeof UnauthenticatedSsoCallbackRouteImport
      parentRoute: typeof UnauthenticatedRoute
    }
    '/signup/confirm/': {
      id: '/signup/confirm/'
      path: '/signup/confirm'
      fullPath: '/signup/confirm/'
      preLoaderRoute: typeof SignupConfirmIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/signup/confirm/$signupIntent': {
      id: '/signup/confirm/$signupIntent'
      path: '/signup/confirm/$signupIntent'
      fullPath: '/signup/confirm/$signupIntent'
      preLoaderRoute: typeof SignupConfirmSignupIntentRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authenticated/_layout/profile/notifications': {
      id: '/_authenticated/_layout/profile/notifications'
      path: '/profile/notifications'
      fullPath: '/profile/notifications'
      preLoaderRoute: typeof AuthenticatedLayoutProfileNotificationsRouteImport
      parentRoute: typeof AuthenticatedLayoutRoute
    }
    '/_authenticated/_layout/profile/settings': {
      id: '/_authenticated/_layout/profile/settings'
      path: '/profile/settings'
      fullPath: '/profile/settings'
      preLoaderRoute: typeof AuthenticatedLayoutProfileSettingsRouteImport
      parentRoute: typeof AuthenticatedLayoutRoute
    }
    '/_authenticated/_layout/settings/users': {
      id: '/_authenticated/_layout/settings/users'
      path: '/settings/users'
      fullPath: '/settings/users'
      preLoaderRoute: typeof AuthenticatedLayoutSettingsUsersRouteImport
      parentRoute: typeof AuthenticatedLayoutRoute
    }
    '/_authenticated/_layout/settings/workspaces': {
      id: '/_authenticated/_layout/settings/workspaces'
      path: '/settings/workspaces'
      fullPath: '/settings/workspaces'
      preLoaderRoute: typeof AuthenticatedLayoutSettingsWorkspacesRouteImport
      parentRoute: typeof AuthenticatedLayoutRoute
    }
    '/_authenticated/_layout/templates/$': {
      id: '/_authenticated/_layout/templates/$'
      path: '/templates/$'
      fullPath: '/templates/$'
      preLoaderRoute: typeof AuthenticatedLayoutTemplatesSplatRouteImport
      parentRoute: typeof AuthenticatedLayoutRoute
    }
    '/_authenticated/_layout/workspaces/$subscriptionId': {
      id: '/_authenticated/_layout/workspaces/$subscriptionId'
      path: '/workspaces/$subscriptionId'
      fullPath: '/workspaces/$subscriptionId'
      preLoaderRoute: typeof AuthenticatedLayoutWorkspacesSubscriptionIdRouteImport
      parentRoute: typeof AuthenticatedLayoutRoute
    }
    '/_authenticated/_layout/(deprecated)/subscriptions/$': {
      id: '/_authenticated/_layout/(deprecated)/subscriptions/$'
      path: '/subscriptions/$'
      fullPath: '/subscriptions/$'
      preLoaderRoute: typeof AuthenticatedLayoutdeprecatedSubscriptionsSplatRouteImport
      parentRoute: typeof AuthenticatedLayoutRoute
    }
    '/_authenticated/_layout/settings/billing/': {
      id: '/_authenticated/_layout/settings/billing/'
      path: '/settings/billing'
      fullPath: '/settings/billing/'
      preLoaderRoute: typeof AuthenticatedLayoutSettingsBillingIndexRouteImport
      parentRoute: typeof AuthenticatedLayoutRoute
    }
    '/_authenticated/_layout/settings/billing/migrate': {
      id: '/_authenticated/_layout/settings/billing/migrate'
      path: '/settings/billing/migrate'
      fullPath: '/settings/billing/migrate'
      preLoaderRoute: typeof AuthenticatedLayoutSettingsBillingMigrateRouteImport
      parentRoute: typeof AuthenticatedLayoutRoute
    }
    '/_authenticated/_layout/workspaces/$subscriptionId/': {
      id: '/_authenticated/_layout/workspaces/$subscriptionId/'
      path: '/'
      fullPath: '/workspaces/$subscriptionId/'
      preLoaderRoute: typeof AuthenticatedLayoutWorkspacesSubscriptionIdIndexRouteImport
      parentRoute: typeof AuthenticatedLayoutWorkspacesSubscriptionIdRoute
    }
    '/_authenticated/_layout/workspaces/$subscriptionId/alerts': {
      id: '/_authenticated/_layout/workspaces/$subscriptionId/alerts'
      path: '/alerts'
      fullPath: '/workspaces/$subscriptionId/alerts'
      preLoaderRoute: typeof AuthenticatedLayoutWorkspacesSubscriptionIdAlertsRouteImport
      parentRoute: typeof AuthenticatedLayoutWorkspacesSubscriptionIdRoute
    }
    '/_authenticated/_layout/workspaces/$subscriptionId/audit-log': {
      id: '/_authenticated/_layout/workspaces/$subscriptionId/audit-log'
      path: '/audit-log'
      fullPath: '/workspaces/$subscriptionId/audit-log'
      preLoaderRoute: typeof AuthenticatedLayoutWorkspacesSubscriptionIdAuditLogRouteImport
      parentRoute: typeof AuthenticatedLayoutWorkspacesSubscriptionIdRoute
    }
    '/_authenticated/_layout/workspaces/$subscriptionId/billing': {
      id: '/_authenticated/_layout/workspaces/$subscriptionId/billing'
      path: '/billing'
      fullPath: '/workspaces/$subscriptionId/billing'
      preLoaderRoute: typeof AuthenticatedLayoutWorkspacesSubscriptionIdBillingRouteImport
      parentRoute: typeof AuthenticatedLayoutWorkspacesSubscriptionIdRoute
    }
    '/_authenticated/_layout/workspaces/$subscriptionId/bot-detection': {
      id: '/_authenticated/_layout/workspaces/$subscriptionId/bot-detection'
      path: '/bot-detection'
      fullPath: '/workspaces/$subscriptionId/bot-detection'
      preLoaderRoute: typeof AuthenticatedLayoutWorkspacesSubscriptionIdBotDetectionRouteImport
      parentRoute: typeof AuthenticatedLayoutWorkspacesSubscriptionIdRoute
    }
    '/_authenticated/_layout/workspaces/$subscriptionId/botd': {
      id: '/_authenticated/_layout/workspaces/$subscriptionId/botd'
      path: '/botd'
      fullPath: '/workspaces/$subscriptionId/botd'
      preLoaderRoute: typeof AuthenticatedLayoutWorkspacesSubscriptionIdBotdRouteImport
      parentRoute: typeof AuthenticatedLayoutWorkspacesSubscriptionIdRoute
    }
    '/_authenticated/_layout/workspaces/$subscriptionId/environments': {
      id: '/_authenticated/_layout/workspaces/$subscriptionId/environments'
      path: '/environments'
      fullPath: '/workspaces/$subscriptionId/environments'
      preLoaderRoute: typeof AuthenticatedLayoutWorkspacesSubscriptionIdEnvironmentsRouteImport
      parentRoute: typeof AuthenticatedLayoutWorkspacesSubscriptionIdRoute
    }
    '/_authenticated/_layout/workspaces/$subscriptionId/fraud-analysis': {
      id: '/_authenticated/_layout/workspaces/$subscriptionId/fraud-analysis'
      path: '/fraud-analysis'
      fullPath: '/workspaces/$subscriptionId/fraud-analysis'
      preLoaderRoute: typeof AuthenticatedLayoutWorkspacesSubscriptionIdFraudAnalysisRouteImport
      parentRoute: typeof AuthenticatedLayoutWorkspacesSubscriptionIdRoute
    }
    '/_authenticated/_layout/workspaces/$subscriptionId/general': {
      id: '/_authenticated/_layout/workspaces/$subscriptionId/general'
      path: '/general'
      fullPath: '/workspaces/$subscriptionId/general'
      preLoaderRoute: typeof AuthenticatedLayoutWorkspacesSubscriptionIdGeneralRouteImport
      parentRoute: typeof AuthenticatedLayoutWorkspacesSubscriptionIdRoute
    }
    '/_authenticated/_layout/workspaces/$subscriptionId/get-started': {
      id: '/_authenticated/_layout/workspaces/$subscriptionId/get-started'
      path: '/get-started'
      fullPath: '/workspaces/$subscriptionId/get-started'
      preLoaderRoute: typeof AuthenticatedLayoutWorkspacesSubscriptionIdGetStartedRouteImport
      parentRoute: typeof AuthenticatedLayoutWorkspacesSubscriptionIdRoute
    }
    '/_authenticated/_layout/workspaces/$subscriptionId/integrations': {
      id: '/_authenticated/_layout/workspaces/$subscriptionId/integrations'
      path: '/integrations'
      fullPath: '/workspaces/$subscriptionId/integrations'
      preLoaderRoute: typeof AuthenticatedLayoutWorkspacesSubscriptionIdIntegrationsRouteImport
      parentRoute: typeof AuthenticatedLayoutWorkspacesSubscriptionIdRoute
    }
    '/_authenticated/_layout/workspaces/$subscriptionId/mcp': {
      id: '/_authenticated/_layout/workspaces/$subscriptionId/mcp'
      path: '/mcp'
      fullPath: '/workspaces/$subscriptionId/mcp'
      preLoaderRoute: typeof AuthenticatedLayoutWorkspacesSubscriptionIdMcpRouteImport
      parentRoute: typeof AuthenticatedLayoutWorkspacesSubscriptionIdRoute
    }
    '/_authenticated/_layout/workspaces/$subscriptionId/overview': {
      id: '/_authenticated/_layout/workspaces/$subscriptionId/overview'
      path: '/overview'
      fullPath: '/workspaces/$subscriptionId/overview'
      preLoaderRoute: typeof AuthenticatedLayoutWorkspacesSubscriptionIdOverviewRouteImport
      parentRoute: typeof AuthenticatedLayoutWorkspacesSubscriptionIdRoute
    }
    '/_authenticated/_layout/workspaces/$subscriptionId/plans': {
      id: '/_authenticated/_layout/workspaces/$subscriptionId/plans'
      path: '/plans'
      fullPath: '/workspaces/$subscriptionId/plans'
      preLoaderRoute: typeof AuthenticatedLayoutWorkspacesSubscriptionIdPlansRouteImport
      parentRoute: typeof AuthenticatedLayoutWorkspacesSubscriptionIdRoute
    }
    '/_authenticated/_layout/workspaces/$subscriptionId/smart-signals': {
      id: '/_authenticated/_layout/workspaces/$subscriptionId/smart-signals'
      path: '/smart-signals'
      fullPath: '/workspaces/$subscriptionId/smart-signals'
      preLoaderRoute: typeof AuthenticatedLayoutWorkspacesSubscriptionIdSmartSignalsRouteImport
      parentRoute: typeof AuthenticatedLayoutWorkspacesSubscriptionIdRoute
    }
    '/_authenticated/_layout/workspaces/$subscriptionId/submit-bot': {
      id: '/_authenticated/_layout/workspaces/$subscriptionId/submit-bot'
      path: '/submit-bot'
      fullPath: '/workspaces/$subscriptionId/submit-bot'
      preLoaderRoute: typeof AuthenticatedLayoutWorkspacesSubscriptionIdSubmitBotRouteImport
      parentRoute: typeof AuthenticatedLayoutWorkspacesSubscriptionIdRoute
    }
    '/_authenticated/_layout/workspaces/$subscriptionId/suspect-score': {
      id: '/_authenticated/_layout/workspaces/$subscriptionId/suspect-score'
      path: '/suspect-score'
      fullPath: '/workspaces/$subscriptionId/suspect-score'
      preLoaderRoute: typeof AuthenticatedLayoutWorkspacesSubscriptionIdSuspectScoreRouteImport
      parentRoute: typeof AuthenticatedLayoutWorkspacesSubscriptionIdRoute
    }
    '/_authenticated/_layout/workspaces/$subscriptionId/traffic-rules': {
      id: '/_authenticated/_layout/workspaces/$subscriptionId/traffic-rules'
      path: '/traffic-rules'
      fullPath: '/workspaces/$subscriptionId/traffic-rules'
      preLoaderRoute: typeof AuthenticatedLayoutWorkspacesSubscriptionIdTrafficRulesRouteImport
      parentRoute: typeof AuthenticatedLayoutWorkspacesSubscriptionIdRoute
    }
    '/_authenticated/workspaces/$subscriptionId/rulesets/$rulesetId': {
      id: '/_authenticated/workspaces/$subscriptionId/rulesets/$rulesetId'
      path: '/workspaces/$subscriptionId/rulesets/$rulesetId'
      fullPath: '/workspaces/$subscriptionId/rulesets/$rulesetId'
      preLoaderRoute: typeof AuthenticatedWorkspacesSubscriptionIdRulesetsRulesetIdRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/workspaces/$subscriptionId/templates/$': {
      id: '/_authenticated/workspaces/$subscriptionId/templates/$'
      path: '/workspaces/$subscriptionId/templates/$'
      fullPath: '/workspaces/$subscriptionId/templates/$'
      preLoaderRoute: typeof AuthenticatedWorkspacesSubscriptionIdTemplatesSplatRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/_layout/(deprecated)/workspaces/$subscriptionId/visits': {
      id: '/_authenticated/_layout/(deprecated)/workspaces/$subscriptionId/visits'
      path: '/workspaces/$subscriptionId/visits'
      fullPath: '/workspaces/$subscriptionId/visits'
      preLoaderRoute: typeof AuthenticatedLayoutdeprecatedWorkspacesSubscriptionIdVisitsRouteImport
      parentRoute: typeof AuthenticatedLayoutRoute
    }
    '/_authenticated/_layout/workspaces/$subscriptionId/api-keys/': {
      id: '/_authenticated/_layout/workspaces/$subscriptionId/api-keys/'
      path: '/api-keys'
      fullPath: '/workspaces/$subscriptionId/api-keys/'
      preLoaderRoute: typeof AuthenticatedLayoutWorkspacesSubscriptionIdApiKeysIndexRouteImport
      parentRoute: typeof AuthenticatedLayoutWorkspacesSubscriptionIdRoute
    }
    '/_authenticated/_layout/workspaces/$subscriptionId/bot-detection/': {
      id: '/_authenticated/_layout/workspaces/$subscriptionId/bot-detection/'
      path: '/'
      fullPath: '/workspaces/$subscriptionId/bot-detection/'
      preLoaderRoute: typeof AuthenticatedLayoutWorkspacesSubscriptionIdBotDetectionIndexRouteImport
      parentRoute: typeof AuthenticatedLayoutWorkspacesSubscriptionIdBotDetectionRoute
    }
    '/_authenticated/_layout/workspaces/$subscriptionId/events/': {
      id: '/_authenticated/_layout/workspaces/$subscriptionId/events/'
      path: '/events'
      fullPath: '/workspaces/$subscriptionId/events/'
      preLoaderRoute: typeof AuthenticatedLayoutWorkspacesSubscriptionIdEventsIndexRouteImport
      parentRoute: typeof AuthenticatedLayoutWorkspacesSubscriptionIdRoute
    }
    '/_authenticated/_layout/workspaces/$subscriptionId/fraud-analysis/': {
      id: '/_authenticated/_layout/workspaces/$subscriptionId/fraud-analysis/'
      path: '/'
      fullPath: '/workspaces/$subscriptionId/fraud-analysis/'
      preLoaderRoute: typeof AuthenticatedLayoutWorkspacesSubscriptionIdFraudAnalysisIndexRouteImport
      parentRoute: typeof AuthenticatedLayoutWorkspacesSubscriptionIdFraudAnalysisRoute
    }
    '/_authenticated/_layout/workspaces/$subscriptionId/fraud-analysis/dataset': {
      id: '/_authenticated/_layout/workspaces/$subscriptionId/fraud-analysis/dataset'
      path: '/dataset'
      fullPath: '/workspaces/$subscriptionId/fraud-analysis/dataset'
      preLoaderRoute: typeof AuthenticatedLayoutWorkspacesSubscriptionIdFraudAnalysisDatasetRouteImport
      parentRoute: typeof AuthenticatedLayoutWorkspacesSubscriptionIdFraudAnalysisRoute
    }
    '/_authenticated/_layout/workspaces/$subscriptionId/fraud-analysis/unlock': {
      id: '/_authenticated/_layout/workspaces/$subscriptionId/fraud-analysis/unlock'
      path: '/unlock'
      fullPath: '/workspaces/$subscriptionId/fraud-analysis/unlock'
      preLoaderRoute: typeof AuthenticatedLayoutWorkspacesSubscriptionIdFraudAnalysisUnlockRouteImport
      parentRoute: typeof AuthenticatedLayoutWorkspacesSubscriptionIdFraudAnalysisRoute
    }
    '/_authenticated/_layout/workspaces/$subscriptionId/fraud-analysis/upgrade': {
      id: '/_authenticated/_layout/workspaces/$subscriptionId/fraud-analysis/upgrade'
      path: '/upgrade'
      fullPath: '/workspaces/$subscriptionId/fraud-analysis/upgrade'
      preLoaderRoute: typeof AuthenticatedLayoutWorkspacesSubscriptionIdFraudAnalysisUpgradeRouteImport
      parentRoute: typeof AuthenticatedLayoutWorkspacesSubscriptionIdFraudAnalysisRoute
    }
    '/_authenticated/_layout/workspaces/$subscriptionId/fraud-analysis/upload': {
      id: '/_authenticated/_layout/workspaces/$subscriptionId/fraud-analysis/upload'
      path: '/upload'
      fullPath: '/workspaces/$subscriptionId/fraud-analysis/upload'
      preLoaderRoute: typeof AuthenticatedLayoutWorkspacesSubscriptionIdFraudAnalysisUploadRouteImport
      parentRoute: typeof AuthenticatedLayoutWorkspacesSubscriptionIdFraudAnalysisRoute
    }
    '/_authenticated/_layout/workspaces/$subscriptionId/get-started/': {
      id: '/_authenticated/_layout/workspaces/$subscriptionId/get-started/'
      path: '/'
      fullPath: '/workspaces/$subscriptionId/get-started/'
      preLoaderRoute: typeof AuthenticatedLayoutWorkspacesSubscriptionIdGetStartedIndexRouteImport
      parentRoute: typeof AuthenticatedLayoutWorkspacesSubscriptionIdGetStartedRoute
    }
    '/_authenticated/_layout/workspaces/$subscriptionId/get-started/$stepSlug': {
      id: '/_authenticated/_layout/workspaces/$subscriptionId/get-started/$stepSlug'
      path: '/$stepSlug'
      fullPath: '/workspaces/$subscriptionId/get-started/$stepSlug'
      preLoaderRoute: typeof AuthenticatedLayoutWorkspacesSubscriptionIdGetStartedStepSlugRouteImport
      parentRoute: typeof AuthenticatedLayoutWorkspacesSubscriptionIdGetStartedRoute
    }
    '/_authenticated/_layout/workspaces/$subscriptionId/health/': {
      id: '/_authenticated/_layout/workspaces/$subscriptionId/health/'
      path: '/health'
      fullPath: '/workspaces/$subscriptionId/health/'
      preLoaderRoute: typeof AuthenticatedLayoutWorkspacesSubscriptionIdHealthIndexRouteImport
      parentRoute: typeof AuthenticatedLayoutWorkspacesSubscriptionIdRoute
    }
    '/_authenticated/_layout/workspaces/$subscriptionId/integrations/': {
      id: '/_authenticated/_layout/workspaces/$subscriptionId/integrations/'
      path: '/'
      fullPath: '/workspaces/$subscriptionId/integrations/'
      preLoaderRoute: typeof AuthenticatedLayoutWorkspacesSubscriptionIdIntegrationsIndexRouteImport
      parentRoute: typeof AuthenticatedLayoutWorkspacesSubscriptionIdIntegrationsRoute
    }
    '/_authenticated/_layout/workspaces/$subscriptionId/integrations/active': {
      id: '/_authenticated/_layout/workspaces/$subscriptionId/integrations/active'
      path: '/active'
      fullPath: '/workspaces/$subscriptionId/integrations/active'
      preLoaderRoute: typeof AuthenticatedLayoutWorkspacesSubscriptionIdIntegrationsActiveRouteImport
      parentRoute: typeof AuthenticatedLayoutWorkspacesSubscriptionIdIntegrationsRoute
    }
    '/_authenticated/_layout/workspaces/$subscriptionId/integrations/directory': {
      id: '/_authenticated/_layout/workspaces/$subscriptionId/integrations/directory'
      path: '/directory'
      fullPath: '/workspaces/$subscriptionId/integrations/directory'
      preLoaderRoute: typeof AuthenticatedLayoutWorkspacesSubscriptionIdIntegrationsDirectoryRouteImport
      parentRoute: typeof AuthenticatedLayoutWorkspacesSubscriptionIdIntegrationsRoute
    }
    '/_authenticated/_layout/workspaces/$subscriptionId/plan/': {
      id: '/_authenticated/_layout/workspaces/$subscriptionId/plan/'
      path: '/plan'
      fullPath: '/workspaces/$subscriptionId/plan/'
      preLoaderRoute: typeof AuthenticatedLayoutWorkspacesSubscriptionIdPlanIndexRouteImport
      parentRoute: typeof AuthenticatedLayoutWorkspacesSubscriptionIdRoute
    }
    '/_authenticated/_layout/workspaces/$subscriptionId/plan/checkout-return': {
      id: '/_authenticated/_layout/workspaces/$subscriptionId/plan/checkout-return'
      path: '/plan/checkout-return'
      fullPath: '/workspaces/$subscriptionId/plan/checkout-return'
      preLoaderRoute: typeof AuthenticatedLayoutWorkspacesSubscriptionIdPlanCheckoutReturnRouteImport
      parentRoute: typeof AuthenticatedLayoutWorkspacesSubscriptionIdRoute
    }
    '/_authenticated/_layout/workspaces/$subscriptionId/plan/unpaid-invoices': {
      id: '/_authenticated/_layout/workspaces/$subscriptionId/plan/unpaid-invoices'
      path: '/plan/unpaid-invoices'
      fullPath: '/workspaces/$subscriptionId/plan/unpaid-invoices'
      preLoaderRoute: typeof AuthenticatedLayoutWorkspacesSubscriptionIdPlanUnpaidInvoicesRouteImport
      parentRoute: typeof AuthenticatedLayoutWorkspacesSubscriptionIdRoute
    }
    '/_authenticated/_layout/workspaces/$subscriptionId/rulesets/': {
      id: '/_authenticated/_layout/workspaces/$subscriptionId/rulesets/'
      path: '/rulesets'
      fullPath: '/workspaces/$subscriptionId/rulesets/'
      preLoaderRoute: typeof AuthenticatedLayoutWorkspacesSubscriptionIdRulesetsIndexRouteImport
      parentRoute: typeof AuthenticatedLayoutWorkspacesSubscriptionIdRoute
    }
    '/_authenticated/_layout/workspaces/$subscriptionId/subdomains/': {
      id: '/_authenticated/_layout/workspaces/$subscriptionId/subdomains/'
      path: '/subdomains'
      fullPath: '/workspaces/$subscriptionId/subdomains/'
      preLoaderRoute: typeof AuthenticatedLayoutWorkspacesSubscriptionIdSubdomainsIndexRouteImport
      parentRoute: typeof AuthenticatedLayoutWorkspacesSubscriptionIdRoute
    }
    '/_authenticated/_layout/workspaces/$subscriptionId/subdomains/$certificateId': {
      id: '/_authenticated/_layout/workspaces/$subscriptionId/subdomains/$certificateId'
      path: '/subdomains/$certificateId'
      fullPath: '/workspaces/$subscriptionId/subdomains/$certificateId'
      preLoaderRoute: typeof AuthenticatedLayoutWorkspacesSubscriptionIdSubdomainsCertificateIdRouteImport
      parentRoute: typeof AuthenticatedLayoutWorkspacesSubscriptionIdRoute
    }
    '/_authenticated/_layout/workspaces/$subscriptionId/suspect-score/': {
      id: '/_authenticated/_layout/workspaces/$subscriptionId/suspect-score/'
      path: '/'
      fullPath: '/workspaces/$subscriptionId/suspect-score/'
      preLoaderRoute: typeof AuthenticatedLayoutWorkspacesSubscriptionIdSuspectScoreIndexRouteImport
      parentRoute: typeof AuthenticatedLayoutWorkspacesSubscriptionIdSuspectScoreRoute
    }
    '/_authenticated/_layout/workspaces/$subscriptionId/suspect-score/analysis': {
      id: '/_authenticated/_layout/workspaces/$subscriptionId/suspect-score/analysis'
      path: '/analysis'
      fullPath: '/workspaces/$subscriptionId/suspect-score/analysis'
      preLoaderRoute: typeof AuthenticatedLayoutWorkspacesSubscriptionIdSuspectScoreAnalysisRouteImport
      parentRoute: typeof AuthenticatedLayoutWorkspacesSubscriptionIdSuspectScoreRoute
    }
    '/_authenticated/_layout/workspaces/$subscriptionId/visitors/': {
      id: '/_authenticated/_layout/workspaces/$subscriptionId/visitors/'
      path: '/visitors'
      fullPath: '/workspaces/$subscriptionId/visitors/'
      preLoaderRoute: typeof AuthenticatedLayoutWorkspacesSubscriptionIdVisitorsIndexRouteImport
      parentRoute: typeof AuthenticatedLayoutWorkspacesSubscriptionIdRoute
    }
    '/_authenticated/_layout/workspaces/$subscriptionId/visitors/$visitorId': {
      id: '/_authenticated/_layout/workspaces/$subscriptionId/visitors/$visitorId'
      path: '/visitors/$visitorId'
      fullPath: '/workspaces/$subscriptionId/visitors/$visitorId'
      preLoaderRoute: typeof AuthenticatedLayoutWorkspacesSubscriptionIdVisitorsVisitorIdRouteImport
      parentRoute: typeof AuthenticatedLayoutWorkspacesSubscriptionIdRoute
    }
    '/_authenticated/_layout/workspaces/$subscriptionId/visitors/avatars': {
      id: '/_authenticated/_layout/workspaces/$subscriptionId/visitors/avatars'
      path: '/visitors/avatars'
      fullPath: '/workspaces/$subscriptionId/visitors/avatars'
      preLoaderRoute: typeof AuthenticatedLayoutWorkspacesSubscriptionIdVisitorsAvatarsRouteImport
      parentRoute: typeof AuthenticatedLayoutWorkspacesSubscriptionIdRoute
    }
    '/_authenticated/_layout/workspaces/$subscriptionId/webhooks/': {
      id: '/_authenticated/_layout/workspaces/$subscriptionId/webhooks/'
      path: '/webhooks'
      fullPath: '/workspaces/$subscriptionId/webhooks/'
      preLoaderRoute: typeof AuthenticatedLayoutWorkspacesSubscriptionIdWebhooksIndexRouteImport
      parentRoute: typeof AuthenticatedLayoutWorkspacesSubscriptionIdRoute
    }
    '/_authenticated/workspaces/$subscriptionId/plan/cancel/': {
      id: '/_authenticated/workspaces/$subscriptionId/plan/cancel/'
      path: '/workspaces/$subscriptionId/plan/cancel'
      fullPath: '/workspaces/$subscriptionId/plan/cancel/'
      preLoaderRoute: typeof AuthenticatedWorkspacesSubscriptionIdPlanCancelIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/workspaces/$subscriptionId/plan/cancel/confirm': {
      id: '/_authenticated/workspaces/$subscriptionId/plan/cancel/confirm'
      path: '/workspaces/$subscriptionId/plan/cancel/confirm'
      fullPath: '/workspaces/$subscriptionId/plan/cancel/confirm'
      preLoaderRoute: typeof AuthenticatedWorkspacesSubscriptionIdPlanCancelConfirmRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/workspaces/$subscriptionId/plan/downgrade/': {
      id: '/_authenticated/workspaces/$subscriptionId/plan/downgrade/'
      path: '/workspaces/$subscriptionId/plan/downgrade'
      fullPath: '/workspaces/$subscriptionId/plan/downgrade/'
      preLoaderRoute: typeof AuthenticatedWorkspacesSubscriptionIdPlanDowngradeIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/workspaces/$subscriptionId/plan/downgrade/confirm': {
      id: '/_authenticated/workspaces/$subscriptionId/plan/downgrade/confirm'
      path: '/workspaces/$subscriptionId/plan/downgrade/confirm'
      fullPath: '/workspaces/$subscriptionId/plan/downgrade/confirm'
      preLoaderRoute: typeof AuthenticatedWorkspacesSubscriptionIdPlanDowngradeConfirmRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/workspaces/$subscriptionId/rulesets/$rulesetId/': {
      id: '/_authenticated/workspaces/$subscriptionId/rulesets/$rulesetId/'
      path: '/'
      fullPath: '/workspaces/$subscriptionId/rulesets/$rulesetId/'
      preLoaderRoute: typeof AuthenticatedWorkspacesSubscriptionIdRulesetsRulesetIdIndexLazyRouteImport
      parentRoute: typeof AuthenticatedWorkspacesSubscriptionIdRulesetsRulesetIdRoute
    }
    '/_authenticated/workspaces/$subscriptionId/rulesets/templates/$templateSlug': {
      id: '/_authenticated/workspaces/$subscriptionId/rulesets/templates/$templateSlug'
      path: '/workspaces/$subscriptionId/rulesets/templates/$templateSlug'
      fullPath: '/workspaces/$subscriptionId/rulesets/templates/$templateSlug'
      preLoaderRoute: typeof AuthenticatedWorkspacesSubscriptionIdRulesetsTemplatesTemplateSlugRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/_layout/(deprecated)/workspaces/$subscriptionId/visits/$requestId': {
      id: '/_authenticated/_layout/(deprecated)/workspaces/$subscriptionId/visits/$requestId'
      path: '/$requestId'
      fullPath: '/workspaces/$subscriptionId/visits/$requestId'
      preLoaderRoute: typeof AuthenticatedLayoutdeprecatedWorkspacesSubscriptionIdVisitsRequestIdRouteImport
      parentRoute: typeof AuthenticatedLayoutdeprecatedWorkspacesSubscriptionIdVisitsRoute
    }
    '/_authenticated/_layout/workspaces/$subscriptionId/api-keys/$tokenId/': {
      id: '/_authenticated/_layout/workspaces/$subscriptionId/api-keys/$tokenId/'
      path: '/api-keys/$tokenId'
      fullPath: '/workspaces/$subscriptionId/api-keys/$tokenId/'
      preLoaderRoute: typeof AuthenticatedLayoutWorkspacesSubscriptionIdApiKeysTokenIdIndexRouteImport
      parentRoute: typeof AuthenticatedLayoutWorkspacesSubscriptionIdRoute
    }
    '/_authenticated/_layout/workspaces/$subscriptionId/bot-detection/events/': {
      id: '/_authenticated/_layout/workspaces/$subscriptionId/bot-detection/events/'
      path: '/events'
      fullPath: '/workspaces/$subscriptionId/bot-detection/events/'
      preLoaderRoute: typeof AuthenticatedLayoutWorkspacesSubscriptionIdBotDetectionEventsIndexRouteImport
      parentRoute: typeof AuthenticatedLayoutWorkspacesSubscriptionIdBotDetectionRoute
    }
    '/_authenticated/_layout/workspaces/$subscriptionId/bot-detection/events/$eventId': {
      id: '/_authenticated/_layout/workspaces/$subscriptionId/bot-detection/events/$eventId'
      path: '/events/$eventId'
      fullPath: '/workspaces/$subscriptionId/bot-detection/events/$eventId'
      preLoaderRoute: typeof AuthenticatedLayoutWorkspacesSubscriptionIdBotDetectionEventsEventIdRouteImport
      parentRoute: typeof AuthenticatedLayoutWorkspacesSubscriptionIdBotDetectionRoute
    }
    '/_authenticated/_layout/workspaces/$subscriptionId/events/$requestId/': {
      id: '/_authenticated/_layout/workspaces/$subscriptionId/events/$requestId/'
      path: '/events/$requestId'
      fullPath: '/workspaces/$subscriptionId/events/$requestId/'
      preLoaderRoute: typeof AuthenticatedLayoutWorkspacesSubscriptionIdEventsRequestIdIndexRouteImport
      parentRoute: typeof AuthenticatedLayoutWorkspacesSubscriptionIdRoute
    }
    '/_authenticated/_layout/workspaces/$subscriptionId/events/$requestId/visitor-history': {
      id: '/_authenticated/_layout/workspaces/$subscriptionId/events/$requestId/visitor-history'
      path: '/events/$requestId/visitor-history'
      fullPath: '/workspaces/$subscriptionId/events/$requestId/visitor-history'
      preLoaderRoute: typeof AuthenticatedLayoutWorkspacesSubscriptionIdEventsRequestIdVisitorHistoryRouteImport
      parentRoute: typeof AuthenticatedLayoutWorkspacesSubscriptionIdRoute
    }
    '/_authenticated/_layout/workspaces/$subscriptionId/fraud-analysis/dataset/': {
      id: '/_authenticated/_layout/workspaces/$subscriptionId/fraud-analysis/dataset/'
      path: '/'
      fullPath: '/workspaces/$subscriptionId/fraud-analysis/dataset/'
      preLoaderRoute: typeof AuthenticatedLayoutWorkspacesSubscriptionIdFraudAnalysisDatasetIndexRouteImport
      parentRoute: typeof AuthenticatedLayoutWorkspacesSubscriptionIdFraudAnalysisDatasetRoute
    }
    '/_authenticated/_layout/workspaces/$subscriptionId/fraud-analysis/dataset/events': {
      id: '/_authenticated/_layout/workspaces/$subscriptionId/fraud-analysis/dataset/events'
      path: '/events'
      fullPath: '/workspaces/$subscriptionId/fraud-analysis/dataset/events'
      preLoaderRoute: typeof AuthenticatedLayoutWorkspacesSubscriptionIdFraudAnalysisDatasetEventsRouteImport
      parentRoute: typeof AuthenticatedLayoutWorkspacesSubscriptionIdFraudAnalysisDatasetRoute
    }
    '/_authenticated/_layout/workspaces/$subscriptionId/fraud-analysis/models/': {
      id: '/_authenticated/_layout/workspaces/$subscriptionId/fraud-analysis/models/'
      path: '/models'
      fullPath: '/workspaces/$subscriptionId/fraud-analysis/models/'
      preLoaderRoute: typeof AuthenticatedLayoutWorkspacesSubscriptionIdFraudAnalysisModelsIndexRouteImport
      parentRoute: typeof AuthenticatedLayoutWorkspacesSubscriptionIdFraudAnalysisRoute
    }
    '/_authenticated/_layout/workspaces/$subscriptionId/integrations/$integrationTag/': {
      id: '/_authenticated/_layout/workspaces/$subscriptionId/integrations/$integrationTag/'
      path: '/$integrationTag'
      fullPath: '/workspaces/$subscriptionId/integrations/$integrationTag/'
      preLoaderRoute: typeof AuthenticatedLayoutWorkspacesSubscriptionIdIntegrationsIntegrationTagIndexRouteImport
      parentRoute: typeof AuthenticatedLayoutWorkspacesSubscriptionIdIntegrationsRoute
    }
    '/_authenticated/_layout/workspaces/$subscriptionId/integrations/$integrationTag/$environmentId': {
      id: '/_authenticated/_layout/workspaces/$subscriptionId/integrations/$integrationTag/$environmentId'
      path: '/$integrationTag/$environmentId'
      fullPath: '/workspaces/$subscriptionId/integrations/$integrationTag/$environmentId'
      preLoaderRoute: typeof AuthenticatedLayoutWorkspacesSubscriptionIdIntegrationsIntegrationTagEnvironmentIdRouteImport
      parentRoute: typeof AuthenticatedLayoutWorkspacesSubscriptionIdIntegrationsRoute
    }
    '/_authenticated/_layout/workspaces/$subscriptionId/integrations/$integrationTag/health': {
      id: '/_authenticated/_layout/workspaces/$subscriptionId/integrations/$integrationTag/health'
      path: '/$integrationTag/health'
      fullPath: '/workspaces/$subscriptionId/integrations/$integrationTag/health'
      preLoaderRoute: typeof AuthenticatedLayoutWorkspacesSubscriptionIdIntegrationsIntegrationTagHealthRouteImport
      parentRoute: typeof AuthenticatedLayoutWorkspacesSubscriptionIdIntegrationsRoute
    }
    '/_authenticated/_layout/workspaces/$subscriptionId/integrations/cloudflare-flow/': {
      id: '/_authenticated/_layout/workspaces/$subscriptionId/integrations/cloudflare-flow/'
      path: '/cloudflare-flow'
      fullPath: '/workspaces/$subscriptionId/integrations/cloudflare-flow/'
      preLoaderRoute: typeof AuthenticatedLayoutWorkspacesSubscriptionIdIntegrationsCloudflareFlowIndexRouteImport
      parentRoute: typeof AuthenticatedLayoutWorkspacesSubscriptionIdIntegrationsRoute
    }
    '/_authenticated/_layout/workspaces/$subscriptionId/invoices/$invoiceId/': {
      id: '/_authenticated/_layout/workspaces/$subscriptionId/invoices/$invoiceId/'
      path: '/invoices/$invoiceId'
      fullPath: '/workspaces/$subscriptionId/invoices/$invoiceId/'
      preLoaderRoute: typeof AuthenticatedLayoutWorkspacesSubscriptionIdInvoicesInvoiceIdIndexRouteImport
      parentRoute: typeof AuthenticatedLayoutWorkspacesSubscriptionIdRoute
    }
    '/_authenticated/_layout/workspaces/$subscriptionId/invoices/$invoiceId/forgiveness-request': {
      id: '/_authenticated/_layout/workspaces/$subscriptionId/invoices/$invoiceId/forgiveness-request'
      path: '/invoices/$invoiceId/forgiveness-request'
      fullPath: '/workspaces/$subscriptionId/invoices/$invoiceId/forgiveness-request'
      preLoaderRoute: typeof AuthenticatedLayoutWorkspacesSubscriptionIdInvoicesInvoiceIdForgivenessRequestRouteImport
      parentRoute: typeof AuthenticatedLayoutWorkspacesSubscriptionIdRoute
    }
    '/_authenticated/_layout/workspaces/$subscriptionId/visitors/$visitorId/': {
      id: '/_authenticated/_layout/workspaces/$subscriptionId/visitors/$visitorId/'
      path: '/'
      fullPath: '/workspaces/$subscriptionId/visitors/$visitorId/'
      preLoaderRoute: typeof AuthenticatedLayoutWorkspacesSubscriptionIdVisitorsVisitorIdIndexRouteImport
      parentRoute: typeof AuthenticatedLayoutWorkspacesSubscriptionIdVisitorsVisitorIdRoute
    }
    '/_authenticated/_layout/workspaces/$subscriptionId/visitors/$visitorId/events': {
      id: '/_authenticated/_layout/workspaces/$subscriptionId/visitors/$visitorId/events'
      path: '/events'
      fullPath: '/workspaces/$subscriptionId/visitors/$visitorId/events'
      preLoaderRoute: typeof AuthenticatedLayoutWorkspacesSubscriptionIdVisitorsVisitorIdEventsRouteImport
      parentRoute: typeof AuthenticatedLayoutWorkspacesSubscriptionIdVisitorsVisitorIdRoute
    }
    '/_authenticated/_layout/workspaces/$subscriptionId/visitors/$visitorId/ip-addresses': {
      id: '/_authenticated/_layout/workspaces/$subscriptionId/visitors/$visitorId/ip-addresses'
      path: '/ip-addresses'
      fullPath: '/workspaces/$subscriptionId/visitors/$visitorId/ip-addresses'
      preLoaderRoute: typeof AuthenticatedLayoutWorkspacesSubscriptionIdVisitorsVisitorIdIpAddressesRouteImport
      parentRoute: typeof AuthenticatedLayoutWorkspacesSubscriptionIdVisitorsVisitorIdRoute
    }
    '/_authenticated/_layout/workspaces/$subscriptionId/visitors/$visitorId/location-history': {
      id: '/_authenticated/_layout/workspaces/$subscriptionId/visitors/$visitorId/location-history'
      path: '/location-history'
      fullPath: '/workspaces/$subscriptionId/visitors/$visitorId/location-history'
      preLoaderRoute: typeof AuthenticatedLayoutWorkspacesSubscriptionIdVisitorsVisitorIdLocationHistoryRouteImport
      parentRoute: typeof AuthenticatedLayoutWorkspacesSubscriptionIdVisitorsVisitorIdRoute
    }
    '/_authenticated/_layout/workspaces/$subscriptionId/visitors/$visitorId/related-visitors': {
      id: '/_authenticated/_layout/workspaces/$subscriptionId/visitors/$visitorId/related-visitors'
      path: '/related-visitors'
      fullPath: '/workspaces/$subscriptionId/visitors/$visitorId/related-visitors'
      preLoaderRoute: typeof AuthenticatedLayoutWorkspacesSubscriptionIdVisitorsVisitorIdRelatedVisitorsRouteImport
      parentRoute: typeof AuthenticatedLayoutWorkspacesSubscriptionIdVisitorsVisitorIdRoute
    }
    '/_authenticated/_layout/workspaces/$subscriptionId/visitors/$visitorId/smart-signals': {
      id: '/_authenticated/_layout/workspaces/$subscriptionId/visitors/$visitorId/smart-signals'
      path: '/smart-signals'
      fullPath: '/workspaces/$subscriptionId/visitors/$visitorId/smart-signals'
      preLoaderRoute: typeof AuthenticatedLayoutWorkspacesSubscriptionIdVisitorsVisitorIdSmartSignalsRouteImport
      parentRoute: typeof AuthenticatedLayoutWorkspacesSubscriptionIdVisitorsVisitorIdRoute
    }
    '/_authenticated/_layout/workspaces/$subscriptionId/webhooks/$webhookId/events': {
      id: '/_authenticated/_layout/workspaces/$subscriptionId/webhooks/$webhookId/events'
      path: '/webhooks/$webhookId/events'
      fullPath: '/workspaces/$subscriptionId/webhooks/$webhookId/events'
      preLoaderRoute: typeof AuthenticatedLayoutWorkspacesSubscriptionIdWebhooksWebhookIdEventsRouteImport
      parentRoute: typeof AuthenticatedLayoutWorkspacesSubscriptionIdRoute
    }
    '/_authenticated/_layout/workspaces/$subscriptionId/webhooks/$webhookId/verify': {
      id: '/_authenticated/_layout/workspaces/$subscriptionId/webhooks/$webhookId/verify'
      path: '/webhooks/$webhookId/verify'
      fullPath: '/workspaces/$subscriptionId/webhooks/$webhookId/verify'
      preLoaderRoute: typeof AuthenticatedLayoutWorkspacesSubscriptionIdWebhooksWebhookIdVerifyRouteImport
      parentRoute: typeof AuthenticatedLayoutWorkspacesSubscriptionIdRoute
    }
    '/_authenticated/_layout/workspaces/$subscriptionId/fraud-analysis/models/$labelSlug/': {
      id: '/_authenticated/_layout/workspaces/$subscriptionId/fraud-analysis/models/$labelSlug/'
      path: '/models/$labelSlug'
      fullPath: '/workspaces/$subscriptionId/fraud-analysis/models/$labelSlug/'
      preLoaderRoute: typeof AuthenticatedLayoutWorkspacesSubscriptionIdFraudAnalysisModelsLabelSlugIndexRouteImport
      parentRoute: typeof AuthenticatedLayoutWorkspacesSubscriptionIdFraudAnalysisRoute
    }
    '/_authenticated/_layout/workspaces/$subscriptionId/fraud-analysis/models/$labelSlug/$clientType': {
      id: '/_authenticated/_layout/workspaces/$subscriptionId/fraud-analysis/models/$labelSlug/$clientType'
      path: '/models/$labelSlug/$clientType'
      fullPath: '/workspaces/$subscriptionId/fraud-analysis/models/$labelSlug/$clientType'
      preLoaderRoute: typeof AuthenticatedLayoutWorkspacesSubscriptionIdFraudAnalysisModelsLabelSlugClientTypeRouteImport
      parentRoute: typeof AuthenticatedLayoutWorkspacesSubscriptionIdFraudAnalysisRoute
    }
    '/_authenticated/_layout/workspaces/$subscriptionId/integrations/cloudflare-flow/workers/': {
      id: '/_authenticated/_layout/workspaces/$subscriptionId/integrations/cloudflare-flow/workers/'
      path: '/cloudflare-flow/workers'
      fullPath: '/workspaces/$subscriptionId/integrations/cloudflare-flow/workers/'
      preLoaderRoute: typeof AuthenticatedLayoutWorkspacesSubscriptionIdIntegrationsCloudflareFlowWorkersIndexRouteImport
      parentRoute: typeof AuthenticatedLayoutWorkspacesSubscriptionIdIntegrationsRoute
    }
    '/_authenticated/_layout/workspaces/$subscriptionId/integrations/cloudflare-flow/workers/$deploymentId': {
      id: '/_authenticated/_layout/workspaces/$subscriptionId/integrations/cloudflare-flow/workers/$deploymentId'
      path: '/cloudflare-flow/workers/$deploymentId'
      fullPath: '/workspaces/$subscriptionId/integrations/cloudflare-flow/workers/$deploymentId'
      preLoaderRoute: typeof AuthenticatedLayoutWorkspacesSubscriptionIdIntegrationsCloudflareFlowWorkersDeploymentIdRouteImport
      parentRoute: typeof AuthenticatedLayoutWorkspacesSubscriptionIdIntegrationsRoute
    }
    '/_authenticated/_layout/workspaces/$subscriptionId/fraud-analysis/models/$labelSlug/$clientType/': {
      id: '/_authenticated/_layout/workspaces/$subscriptionId/fraud-analysis/models/$labelSlug/$clientType/'
      path: '/'
      fullPath: '/workspaces/$subscriptionId/fraud-analysis/models/$labelSlug/$clientType/'
      preLoaderRoute: typeof AuthenticatedLayoutWorkspacesSubscriptionIdFraudAnalysisModelsLabelSlugClientTypeIndexRouteImport
      parentRoute: typeof AuthenticatedLayoutWorkspacesSubscriptionIdFraudAnalysisModelsLabelSlugClientTypeRoute
    }
    '/_authenticated/_layout/workspaces/$subscriptionId/fraud-analysis/models/$labelSlug/$clientType/$modelVersionId': {
      id: '/_authenticated/_layout/workspaces/$subscriptionId/fraud-analysis/models/$labelSlug/$clientType/$modelVersionId'
      path: '/$modelVersionId'
      fullPath: '/workspaces/$subscriptionId/fraud-analysis/models/$labelSlug/$clientType/$modelVersionId'
      preLoaderRoute: typeof AuthenticatedLayoutWorkspacesSubscriptionIdFraudAnalysisModelsLabelSlugClientTypeModelVersionIdRouteImport
      parentRoute: typeof AuthenticatedLayoutWorkspacesSubscriptionIdFraudAnalysisModelsLabelSlugClientTypeRoute
    }
    '/_authenticated/_layout/workspaces/$subscriptionId/fraud-analysis/models/$labelSlug/$clientType/overview': {
      id: '/_authenticated/_layout/workspaces/$subscriptionId/fraud-analysis/models/$labelSlug/$clientType/overview'
      path: '/overview'
      fullPath: '/workspaces/$subscriptionId/fraud-analysis/models/$labelSlug/$clientType/overview'
      preLoaderRoute: typeof AuthenticatedLayoutWorkspacesSubscriptionIdFraudAnalysisModelsLabelSlugClientTypeOverviewRouteImport
      parentRoute: typeof AuthenticatedLayoutWorkspacesSubscriptionIdFraudAnalysisModelsLabelSlugClientTypeRoute
    }
    '/_authenticated/_layout/workspaces/$subscriptionId/fraud-analysis/models/$labelSlug/$clientType/versions': {
      id: '/_authenticated/_layout/workspaces/$subscriptionId/fraud-analysis/models/$labelSlug/$clientType/versions'
      path: '/versions'
      fullPath: '/workspaces/$subscriptionId/fraud-analysis/models/$labelSlug/$clientType/versions'
      preLoaderRoute: typeof AuthenticatedLayoutWorkspacesSubscriptionIdFraudAnalysisModelsLabelSlugClientTypeVersionsRouteImport
      parentRoute: typeof AuthenticatedLayoutWorkspacesSubscriptionIdFraudAnalysisModelsLabelSlugClientTypeRoute
    }
  }
}

interface AuthenticatedLayoutWorkspacesSubscriptionIdBotDetectionRouteChildren {
  AuthenticatedLayoutWorkspacesSubscriptionIdBotDetectionIndexRoute: typeof AuthenticatedLayoutWorkspacesSubscriptionIdBotDetectionIndexRoute
  AuthenticatedLayoutWorkspacesSubscriptionIdBotDetectionEventsEventIdRoute: typeof AuthenticatedLayoutWorkspacesSubscriptionIdBotDetectionEventsEventIdRoute
  AuthenticatedLayoutWorkspacesSubscriptionIdBotDetectionEventsIndexRoute: typeof AuthenticatedLayoutWorkspacesSubscriptionIdBotDetectionEventsIndexRoute
}

const AuthenticatedLayoutWorkspacesSubscriptionIdBotDetectionRouteChildren: AuthenticatedLayoutWorkspacesSubscriptionIdBotDetectionRouteChildren =
  {
    AuthenticatedLayoutWorkspacesSubscriptionIdBotDetectionIndexRoute:
      AuthenticatedLayoutWorkspacesSubscriptionIdBotDetectionIndexRoute,
    AuthenticatedLayoutWorkspacesSubscriptionIdBotDetectionEventsEventIdRoute:
      AuthenticatedLayoutWorkspacesSubscriptionIdBotDetectionEventsEventIdRoute,
    AuthenticatedLayoutWorkspacesSubscriptionIdBotDetectionEventsIndexRoute:
      AuthenticatedLayoutWorkspacesSubscriptionIdBotDetectionEventsIndexRoute,
  }

const AuthenticatedLayoutWorkspacesSubscriptionIdBotDetectionRouteWithChildren =
  AuthenticatedLayoutWorkspacesSubscriptionIdBotDetectionRoute._addFileChildren(
    AuthenticatedLayoutWorkspacesSubscriptionIdBotDetectionRouteChildren,
  )

interface AuthenticatedLayoutWorkspacesSubscriptionIdFraudAnalysisDatasetRouteChildren {
  AuthenticatedLayoutWorkspacesSubscriptionIdFraudAnalysisDatasetEventsRoute: typeof AuthenticatedLayoutWorkspacesSubscriptionIdFraudAnalysisDatasetEventsRoute
  AuthenticatedLayoutWorkspacesSubscriptionIdFraudAnalysisDatasetIndexRoute: typeof AuthenticatedLayoutWorkspacesSubscriptionIdFraudAnalysisDatasetIndexRoute
}

const AuthenticatedLayoutWorkspacesSubscriptionIdFraudAnalysisDatasetRouteChildren: AuthenticatedLayoutWorkspacesSubscriptionIdFraudAnalysisDatasetRouteChildren =
  {
    AuthenticatedLayoutWorkspacesSubscriptionIdFraudAnalysisDatasetEventsRoute:
      AuthenticatedLayoutWorkspacesSubscriptionIdFraudAnalysisDatasetEventsRoute,
    AuthenticatedLayoutWorkspacesSubscriptionIdFraudAnalysisDatasetIndexRoute:
      AuthenticatedLayoutWorkspacesSubscriptionIdFraudAnalysisDatasetIndexRoute,
  }

const AuthenticatedLayoutWorkspacesSubscriptionIdFraudAnalysisDatasetRouteWithChildren =
  AuthenticatedLayoutWorkspacesSubscriptionIdFraudAnalysisDatasetRoute._addFileChildren(
    AuthenticatedLayoutWorkspacesSubscriptionIdFraudAnalysisDatasetRouteChildren,
  )

interface AuthenticatedLayoutWorkspacesSubscriptionIdFraudAnalysisModelsLabelSlugClientTypeRouteChildren {
  AuthenticatedLayoutWorkspacesSubscriptionIdFraudAnalysisModelsLabelSlugClientTypeModelVersionIdRoute: typeof AuthenticatedLayoutWorkspacesSubscriptionIdFraudAnalysisModelsLabelSlugClientTypeModelVersionIdRoute
  AuthenticatedLayoutWorkspacesSubscriptionIdFraudAnalysisModelsLabelSlugClientTypeOverviewRoute: typeof AuthenticatedLayoutWorkspacesSubscriptionIdFraudAnalysisModelsLabelSlugClientTypeOverviewRoute
  AuthenticatedLayoutWorkspacesSubscriptionIdFraudAnalysisModelsLabelSlugClientTypeVersionsRoute: typeof AuthenticatedLayoutWorkspacesSubscriptionIdFraudAnalysisModelsLabelSlugClientTypeVersionsRoute
  AuthenticatedLayoutWorkspacesSubscriptionIdFraudAnalysisModelsLabelSlugClientTypeIndexRoute: typeof AuthenticatedLayoutWorkspacesSubscriptionIdFraudAnalysisModelsLabelSlugClientTypeIndexRoute
}

const AuthenticatedLayoutWorkspacesSubscriptionIdFraudAnalysisModelsLabelSlugClientTypeRouteChildren: AuthenticatedLayoutWorkspacesSubscriptionIdFraudAnalysisModelsLabelSlugClientTypeRouteChildren =
  {
    AuthenticatedLayoutWorkspacesSubscriptionIdFraudAnalysisModelsLabelSlugClientTypeModelVersionIdRoute:
      AuthenticatedLayoutWorkspacesSubscriptionIdFraudAnalysisModelsLabelSlugClientTypeModelVersionIdRoute,
    AuthenticatedLayoutWorkspacesSubscriptionIdFraudAnalysisModelsLabelSlugClientTypeOverviewRoute:
      AuthenticatedLayoutWorkspacesSubscriptionIdFraudAnalysisModelsLabelSlugClientTypeOverviewRoute,
    AuthenticatedLayoutWorkspacesSubscriptionIdFraudAnalysisModelsLabelSlugClientTypeVersionsRoute:
      AuthenticatedLayoutWorkspacesSubscriptionIdFraudAnalysisModelsLabelSlugClientTypeVersionsRoute,
    AuthenticatedLayoutWorkspacesSubscriptionIdFraudAnalysisModelsLabelSlugClientTypeIndexRoute:
      AuthenticatedLayoutWorkspacesSubscriptionIdFraudAnalysisModelsLabelSlugClientTypeIndexRoute,
  }

const AuthenticatedLayoutWorkspacesSubscriptionIdFraudAnalysisModelsLabelSlugClientTypeRouteWithChildren =
  AuthenticatedLayoutWorkspacesSubscriptionIdFraudAnalysisModelsLabelSlugClientTypeRoute._addFileChildren(
    AuthenticatedLayoutWorkspacesSubscriptionIdFraudAnalysisModelsLabelSlugClientTypeRouteChildren,
  )

interface AuthenticatedLayoutWorkspacesSubscriptionIdFraudAnalysisRouteChildren {
  AuthenticatedLayoutWorkspacesSubscriptionIdFraudAnalysisDatasetRoute: typeof AuthenticatedLayoutWorkspacesSubscriptionIdFraudAnalysisDatasetRouteWithChildren
  AuthenticatedLayoutWorkspacesSubscriptionIdFraudAnalysisUnlockRoute: typeof AuthenticatedLayoutWorkspacesSubscriptionIdFraudAnalysisUnlockRoute
  AuthenticatedLayoutWorkspacesSubscriptionIdFraudAnalysisUpgradeRoute: typeof AuthenticatedLayoutWorkspacesSubscriptionIdFraudAnalysisUpgradeRoute
  AuthenticatedLayoutWorkspacesSubscriptionIdFraudAnalysisUploadRoute: typeof AuthenticatedLayoutWorkspacesSubscriptionIdFraudAnalysisUploadRoute
  AuthenticatedLayoutWorkspacesSubscriptionIdFraudAnalysisIndexRoute: typeof AuthenticatedLayoutWorkspacesSubscriptionIdFraudAnalysisIndexRoute
  AuthenticatedLayoutWorkspacesSubscriptionIdFraudAnalysisModelsIndexRoute: typeof AuthenticatedLayoutWorkspacesSubscriptionIdFraudAnalysisModelsIndexRoute
  AuthenticatedLayoutWorkspacesSubscriptionIdFraudAnalysisModelsLabelSlugClientTypeRoute: typeof AuthenticatedLayoutWorkspacesSubscriptionIdFraudAnalysisModelsLabelSlugClientTypeRouteWithChildren
  AuthenticatedLayoutWorkspacesSubscriptionIdFraudAnalysisModelsLabelSlugIndexRoute: typeof AuthenticatedLayoutWorkspacesSubscriptionIdFraudAnalysisModelsLabelSlugIndexRoute
}

const AuthenticatedLayoutWorkspacesSubscriptionIdFraudAnalysisRouteChildren: AuthenticatedLayoutWorkspacesSubscriptionIdFraudAnalysisRouteChildren =
  {
    AuthenticatedLayoutWorkspacesSubscriptionIdFraudAnalysisDatasetRoute:
      AuthenticatedLayoutWorkspacesSubscriptionIdFraudAnalysisDatasetRouteWithChildren,
    AuthenticatedLayoutWorkspacesSubscriptionIdFraudAnalysisUnlockRoute:
      AuthenticatedLayoutWorkspacesSubscriptionIdFraudAnalysisUnlockRoute,
    AuthenticatedLayoutWorkspacesSubscriptionIdFraudAnalysisUpgradeRoute:
      AuthenticatedLayoutWorkspacesSubscriptionIdFraudAnalysisUpgradeRoute,
    AuthenticatedLayoutWorkspacesSubscriptionIdFraudAnalysisUploadRoute:
      AuthenticatedLayoutWorkspacesSubscriptionIdFraudAnalysisUploadRoute,
    AuthenticatedLayoutWorkspacesSubscriptionIdFraudAnalysisIndexRoute:
      AuthenticatedLayoutWorkspacesSubscriptionIdFraudAnalysisIndexRoute,
    AuthenticatedLayoutWorkspacesSubscriptionIdFraudAnalysisModelsIndexRoute:
      AuthenticatedLayoutWorkspacesSubscriptionIdFraudAnalysisModelsIndexRoute,
    AuthenticatedLayoutWorkspacesSubscriptionIdFraudAnalysisModelsLabelSlugClientTypeRoute:
      AuthenticatedLayoutWorkspacesSubscriptionIdFraudAnalysisModelsLabelSlugClientTypeRouteWithChildren,
    AuthenticatedLayoutWorkspacesSubscriptionIdFraudAnalysisModelsLabelSlugIndexRoute:
      AuthenticatedLayoutWorkspacesSubscriptionIdFraudAnalysisModelsLabelSlugIndexRoute,
  }

const AuthenticatedLayoutWorkspacesSubscriptionIdFraudAnalysisRouteWithChildren =
  AuthenticatedLayoutWorkspacesSubscriptionIdFraudAnalysisRoute._addFileChildren(
    AuthenticatedLayoutWorkspacesSubscriptionIdFraudAnalysisRouteChildren,
  )

interface AuthenticatedLayoutWorkspacesSubscriptionIdGetStartedRouteChildren {
  AuthenticatedLayoutWorkspacesSubscriptionIdGetStartedStepSlugRoute: typeof AuthenticatedLayoutWorkspacesSubscriptionIdGetStartedStepSlugRoute
  AuthenticatedLayoutWorkspacesSubscriptionIdGetStartedIndexRoute: typeof AuthenticatedLayoutWorkspacesSubscriptionIdGetStartedIndexRoute
}

const AuthenticatedLayoutWorkspacesSubscriptionIdGetStartedRouteChildren: AuthenticatedLayoutWorkspacesSubscriptionIdGetStartedRouteChildren =
  {
    AuthenticatedLayoutWorkspacesSubscriptionIdGetStartedStepSlugRoute:
      AuthenticatedLayoutWorkspacesSubscriptionIdGetStartedStepSlugRoute,
    AuthenticatedLayoutWorkspacesSubscriptionIdGetStartedIndexRoute:
      AuthenticatedLayoutWorkspacesSubscriptionIdGetStartedIndexRoute,
  }

const AuthenticatedLayoutWorkspacesSubscriptionIdGetStartedRouteWithChildren =
  AuthenticatedLayoutWorkspacesSubscriptionIdGetStartedRoute._addFileChildren(
    AuthenticatedLayoutWorkspacesSubscriptionIdGetStartedRouteChildren,
  )

interface AuthenticatedLayoutWorkspacesSubscriptionIdIntegrationsRouteChildren {
  AuthenticatedLayoutWorkspacesSubscriptionIdIntegrationsActiveRoute: typeof AuthenticatedLayoutWorkspacesSubscriptionIdIntegrationsActiveRoute
  AuthenticatedLayoutWorkspacesSubscriptionIdIntegrationsDirectoryRoute: typeof AuthenticatedLayoutWorkspacesSubscriptionIdIntegrationsDirectoryRoute
  AuthenticatedLayoutWorkspacesSubscriptionIdIntegrationsIndexRoute: typeof AuthenticatedLayoutWorkspacesSubscriptionIdIntegrationsIndexRoute
  AuthenticatedLayoutWorkspacesSubscriptionIdIntegrationsIntegrationTagEnvironmentIdRoute: typeof AuthenticatedLayoutWorkspacesSubscriptionIdIntegrationsIntegrationTagEnvironmentIdRoute
  AuthenticatedLayoutWorkspacesSubscriptionIdIntegrationsIntegrationTagHealthRoute: typeof AuthenticatedLayoutWorkspacesSubscriptionIdIntegrationsIntegrationTagHealthRoute
  AuthenticatedLayoutWorkspacesSubscriptionIdIntegrationsIntegrationTagIndexRoute: typeof AuthenticatedLayoutWorkspacesSubscriptionIdIntegrationsIntegrationTagIndexRoute
  AuthenticatedLayoutWorkspacesSubscriptionIdIntegrationsCloudflareFlowIndexRoute: typeof AuthenticatedLayoutWorkspacesSubscriptionIdIntegrationsCloudflareFlowIndexRoute
  AuthenticatedLayoutWorkspacesSubscriptionIdIntegrationsCloudflareFlowWorkersDeploymentIdRoute: typeof AuthenticatedLayoutWorkspacesSubscriptionIdIntegrationsCloudflareFlowWorkersDeploymentIdRoute
  AuthenticatedLayoutWorkspacesSubscriptionIdIntegrationsCloudflareFlowWorkersIndexRoute: typeof AuthenticatedLayoutWorkspacesSubscriptionIdIntegrationsCloudflareFlowWorkersIndexRoute
}

const AuthenticatedLayoutWorkspacesSubscriptionIdIntegrationsRouteChildren: AuthenticatedLayoutWorkspacesSubscriptionIdIntegrationsRouteChildren =
  {
    AuthenticatedLayoutWorkspacesSubscriptionIdIntegrationsActiveRoute:
      AuthenticatedLayoutWorkspacesSubscriptionIdIntegrationsActiveRoute,
    AuthenticatedLayoutWorkspacesSubscriptionIdIntegrationsDirectoryRoute:
      AuthenticatedLayoutWorkspacesSubscriptionIdIntegrationsDirectoryRoute,
    AuthenticatedLayoutWorkspacesSubscriptionIdIntegrationsIndexRoute:
      AuthenticatedLayoutWorkspacesSubscriptionIdIntegrationsIndexRoute,
    AuthenticatedLayoutWorkspacesSubscriptionIdIntegrationsIntegrationTagEnvironmentIdRoute:
      AuthenticatedLayoutWorkspacesSubscriptionIdIntegrationsIntegrationTagEnvironmentIdRoute,
    AuthenticatedLayoutWorkspacesSubscriptionIdIntegrationsIntegrationTagHealthRoute:
      AuthenticatedLayoutWorkspacesSubscriptionIdIntegrationsIntegrationTagHealthRoute,
    AuthenticatedLayoutWorkspacesSubscriptionIdIntegrationsIntegrationTagIndexRoute:
      AuthenticatedLayoutWorkspacesSubscriptionIdIntegrationsIntegrationTagIndexRoute,
    AuthenticatedLayoutWorkspacesSubscriptionIdIntegrationsCloudflareFlowIndexRoute:
      AuthenticatedLayoutWorkspacesSubscriptionIdIntegrationsCloudflareFlowIndexRoute,
    AuthenticatedLayoutWorkspacesSubscriptionIdIntegrationsCloudflareFlowWorkersDeploymentIdRoute:
      AuthenticatedLayoutWorkspacesSubscriptionIdIntegrationsCloudflareFlowWorkersDeploymentIdRoute,
    AuthenticatedLayoutWorkspacesSubscriptionIdIntegrationsCloudflareFlowWorkersIndexRoute:
      AuthenticatedLayoutWorkspacesSubscriptionIdIntegrationsCloudflareFlowWorkersIndexRoute,
  }

const AuthenticatedLayoutWorkspacesSubscriptionIdIntegrationsRouteWithChildren =
  AuthenticatedLayoutWorkspacesSubscriptionIdIntegrationsRoute._addFileChildren(
    AuthenticatedLayoutWorkspacesSubscriptionIdIntegrationsRouteChildren,
  )

interface AuthenticatedLayoutWorkspacesSubscriptionIdSuspectScoreRouteChildren {
  AuthenticatedLayoutWorkspacesSubscriptionIdSuspectScoreAnalysisRoute: typeof AuthenticatedLayoutWorkspacesSubscriptionIdSuspectScoreAnalysisRoute
  AuthenticatedLayoutWorkspacesSubscriptionIdSuspectScoreIndexRoute: typeof AuthenticatedLayoutWorkspacesSubscriptionIdSuspectScoreIndexRoute
}

const AuthenticatedLayoutWorkspacesSubscriptionIdSuspectScoreRouteChildren: AuthenticatedLayoutWorkspacesSubscriptionIdSuspectScoreRouteChildren =
  {
    AuthenticatedLayoutWorkspacesSubscriptionIdSuspectScoreAnalysisRoute:
      AuthenticatedLayoutWorkspacesSubscriptionIdSuspectScoreAnalysisRoute,
    AuthenticatedLayoutWorkspacesSubscriptionIdSuspectScoreIndexRoute:
      AuthenticatedLayoutWorkspacesSubscriptionIdSuspectScoreIndexRoute,
  }

const AuthenticatedLayoutWorkspacesSubscriptionIdSuspectScoreRouteWithChildren =
  AuthenticatedLayoutWorkspacesSubscriptionIdSuspectScoreRoute._addFileChildren(
    AuthenticatedLayoutWorkspacesSubscriptionIdSuspectScoreRouteChildren,
  )

interface AuthenticatedLayoutWorkspacesSubscriptionIdVisitorsVisitorIdRouteChildren {
  AuthenticatedLayoutWorkspacesSubscriptionIdVisitorsVisitorIdEventsRoute: typeof AuthenticatedLayoutWorkspacesSubscriptionIdVisitorsVisitorIdEventsRoute
  AuthenticatedLayoutWorkspacesSubscriptionIdVisitorsVisitorIdIpAddressesRoute: typeof AuthenticatedLayoutWorkspacesSubscriptionIdVisitorsVisitorIdIpAddressesRoute
  AuthenticatedLayoutWorkspacesSubscriptionIdVisitorsVisitorIdLocationHistoryRoute: typeof AuthenticatedLayoutWorkspacesSubscriptionIdVisitorsVisitorIdLocationHistoryRoute
  AuthenticatedLayoutWorkspacesSubscriptionIdVisitorsVisitorIdRelatedVisitorsRoute: typeof AuthenticatedLayoutWorkspacesSubscriptionIdVisitorsVisitorIdRelatedVisitorsRoute
  AuthenticatedLayoutWorkspacesSubscriptionIdVisitorsVisitorIdSmartSignalsRoute: typeof AuthenticatedLayoutWorkspacesSubscriptionIdVisitorsVisitorIdSmartSignalsRoute
  AuthenticatedLayoutWorkspacesSubscriptionIdVisitorsVisitorIdIndexRoute: typeof AuthenticatedLayoutWorkspacesSubscriptionIdVisitorsVisitorIdIndexRoute
}

const AuthenticatedLayoutWorkspacesSubscriptionIdVisitorsVisitorIdRouteChildren: AuthenticatedLayoutWorkspacesSubscriptionIdVisitorsVisitorIdRouteChildren =
  {
    AuthenticatedLayoutWorkspacesSubscriptionIdVisitorsVisitorIdEventsRoute:
      AuthenticatedLayoutWorkspacesSubscriptionIdVisitorsVisitorIdEventsRoute,
    AuthenticatedLayoutWorkspacesSubscriptionIdVisitorsVisitorIdIpAddressesRoute:
      AuthenticatedLayoutWorkspacesSubscriptionIdVisitorsVisitorIdIpAddressesRoute,
    AuthenticatedLayoutWorkspacesSubscriptionIdVisitorsVisitorIdLocationHistoryRoute:
      AuthenticatedLayoutWorkspacesSubscriptionIdVisitorsVisitorIdLocationHistoryRoute,
    AuthenticatedLayoutWorkspacesSubscriptionIdVisitorsVisitorIdRelatedVisitorsRoute:
      AuthenticatedLayoutWorkspacesSubscriptionIdVisitorsVisitorIdRelatedVisitorsRoute,
    AuthenticatedLayoutWorkspacesSubscriptionIdVisitorsVisitorIdSmartSignalsRoute:
      AuthenticatedLayoutWorkspacesSubscriptionIdVisitorsVisitorIdSmartSignalsRoute,
    AuthenticatedLayoutWorkspacesSubscriptionIdVisitorsVisitorIdIndexRoute:
      AuthenticatedLayoutWorkspacesSubscriptionIdVisitorsVisitorIdIndexRoute,
  }

const AuthenticatedLayoutWorkspacesSubscriptionIdVisitorsVisitorIdRouteWithChildren =
  AuthenticatedLayoutWorkspacesSubscriptionIdVisitorsVisitorIdRoute._addFileChildren(
    AuthenticatedLayoutWorkspacesSubscriptionIdVisitorsVisitorIdRouteChildren,
  )

interface AuthenticatedLayoutWorkspacesSubscriptionIdRouteChildren {
  AuthenticatedLayoutWorkspacesSubscriptionIdAlertsRoute: typeof AuthenticatedLayoutWorkspacesSubscriptionIdAlertsRoute
  AuthenticatedLayoutWorkspacesSubscriptionIdAuditLogRoute: typeof AuthenticatedLayoutWorkspacesSubscriptionIdAuditLogRoute
  AuthenticatedLayoutWorkspacesSubscriptionIdBillingRoute: typeof AuthenticatedLayoutWorkspacesSubscriptionIdBillingRoute
  AuthenticatedLayoutWorkspacesSubscriptionIdBotDetectionRoute: typeof AuthenticatedLayoutWorkspacesSubscriptionIdBotDetectionRouteWithChildren
  AuthenticatedLayoutWorkspacesSubscriptionIdBotdRoute: typeof AuthenticatedLayoutWorkspacesSubscriptionIdBotdRoute
  AuthenticatedLayoutWorkspacesSubscriptionIdEnvironmentsRoute: typeof AuthenticatedLayoutWorkspacesSubscriptionIdEnvironmentsRoute
  AuthenticatedLayoutWorkspacesSubscriptionIdFraudAnalysisRoute: typeof AuthenticatedLayoutWorkspacesSubscriptionIdFraudAnalysisRouteWithChildren
  AuthenticatedLayoutWorkspacesSubscriptionIdGeneralRoute: typeof AuthenticatedLayoutWorkspacesSubscriptionIdGeneralRoute
  AuthenticatedLayoutWorkspacesSubscriptionIdGetStartedRoute: typeof AuthenticatedLayoutWorkspacesSubscriptionIdGetStartedRouteWithChildren
  AuthenticatedLayoutWorkspacesSubscriptionIdIntegrationsRoute: typeof AuthenticatedLayoutWorkspacesSubscriptionIdIntegrationsRouteWithChildren
  AuthenticatedLayoutWorkspacesSubscriptionIdMcpRoute: typeof AuthenticatedLayoutWorkspacesSubscriptionIdMcpRoute
  AuthenticatedLayoutWorkspacesSubscriptionIdOverviewRoute: typeof AuthenticatedLayoutWorkspacesSubscriptionIdOverviewRoute
  AuthenticatedLayoutWorkspacesSubscriptionIdPlansRoute: typeof AuthenticatedLayoutWorkspacesSubscriptionIdPlansRoute
  AuthenticatedLayoutWorkspacesSubscriptionIdSmartSignalsRoute: typeof AuthenticatedLayoutWorkspacesSubscriptionIdSmartSignalsRoute
  AuthenticatedLayoutWorkspacesSubscriptionIdSubmitBotRoute: typeof AuthenticatedLayoutWorkspacesSubscriptionIdSubmitBotRoute
  AuthenticatedLayoutWorkspacesSubscriptionIdSuspectScoreRoute: typeof AuthenticatedLayoutWorkspacesSubscriptionIdSuspectScoreRouteWithChildren
  AuthenticatedLayoutWorkspacesSubscriptionIdTrafficRulesRoute: typeof AuthenticatedLayoutWorkspacesSubscriptionIdTrafficRulesRoute
  AuthenticatedLayoutWorkspacesSubscriptionIdIndexRoute: typeof AuthenticatedLayoutWorkspacesSubscriptionIdIndexRoute
  AuthenticatedLayoutWorkspacesSubscriptionIdPlanCheckoutReturnRoute: typeof AuthenticatedLayoutWorkspacesSubscriptionIdPlanCheckoutReturnRoute
  AuthenticatedLayoutWorkspacesSubscriptionIdPlanUnpaidInvoicesRoute: typeof AuthenticatedLayoutWorkspacesSubscriptionIdPlanUnpaidInvoicesRoute
  AuthenticatedLayoutWorkspacesSubscriptionIdSubdomainsCertificateIdRoute: typeof AuthenticatedLayoutWorkspacesSubscriptionIdSubdomainsCertificateIdRoute
  AuthenticatedLayoutWorkspacesSubscriptionIdVisitorsVisitorIdRoute: typeof AuthenticatedLayoutWorkspacesSubscriptionIdVisitorsVisitorIdRouteWithChildren
  AuthenticatedLayoutWorkspacesSubscriptionIdVisitorsAvatarsRoute: typeof AuthenticatedLayoutWorkspacesSubscriptionIdVisitorsAvatarsRoute
  AuthenticatedLayoutWorkspacesSubscriptionIdApiKeysIndexRoute: typeof AuthenticatedLayoutWorkspacesSubscriptionIdApiKeysIndexRoute
  AuthenticatedLayoutWorkspacesSubscriptionIdEventsIndexRoute: typeof AuthenticatedLayoutWorkspacesSubscriptionIdEventsIndexRoute
  AuthenticatedLayoutWorkspacesSubscriptionIdHealthIndexRoute: typeof AuthenticatedLayoutWorkspacesSubscriptionIdHealthIndexRoute
  AuthenticatedLayoutWorkspacesSubscriptionIdPlanIndexRoute: typeof AuthenticatedLayoutWorkspacesSubscriptionIdPlanIndexRoute
  AuthenticatedLayoutWorkspacesSubscriptionIdRulesetsIndexRoute: typeof AuthenticatedLayoutWorkspacesSubscriptionIdRulesetsIndexRoute
  AuthenticatedLayoutWorkspacesSubscriptionIdSubdomainsIndexRoute: typeof AuthenticatedLayoutWorkspacesSubscriptionIdSubdomainsIndexRoute
  AuthenticatedLayoutWorkspacesSubscriptionIdVisitorsIndexRoute: typeof AuthenticatedLayoutWorkspacesSubscriptionIdVisitorsIndexRoute
  AuthenticatedLayoutWorkspacesSubscriptionIdWebhooksIndexRoute: typeof AuthenticatedLayoutWorkspacesSubscriptionIdWebhooksIndexRoute
  AuthenticatedLayoutWorkspacesSubscriptionIdEventsRequestIdVisitorHistoryRoute: typeof AuthenticatedLayoutWorkspacesSubscriptionIdEventsRequestIdVisitorHistoryRoute
  AuthenticatedLayoutWorkspacesSubscriptionIdInvoicesInvoiceIdForgivenessRequestRoute: typeof AuthenticatedLayoutWorkspacesSubscriptionIdInvoicesInvoiceIdForgivenessRequestRoute
  AuthenticatedLayoutWorkspacesSubscriptionIdWebhooksWebhookIdEventsRoute: typeof AuthenticatedLayoutWorkspacesSubscriptionIdWebhooksWebhookIdEventsRoute
  AuthenticatedLayoutWorkspacesSubscriptionIdWebhooksWebhookIdVerifyRoute: typeof AuthenticatedLayoutWorkspacesSubscriptionIdWebhooksWebhookIdVerifyRoute
  AuthenticatedLayoutWorkspacesSubscriptionIdApiKeysTokenIdIndexRoute: typeof AuthenticatedLayoutWorkspacesSubscriptionIdApiKeysTokenIdIndexRoute
  AuthenticatedLayoutWorkspacesSubscriptionIdEventsRequestIdIndexRoute: typeof AuthenticatedLayoutWorkspacesSubscriptionIdEventsRequestIdIndexRoute
  AuthenticatedLayoutWorkspacesSubscriptionIdInvoicesInvoiceIdIndexRoute: typeof AuthenticatedLayoutWorkspacesSubscriptionIdInvoicesInvoiceIdIndexRoute
}

const AuthenticatedLayoutWorkspacesSubscriptionIdRouteChildren: AuthenticatedLayoutWorkspacesSubscriptionIdRouteChildren =
  {
    AuthenticatedLayoutWorkspacesSubscriptionIdAlertsRoute:
      AuthenticatedLayoutWorkspacesSubscriptionIdAlertsRoute,
    AuthenticatedLayoutWorkspacesSubscriptionIdAuditLogRoute:
      AuthenticatedLayoutWorkspacesSubscriptionIdAuditLogRoute,
    AuthenticatedLayoutWorkspacesSubscriptionIdBillingRoute:
      AuthenticatedLayoutWorkspacesSubscriptionIdBillingRoute,
    AuthenticatedLayoutWorkspacesSubscriptionIdBotDetectionRoute:
      AuthenticatedLayoutWorkspacesSubscriptionIdBotDetectionRouteWithChildren,
    AuthenticatedLayoutWorkspacesSubscriptionIdBotdRoute:
      AuthenticatedLayoutWorkspacesSubscriptionIdBotdRoute,
    AuthenticatedLayoutWorkspacesSubscriptionIdEnvironmentsRoute:
      AuthenticatedLayoutWorkspacesSubscriptionIdEnvironmentsRoute,
    AuthenticatedLayoutWorkspacesSubscriptionIdFraudAnalysisRoute:
      AuthenticatedLayoutWorkspacesSubscriptionIdFraudAnalysisRouteWithChildren,
    AuthenticatedLayoutWorkspacesSubscriptionIdGeneralRoute:
      AuthenticatedLayoutWorkspacesSubscriptionIdGeneralRoute,
    AuthenticatedLayoutWorkspacesSubscriptionIdGetStartedRoute:
      AuthenticatedLayoutWorkspacesSubscriptionIdGetStartedRouteWithChildren,
    AuthenticatedLayoutWorkspacesSubscriptionIdIntegrationsRoute:
      AuthenticatedLayoutWorkspacesSubscriptionIdIntegrationsRouteWithChildren,
    AuthenticatedLayoutWorkspacesSubscriptionIdMcpRoute:
      AuthenticatedLayoutWorkspacesSubscriptionIdMcpRoute,
    AuthenticatedLayoutWorkspacesSubscriptionIdOverviewRoute:
      AuthenticatedLayoutWorkspacesSubscriptionIdOverviewRoute,
    AuthenticatedLayoutWorkspacesSubscriptionIdPlansRoute:
      AuthenticatedLayoutWorkspacesSubscriptionIdPlansRoute,
    AuthenticatedLayoutWorkspacesSubscriptionIdSmartSignalsRoute:
      AuthenticatedLayoutWorkspacesSubscriptionIdSmartSignalsRoute,
    AuthenticatedLayoutWorkspacesSubscriptionIdSubmitBotRoute:
      AuthenticatedLayoutWorkspacesSubscriptionIdSubmitBotRoute,
    AuthenticatedLayoutWorkspacesSubscriptionIdSuspectScoreRoute:
      AuthenticatedLayoutWorkspacesSubscriptionIdSuspectScoreRouteWithChildren,
    AuthenticatedLayoutWorkspacesSubscriptionIdTrafficRulesRoute:
      AuthenticatedLayoutWorkspacesSubscriptionIdTrafficRulesRoute,
    AuthenticatedLayoutWorkspacesSubscriptionIdIndexRoute:
      AuthenticatedLayoutWorkspacesSubscriptionIdIndexRoute,
    AuthenticatedLayoutWorkspacesSubscriptionIdPlanCheckoutReturnRoute:
      AuthenticatedLayoutWorkspacesSubscriptionIdPlanCheckoutReturnRoute,
    AuthenticatedLayoutWorkspacesSubscriptionIdPlanUnpaidInvoicesRoute:
      AuthenticatedLayoutWorkspacesSubscriptionIdPlanUnpaidInvoicesRoute,
    AuthenticatedLayoutWorkspacesSubscriptionIdSubdomainsCertificateIdRoute:
      AuthenticatedLayoutWorkspacesSubscriptionIdSubdomainsCertificateIdRoute,
    AuthenticatedLayoutWorkspacesSubscriptionIdVisitorsVisitorIdRoute:
      AuthenticatedLayoutWorkspacesSubscriptionIdVisitorsVisitorIdRouteWithChildren,
    AuthenticatedLayoutWorkspacesSubscriptionIdVisitorsAvatarsRoute:
      AuthenticatedLayoutWorkspacesSubscriptionIdVisitorsAvatarsRoute,
    AuthenticatedLayoutWorkspacesSubscriptionIdApiKeysIndexRoute:
      AuthenticatedLayoutWorkspacesSubscriptionIdApiKeysIndexRoute,
    AuthenticatedLayoutWorkspacesSubscriptionIdEventsIndexRoute:
      AuthenticatedLayoutWorkspacesSubscriptionIdEventsIndexRoute,
    AuthenticatedLayoutWorkspacesSubscriptionIdHealthIndexRoute:
      AuthenticatedLayoutWorkspacesSubscriptionIdHealthIndexRoute,
    AuthenticatedLayoutWorkspacesSubscriptionIdPlanIndexRoute:
      AuthenticatedLayoutWorkspacesSubscriptionIdPlanIndexRoute,
    AuthenticatedLayoutWorkspacesSubscriptionIdRulesetsIndexRoute:
      AuthenticatedLayoutWorkspacesSubscriptionIdRulesetsIndexRoute,
    AuthenticatedLayoutWorkspacesSubscriptionIdSubdomainsIndexRoute:
      AuthenticatedLayoutWorkspacesSubscriptionIdSubdomainsIndexRoute,
    AuthenticatedLayoutWorkspacesSubscriptionIdVisitorsIndexRoute:
      AuthenticatedLayoutWorkspacesSubscriptionIdVisitorsIndexRoute,
    AuthenticatedLayoutWorkspacesSubscriptionIdWebhooksIndexRoute:
      AuthenticatedLayoutWorkspacesSubscriptionIdWebhooksIndexRoute,
    AuthenticatedLayoutWorkspacesSubscriptionIdEventsRequestIdVisitorHistoryRoute:
      AuthenticatedLayoutWorkspacesSubscriptionIdEventsRequestIdVisitorHistoryRoute,
    AuthenticatedLayoutWorkspacesSubscriptionIdInvoicesInvoiceIdForgivenessRequestRoute:
      AuthenticatedLayoutWorkspacesSubscriptionIdInvoicesInvoiceIdForgivenessRequestRoute,
    AuthenticatedLayoutWorkspacesSubscriptionIdWebhooksWebhookIdEventsRoute:
      AuthenticatedLayoutWorkspacesSubscriptionIdWebhooksWebhookIdEventsRoute,
    AuthenticatedLayoutWorkspacesSubscriptionIdWebhooksWebhookIdVerifyRoute:
      AuthenticatedLayoutWorkspacesSubscriptionIdWebhooksWebhookIdVerifyRoute,
    AuthenticatedLayoutWorkspacesSubscriptionIdApiKeysTokenIdIndexRoute:
      AuthenticatedLayoutWorkspacesSubscriptionIdApiKeysTokenIdIndexRoute,
    AuthenticatedLayoutWorkspacesSubscriptionIdEventsRequestIdIndexRoute:
      AuthenticatedLayoutWorkspacesSubscriptionIdEventsRequestIdIndexRoute,
    AuthenticatedLayoutWorkspacesSubscriptionIdInvoicesInvoiceIdIndexRoute:
      AuthenticatedLayoutWorkspacesSubscriptionIdInvoicesInvoiceIdIndexRoute,
  }

const AuthenticatedLayoutWorkspacesSubscriptionIdRouteWithChildren =
  AuthenticatedLayoutWorkspacesSubscriptionIdRoute._addFileChildren(
    AuthenticatedLayoutWorkspacesSubscriptionIdRouteChildren,
  )

interface AuthenticatedLayoutdeprecatedWorkspacesSubscriptionIdVisitsRouteChildren {
  AuthenticatedLayoutdeprecatedWorkspacesSubscriptionIdVisitsRequestIdRoute: typeof AuthenticatedLayoutdeprecatedWorkspacesSubscriptionIdVisitsRequestIdRoute
}

const AuthenticatedLayoutdeprecatedWorkspacesSubscriptionIdVisitsRouteChildren: AuthenticatedLayoutdeprecatedWorkspacesSubscriptionIdVisitsRouteChildren =
  {
    AuthenticatedLayoutdeprecatedWorkspacesSubscriptionIdVisitsRequestIdRoute:
      AuthenticatedLayoutdeprecatedWorkspacesSubscriptionIdVisitsRequestIdRoute,
  }

const AuthenticatedLayoutdeprecatedWorkspacesSubscriptionIdVisitsRouteWithChildren =
  AuthenticatedLayoutdeprecatedWorkspacesSubscriptionIdVisitsRoute._addFileChildren(
    AuthenticatedLayoutdeprecatedWorkspacesSubscriptionIdVisitsRouteChildren,
  )

interface AuthenticatedLayoutRouteChildren {
  AuthenticatedLayoutSplatRoute: typeof AuthenticatedLayoutSplatRoute
  AuthenticatedLayoutProfileNotificationsRoute: typeof AuthenticatedLayoutProfileNotificationsRoute
  AuthenticatedLayoutProfileSettingsRoute: typeof AuthenticatedLayoutProfileSettingsRoute
  AuthenticatedLayoutSettingsUsersRoute: typeof AuthenticatedLayoutSettingsUsersRoute
  AuthenticatedLayoutSettingsWorkspacesRoute: typeof AuthenticatedLayoutSettingsWorkspacesRoute
  AuthenticatedLayoutTemplatesSplatRoute: typeof AuthenticatedLayoutTemplatesSplatRoute
  AuthenticatedLayoutWorkspacesSubscriptionIdRoute: typeof AuthenticatedLayoutWorkspacesSubscriptionIdRouteWithChildren
  AuthenticatedLayoutdeprecatedSubscriptionsSplatRoute: typeof AuthenticatedLayoutdeprecatedSubscriptionsSplatRoute
  AuthenticatedLayoutSettingsBillingMigrateRoute: typeof AuthenticatedLayoutSettingsBillingMigrateRoute
  AuthenticatedLayoutSettingsBillingIndexRoute: typeof AuthenticatedLayoutSettingsBillingIndexRoute
  AuthenticatedLayoutdeprecatedWorkspacesSubscriptionIdVisitsRoute: typeof AuthenticatedLayoutdeprecatedWorkspacesSubscriptionIdVisitsRouteWithChildren
}

const AuthenticatedLayoutRouteChildren: AuthenticatedLayoutRouteChildren = {
  AuthenticatedLayoutSplatRoute: AuthenticatedLayoutSplatRoute,
  AuthenticatedLayoutProfileNotificationsRoute:
    AuthenticatedLayoutProfileNotificationsRoute,
  AuthenticatedLayoutProfileSettingsRoute:
    AuthenticatedLayoutProfileSettingsRoute,
  AuthenticatedLayoutSettingsUsersRoute: AuthenticatedLayoutSettingsUsersRoute,
  AuthenticatedLayoutSettingsWorkspacesRoute:
    AuthenticatedLayoutSettingsWorkspacesRoute,
  AuthenticatedLayoutTemplatesSplatRoute:
    AuthenticatedLayoutTemplatesSplatRoute,
  AuthenticatedLayoutWorkspacesSubscriptionIdRoute:
    AuthenticatedLayoutWorkspacesSubscriptionIdRouteWithChildren,
  AuthenticatedLayoutdeprecatedSubscriptionsSplatRoute:
    AuthenticatedLayoutdeprecatedSubscriptionsSplatRoute,
  AuthenticatedLayoutSettingsBillingMigrateRoute:
    AuthenticatedLayoutSettingsBillingMigrateRoute,
  AuthenticatedLayoutSettingsBillingIndexRoute:
    AuthenticatedLayoutSettingsBillingIndexRoute,
  AuthenticatedLayoutdeprecatedWorkspacesSubscriptionIdVisitsRoute:
    AuthenticatedLayoutdeprecatedWorkspacesSubscriptionIdVisitsRouteWithChildren,
}

const AuthenticatedLayoutRouteWithChildren =
  AuthenticatedLayoutRoute._addFileChildren(AuthenticatedLayoutRouteChildren)

interface AuthenticatedWorkspacesSubscriptionIdRulesetsRulesetIdRouteChildren {
  AuthenticatedWorkspacesSubscriptionIdRulesetsRulesetIdIndexLazyRoute: typeof AuthenticatedWorkspacesSubscriptionIdRulesetsRulesetIdIndexLazyRoute
}

const AuthenticatedWorkspacesSubscriptionIdRulesetsRulesetIdRouteChildren: AuthenticatedWorkspacesSubscriptionIdRulesetsRulesetIdRouteChildren =
  {
    AuthenticatedWorkspacesSubscriptionIdRulesetsRulesetIdIndexLazyRoute:
      AuthenticatedWorkspacesSubscriptionIdRulesetsRulesetIdIndexLazyRoute,
  }

const AuthenticatedWorkspacesSubscriptionIdRulesetsRulesetIdRouteWithChildren =
  AuthenticatedWorkspacesSubscriptionIdRulesetsRulesetIdRoute._addFileChildren(
    AuthenticatedWorkspacesSubscriptionIdRulesetsRulesetIdRouteChildren,
  )

interface AuthenticatedRouteChildren {
  AuthenticatedLayoutRoute: typeof AuthenticatedLayoutRouteWithChildren
  AuthenticatedConsentRoute: typeof AuthenticatedConsentRoute
  AuthenticatedMcpAuthRoute: typeof AuthenticatedMcpAuthRoute
  AuthenticatedMintlify_loginRoute: typeof AuthenticatedMintlify_loginRoute
  AuthenticatedOnboardingRoute: typeof AuthenticatedOnboardingRoute
  AuthenticatedReadme_loginRoute: typeof AuthenticatedReadme_loginRoute
  AuthenticatedIndexRoute: typeof AuthenticatedIndexRoute
  AuthenticatedWorkspacesStartRoute: typeof AuthenticatedWorkspacesStartRoute
  AuthenticatedWorkspacesSubscriptionIdRulesetsRulesetIdRoute: typeof AuthenticatedWorkspacesSubscriptionIdRulesetsRulesetIdRouteWithChildren
  AuthenticatedWorkspacesSubscriptionIdTemplatesSplatRoute: typeof AuthenticatedWorkspacesSubscriptionIdTemplatesSplatRoute
  AuthenticatedWorkspacesSubscriptionIdPlanCancelConfirmRoute: typeof AuthenticatedWorkspacesSubscriptionIdPlanCancelConfirmRoute
  AuthenticatedWorkspacesSubscriptionIdPlanDowngradeConfirmRoute: typeof AuthenticatedWorkspacesSubscriptionIdPlanDowngradeConfirmRoute
  AuthenticatedWorkspacesSubscriptionIdRulesetsTemplatesTemplateSlugRoute: typeof AuthenticatedWorkspacesSubscriptionIdRulesetsTemplatesTemplateSlugRoute
  AuthenticatedWorkspacesSubscriptionIdPlanCancelIndexRoute: typeof AuthenticatedWorkspacesSubscriptionIdPlanCancelIndexRoute
  AuthenticatedWorkspacesSubscriptionIdPlanDowngradeIndexRoute: typeof AuthenticatedWorkspacesSubscriptionIdPlanDowngradeIndexRoute
}

const AuthenticatedRouteChildren: AuthenticatedRouteChildren = {
  AuthenticatedLayoutRoute: AuthenticatedLayoutRouteWithChildren,
  AuthenticatedConsentRoute: AuthenticatedConsentRoute,
  AuthenticatedMcpAuthRoute: AuthenticatedMcpAuthRoute,
  AuthenticatedMintlify_loginRoute: AuthenticatedMintlify_loginRoute,
  AuthenticatedOnboardingRoute: AuthenticatedOnboardingRoute,
  AuthenticatedReadme_loginRoute: AuthenticatedReadme_loginRoute,
  AuthenticatedIndexRoute: AuthenticatedIndexRoute,
  AuthenticatedWorkspacesStartRoute: AuthenticatedWorkspacesStartRoute,
  AuthenticatedWorkspacesSubscriptionIdRulesetsRulesetIdRoute:
    AuthenticatedWorkspacesSubscriptionIdRulesetsRulesetIdRouteWithChildren,
  AuthenticatedWorkspacesSubscriptionIdTemplatesSplatRoute:
    AuthenticatedWorkspacesSubscriptionIdTemplatesSplatRoute,
  AuthenticatedWorkspacesSubscriptionIdPlanCancelConfirmRoute:
    AuthenticatedWorkspacesSubscriptionIdPlanCancelConfirmRoute,
  AuthenticatedWorkspacesSubscriptionIdPlanDowngradeConfirmRoute:
    AuthenticatedWorkspacesSubscriptionIdPlanDowngradeConfirmRoute,
  AuthenticatedWorkspacesSubscriptionIdRulesetsTemplatesTemplateSlugRoute:
    AuthenticatedWorkspacesSubscriptionIdRulesetsTemplatesTemplateSlugRoute,
  AuthenticatedWorkspacesSubscriptionIdPlanCancelIndexRoute:
    AuthenticatedWorkspacesSubscriptionIdPlanCancelIndexRoute,
  AuthenticatedWorkspacesSubscriptionIdPlanDowngradeIndexRoute:
    AuthenticatedWorkspacesSubscriptionIdPlanDowngradeIndexRoute,
}

const AuthenticatedRouteWithChildren = AuthenticatedRoute._addFileChildren(
  AuthenticatedRouteChildren,
)

interface UnauthenticatedRouteChildren {
  UnauthenticatedLoginRoute: typeof UnauthenticatedLoginRoute
  UnauthenticatedInvitation_confirmationIdRoute: typeof UnauthenticatedInvitation_confirmationIdRoute
  UnauthenticatedResetIdRoute: typeof UnauthenticatedResetIdRoute
  UnauthenticatedSsoCallbackRoute: typeof UnauthenticatedSsoCallbackRoute
  UnauthenticatedResetIndexRoute: typeof UnauthenticatedResetIndexRoute
  UnauthenticatedReset_confirmIndexRoute: typeof UnauthenticatedReset_confirmIndexRoute
  UnauthenticatedSignupIndexRoute: typeof UnauthenticatedSignupIndexRoute
}

const UnauthenticatedRouteChildren: UnauthenticatedRouteChildren = {
  UnauthenticatedLoginRoute: UnauthenticatedLoginRoute,
  UnauthenticatedInvitation_confirmationIdRoute:
    UnauthenticatedInvitation_confirmationIdRoute,
  UnauthenticatedResetIdRoute: UnauthenticatedResetIdRoute,
  UnauthenticatedSsoCallbackRoute: UnauthenticatedSsoCallbackRoute,
  UnauthenticatedResetIndexRoute: UnauthenticatedResetIndexRoute,
  UnauthenticatedReset_confirmIndexRoute:
    UnauthenticatedReset_confirmIndexRoute,
  UnauthenticatedSignupIndexRoute: UnauthenticatedSignupIndexRoute,
}

const UnauthenticatedRouteWithChildren = UnauthenticatedRoute._addFileChildren(
  UnauthenticatedRouteChildren,
)

interface UnsubscribeRouteChildren {
  UnsubscribeFeedbackRoute: typeof UnsubscribeFeedbackRoute
  UnsubscribeIndexRoute: typeof UnsubscribeIndexRoute
}

const UnsubscribeRouteChildren: UnsubscribeRouteChildren = {
  UnsubscribeFeedbackRoute: UnsubscribeFeedbackRoute,
  UnsubscribeIndexRoute: UnsubscribeIndexRoute,
}

const UnsubscribeRouteWithChildren = UnsubscribeRoute._addFileChildren(
  UnsubscribeRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  AuthenticatedRoute: AuthenticatedRouteWithChildren,
  UnauthenticatedRoute: UnauthenticatedRouteWithChildren,
  ImpersonateRoute: ImpersonateRoute,
  UnsubscribeRoute: UnsubscribeRouteWithChildren,
  ContactSalesEnterpriseRoute: ContactSalesEnterpriseRoute,
  NewsletterUnsubscribeRoute: NewsletterUnsubscribeRoute,
  SignupConfirmSignupIntentRoute: SignupConfirmSignupIntentRoute,
  SignupConfirmIndexRoute: SignupConfirmIndexRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
